const tours = [
  {
    id: 1,
    price: "189",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "522"
      },
      {
        id: 2,
        persons: "2",
        price: "604"
      },
      {
        id: 3,
        persons: "3",
        price: "686"
      },
      {
        id: 4,
        persons: "4",
        price: "756"
      },

    ],
    srcitinerary: "img/eco-tour-2day/itinerary/eng",
    maxamount: "100+",
    category: "Aral",
    category1: "Top",
    tourlang: "eng",
    name: "Eco Tour to the Aral Sea",
    dayDuration: "(2 days and 1 night)",
    aboutTour: "Discover Karakalpakstan: endless canyons, the legendary Aral Sea and fortresses of ancient civilizations",
    unitDay: "2",
    unitNight: "1",
    country: "8",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Over 700 km",
    mapstext2: "Tour season: Year-round",
    description: "Nukus – Muynak – Aral Sea – Nomads’ Cemetery – Kurgancha Kala – Kubla area – Sudochye Lake – Kungrad – Mizdakhan Necropolis – Gaur Kala – Nukus",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: 4×4 off-road vehicle;"
      },
      {
        class: "fa fa-cutlery",
        text: "Meals: 4 times;"
      },

      {
        class: "fa fa-bed",
        text: "Accommodation: 1 night in a yurt camp;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance fees;"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-globe",
        text: "Tips / gratuities"
      },
      {
        class: "fa fa-language",
        text: "Guide services"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional guide",
        price: "145"
      },
      {
        id: 3,
        name: "Barsa Kelmes",
        price: "50"
      },
      {
        id: 4,
        name: "Nukus-Khiva Transfer",
        price: "75"
      }
    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "The adventure begins in Nukus",
            timeDistination: "Welcome to Karakalpakstan — a land where the steppe stretches beyond the horizon, where every hill whispers stories of the past, and where silence speaks louder than words. You have arrived in the very heart of Central Asia — a place where nature and culture have intertwined over centuries, creating a world unlike any other.",
            timeVideoSrc: "https://www.youtube.com/embed/Io1Cj4c8mTE?si=JgvUoSawUWtlTiUK",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-2day/daysimg/1-08-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Muynak — the former port city of the Aral Sea",
            timeDistination: "You will visit Muynak, a city that was once a major port of the Aral Sea and a center of fishing. You will see the Muynak Ship Cemetery and visit the Muynak State Museum of Local History, where exhibitions and a documentary film reveal the dramatic history of the Aral Sea and the life of the city.",
            timeVideoSrc: "https://www.youtube.com/embed/HRM2Ek40taw?si=3ZkV3OKx8ZXka-BS",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-2day/daysimg/1-11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Lunch",
            timeDistination: "Lunch at a cozy guest house, where you will be served hot dishes of traditional local cuisine.",
            timeVideoSrc: "",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-2day/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:00",
            timeName: "Where the sea once was: journey to the Ustyurt canyons",
            timeDistination: "The route follows the dry seabed of the former Aral Sea, revealing harsh yet striking landscapes of the deserted seashore. Several stops are planned for photography, allowing you to capture the unique scenery and the majestic canyons of the Ustyurt Plateau. Along the way, you will learn about the ancient history of the region and make a short stop at the Nomads’ Cemetery — a silent witness to lives once lived on these lands.",
            timeVideoSrc: "https://youtu.be/ZyK0XZqPNSA",
            location: "Ustyurt canyons",
            locationSrc: "https://maps.app.goo.gl/edkUA1k6bRFLELzN6",
            img: "img/eco-tour-2day/daysimg/1-14-00"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Nomads’ Cemetery on the Ustyurt Plateau",
            timeDistination: "You will visit the Nomads’ Cemetery on the Ustyurt Plateau — a brief stop amid a stark and expressive landscape. This place preserves traces of people who migrated across these lands for centuries.",
            timeVideoSrc: "https://youtube.com/shorts/tg3_p0wkTmM?feature=share",
            location: "Ustyurt Plateau",
            locationSrc: "https://maps.app.goo.gl/bMriUXdZQD85aNXv5",
            img: "img/eco-tour-2day/daysimg/1-16-00"
          },
          {
            timeid: "6",
            time: "17:00",
            timeName: "Meeting the Aral Sea",
            timeDistination: "You will reach the shores of the Aral Sea, where, depending on the season, you can swim, walk along the water, and collect seashells, enjoying the silence and unique atmosphere of this place.",
            timeVideoSrc: "https://youtu.be/EEvEC6w_OR0",
            location: "Aral Sea",
            locationSrc: "https://maps.app.goo.gl/8UMc14PqDxubXGah7",
            img: "img/eco-tour-2day/daysimg/1-17-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Overnight at the yurt camp by the Aral Sea",
            timeDistination: "The day ends at a cozy yurt camp on the shores of the Aral Sea. You will spend the night in a comfortable traditional yurt, immersed in a unique atmosphere that offers a deep sense of peace and solitude. The camp is equipped with showers with fresh water and restroom facilities for guests’ convenience.",
            timeVideoSrc: "https://youtu.be/NO8NKm8yyKY",
            location: "Yurt camp",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-2day/daysimg/1-18-00"
          },
        ],
      },
      {
        id: "day2",
        nameDay: "Day 2",
        times: [
          {
            timeid: "1",
            time: "05:00",
            timeName: "Sunrise over the Aral Sea",
            timeDistination: "The second day begins with sunrise over the sea — a quiet and truly magical moment that sets the mood for the entire morning. Afterwards, you will enjoy a tasty breakfast, providing energy for the day ahead.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Aral Sea",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-2day/daysimg/2-05-00"
          },
          {
            timeid: "2",
            time: "08:00",
            timeName: "Kurgancha Kala — a settlement of the Great Silk Road",
            timeDistination: "The return journey follows historic settlements from a new perspective. The program includes a visit to Kurgancha Kala (12th–14th centuries), a fortified trading settlement located on one of the routes of the Great Silk Road.",
            timeVideoSrc: "https://youtu.be/o2_CLTVkQTI",
            location: "Kurgancha Kala",
            locationSrc: "https://maps.app.goo.gl/Z2ZShskvfvphyFLJ6",
            img: "img/eco-tour-2day/daysimg/2-08-00"
          },
          {
            timeid: "3",
            time: "10:30",
            timeName: "Kubla-Ustyurt — the most remote settlement in the region",
            timeDistination: "The next stop is Kubla-Ustyurt, one of the most remote settlements in the region, built during the Soviet period. Here, you will make a stop at an old airstrip and see interesting structures from that era set against a calm rural landscape.",
            timeVideoSrc: "https://youtube.com/shorts/oiGYsE-FSlg?feature=share",
            location: "Kubla-Ustyurt",
            locationSrc: "https://maps.app.goo.gl/Z2ZShskvfvphyFLJ6",
            img: "img/eco-tour-2day/daysimg/2-10-30"
          },
          {
            timeid: "4",
            time: "12:00",
            timeName: "Sudochye Lake and the abandoned village of Urga",
            timeDistination: "You will visit an old lighthouse that once guided the way to the village of Urga. Then the route descends steeply to the abandoned fishing village of Urga, located on the shores of Sudochye Lake. This lake is an important stopover for migratory birds — here you may see pink flamingos, pelicans, ducks, geese, and swans.",
            timeVideoSrc: "https://youtu.be/E7rcFO1nCE0",
            location: "Sudochye Lake",
            locationSrc: "https://maps.app.goo.gl/myjzm7QPfxEx3KMu8",
            img: "img/eco-tour-2day/daysimg/2-12-00"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café in the city of Kungrad.",
            timeVideoSrc: "",
            location: "Kungrad",
            locationSrc: "https://maps.app.goo.gl/jQfnM29Lkt8UTzdE8",
            img: "img/eco-tour-2day/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "16:00",
            timeName: "Mizdakhan — a sacred historical complex",
            timeDistination: "The journey continues with a visit to the sacred and historical Mizdakhan complex (4th century BCE – 13th century CE). The program includes the mausoleums of Mazlumkhan Sulu and Shamun Nabi, as well as the ancient settlement of Gaur Kala — a monument of the Zoroastrian era (4th–3rd centuries BCE).",
            timeVideoSrc: "https://youtu.be/CV_TCysQTAo",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/eco-tour-2day/daysimg/2-16-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Return to Nukus",
            timeDistination: "The tour concludes with a return to Nukus, marking the end of a rich journey through some of the most remote and unique places in the region.",
            timeVideoSrc: "https://youtu.be/Io1Cj4c8mTE",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-2day/daysimg/1-08-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1nS3XchOj5O8Ds3OeWyZkKn6km7N65j0&ehbc=2E312F&noprof=1",
    feedback: [
      {
        date: "",
        name: "Louisa & Kieran",
        gmail: "",
        messages:
          "Really well looked after, made sure we were warm & well fed.A beautiful place to camp and an incredible experience for a good night’s sleep.We recommend the vodka!",
        score: 5,
      },
      {
        date: "",
        name: "Sandro",
        gmail: "",
        messages:
          "Really nice hosts. Really nice place. Service was perfect.Everything was perfect and amazing experience and landscapes! :). We loved this really. A great experience, great hospitality and a warm & cozy yurt - even when it was cold outside.",
        score: 5,
      },
      {
        date: "2018-04-02",
        name: "Thomas & Camilla",
        gmail: "Sweden",
        messages:
          "En underbar afton vid Aralsjön! Gästfriheten vet inga gränser, god mat, mycket mot och excellent Karakalpakstansk vodka :) Sarsenbay är en perfekt värd/guide!",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "Frau Rainer und Markus",
        gmail: "Sweden",
        messages:
          "Sehnsüger Ausflug an den Aralsee! Super Reiseleiter und Fahrer. Alles wunderbar, wir kommen gerne wieder. Sehr eindrucksvoll hier in Karakalpakstan.",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "同海王",
        gmail: "",
        messages:
          "大家好，欢迎来到咸海。我是在此工作8年的中国人“咸海王”，每年要在此工作4-6个月，很荣幸和知名旅行公司成为邻居。如果有中国朋友要介绍朋友或者生意中的主人公，希望来咸海旅游的中国朋友请联系我，想更多了解咸海可加我微信或电话：乌兹电话: +99899 9686518 国内电: 186130543232",
        score: 5,
      },
      {
        date: "апрель 2018",
        name: "Дмитрий",
        gmail: "Москва",
        messages:
          "Огромное спасибо сотрудникам турбазы и людям за гостеприимство. Получили огромное удовольствие от общения с такими замечательными людьми. Спасибо за это открытие для нас Арал!",
        score: 5,
      },
      {
        date: "13.04.2018",
        name: "Друг из Владикавказа",
        gmail: "",
        messages:
          "Спасибо огромное за гостеприимство! Очень понравился прием и организованность лагеря. Радушие и теплое отношение всех. О киме ли ветер – тишина здесь. Нам нужно еще побывать у вас. Рассмотрели друзей, о прекрасно проведенном времени.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Анна Сергеевна Иванова",
        gmail: "",
        messages:
          "Отзыв о туре 'Нукус – Муйнак – Плато Устюрт – Аральское море': 'Этот тур оказался для меня настоящим открытием! С самого утра нас забрали из Нукуса, и началось наше путешествие по местам, которые буквально дышат историей. Кладбище кораблей в Муйнаке оставляет неизгладимое впечатление – когда-то здесь было море, а теперь на сухом дне стоят забытые корабли, что заставляет задуматься о масштабах природных изменений. Музеи в Муйнаке погружают в историю региона и трагедию Арала. Особенно запомнилась поездка через плато Устюрт – такие виды сложно описать словами. Местные каньоны, кладбище кочевников – всё это делает маршрут по-настоящему уникальным. Природа здесь потрясающая, и каждый момент хотелось запечатлеть на камеру. День завершился на берегу Аральского моря, где можно было искупаться и собирать ракушки. Юртовый лагерь на берегу – это отдельная магия. Ужин в традиционной обстановке, а затем ночь в уютной юрте под звёздами – идеальное завершение такого насыщенного дня. Большое спасибо команде за этот потрясающий опыт. Рекомендую всем, кто хочет прикоснуться к уникальной истории и природе этой области!",
        score: 5,
      },
      {
        date: "30.07.2023",
        name: "Beth W",
        gmail: "bethwison1991@gmail.com",
        messages:
          "We did not book a tour with a guide. We used the company for having the driver only to take us to the Ship Graveyard.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Janusz Tylus",
        gmail: "",
        messages:
          "Grupa z Polski, podróżnicy TOP TURYSTYKA Super miejscówka, niezwykła gościnność, wielogwiazdkowy camp pod gwiazdami. Było super! Bardzo miłe miejsce ♥ Astelie Eryk Kwasnica PS.Pan w agregacie WYMlATA:) Brestowice",
        score: 5,
      },

      {
        date: "",
        name: "Lisa & Alexander",
        gmail: "Liebe Grüße",
        messages:
          "Auf die Freude der Natur und die Gesellschaft der Menschen im Jurten Camp beim Mal See. Wir haben die Zeit sehr genossen, wurden sehr umsorgt, gut & korrekt informiert, und die Sonne hat uns allen das Aufstehen versüßt. Danke für alles!",
        score: 5,
      },
      {
        date: "14.04.2018",
        name: "Simon & Natasha",
        gmail: "Switzerland / Russia",
        messages:
          "Very nice camp with competent staff and lots of anecdotes! It’s sad to see to what level the Aral Sea shrunk and hope that the government starts taking action. Good Luck",
        score: 4,
      },
      {
        date: "April 15, 2018",
        name: "Marc, Jennifer,Lucas & Alexis",
        gmail: "Michigan, USA",
        messages:
          "Thank you for the great visit to the Aral Sea. The Yurt Camp was very comfortable and pleasant. Our family enjoyed the friendly atmosphere and comfortable accommodations. Thank you",
        score: 5,
      },
      {
        date: "12-16 августа 2019",
        name: "Den Garage",
        gmail: "БЕНЗИН И ГРЕЧА",
        messages:
          "Идеальный хостел для путешествующих на двух колесах и не только.Удачно расположен в центре и чуть в стороне от шумных улиц. Как только открываешь дверь, и заканчивай свой trip— всё начинает нравиться! Ковровое покрытие под капотом в комнате, выходное место пространства. В шкатках всё очень тщательно обустроено, нет ничего лишнего. В хостеле все отлично функционирует, никаких поломанных кранов и неисправных розеток… и так далее. А самое главное – это расположение администраторов и персонала.Мне не хотелось бы забыть, но не хотелось бы останавливаться с недугом в Besqala. Пожалуй, достаточно отзыв и завтрак индуский!",
        score: 5,
      },
      {
        date: "09.09.19",
        name: "Isabelle",
        gmail: "France",
        messages:
          "Super séjour à Nukus et à l’Aral Sea (impressionnant à voir). Expérience à faire : se baigner dans le lac et avoir les pieds pleins de boue. Équipe au petit soin, vraiment top ! Merci à Tazabay et à son équipe.Merci Taschkent (petit clin d’œil à mon guide K.)",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Antoine PELLERIN ",
        gmail: "",
        messages:
          "Excellent keeper Diana to his camp Elena & Vova. A magnificent piece of scenography. The beautiful desert & skies. Thanks a lot for this great moment for us.",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Annika,Viki ",
        gmail: "Germany,Hungary",
        messages:
          "We had a fantastic stay thanks to the warm hospitality of the team – and fun despite the noisy tourist group next door!",
        score: 5,
      },
      {
        date: "11.05.2026",
        name: "Liza Raitina",
        gmail: "",
        messages: "Нам тур понравился на 10 из 10. Особенная благодарность водителю - он просто гуру вождения вне трассы. Из пожеланий по улучшению: я бы озвучила аудиогид живым голосом вместо робота. Возможно, также можно добавить для желающих более расширенный контент, особенно с учетом долгой дороги. В остальном нам все очень понравилось, спасибо вам большое за помощь и организацию.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Jill Heyde",
        gmail: "",
        messages: "We just returned from an Aral Sea trip with Rakhmet. It was very interesting. We are not comfortable with video. Would you mind sending us the questions in writing?",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Gioacchino Pagano",
        gmail: "",
        messages: "The trip was very beautiful, especially with Max as guide. You did a great choice to suggest us him.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Martina & Manfred",
        gmail: "",
        messages: "We had a wonderful tour to the Besqala Aral camp. We spent two nights in the camp. All things are very well organized. The food was very good and the ladies were very friendly and helpful. The yurts were comfortable and clean. Our driver Muchtar was a very good driver, always driving safely on difficult off-road routes. One suggestion: switch off the camp light for an hour at night so guests can better enjoy the stars.",
        score: 5,
      },
      {
        date: "24.05.2026",
        name: "Ola Jodyna",
        gmail: "",
        messages: "It was a wonderful, well-organized adventure. We were picked up punctually from our hotel by a friendly driver. The vehicle was exactly as promised, equipped with air conditioning and 4WD. The scenery was stunning and unforgettable. The yurts were clean and the food was delicious. The optional excursion to the edge of the plateau was absolutely worth it.",
        score: 5,
      },
      {
        date: "26.05.2026",
        name: "Alessandro",
        gmail: "",
        messages: "The tour was beautiful and very touching. Even though the car broke down, the staff quickly found an alternative solution. Our guide Azat was amazing and exceeded all expectations. Everything was perfect and we highly recommend this experience.",
        score: 5,
      },
      {
        date: "29.05.2026",
        name: "Симоне Донди",
        gmail: "",
        messages: "Не могу назвать ничего отрицательного. Отличный водитель, своевременные остановки, позволившие насладиться местами, отличная и обильная еда.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Katia",
        gmail: "",
        messages: "I loved both of my trips with Besqala. The Aral Sea is a place worth seeing and the fortresses of ancient Khorezm are unique. Drivers were knowledgeable and attentive. If I had to suggest one improvement, it would be providing a clearer schedule and more information about stop durations.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Sibylle Kiss",
        gmail: "",
        messages: "We had 3 great days at the Aral Sea.",
        score: 5,
      },
      {
        date: "09.06.2026",
        name: "Крейдина Алиса",
        gmail: "",
        messages: "Хотела сказать вашей организации огромное спасибо за организацию тура, все было супер! Один из лучших опытов в моей жизни.",
        score: 5,
      }
    ],
    img: [
      "img/eco-tour-2day/tourimg/21",
      "img/eco-tour-2day/tourimg/27",
      "img/eco-tour-2day/tourimg/1",
      "img/eco-tour-2day/tourimg/2",
      "img/eco-tour-2day/tourimg/3",
      "img/eco-tour-2day/tourimg/4",
      "img/eco-tour-2day/tourimg/5",
      "img/eco-tour-2day/tourimg/6",
      "img/eco-tour-2day/tourimg/7",
      "img/eco-tour-2day/tourimg/8",
      "img/eco-tour-2day/tourimg/9",
      "img/eco-tour-2day/tourimg/10",
      "img/eco-tour-2day/tourimg/11",
      "img/eco-tour-2day/tourimg/12",
      "img/eco-tour-2day/tourimg/13",
      "img/eco-tour-2day/tourimg/14",
      "img/eco-tour-2day/tourimg/15",
      "img/eco-tour-2day/tourimg/16",
      "img/eco-tour-2day/tourimg/17",
      "img/eco-tour-2day/tourimg/18",
      "img/eco-tour-2day/tourimg/19",
      "img/eco-tour-2day/tourimg/22",
      "img/eco-tour-2day/tourimg/23",
      "img/eco-tour-2day/tourimg/24",
      "img/eco-tour-2day/tourimg/25",
      "img/eco-tour-2day/tourimg/26",
      "img/eco-tour-2day/tourimg/28",
      "img/eco-tour-2day/tourimg/29",
      "img/eco-tour-2day/tourimg/30",
      "img/eco-tour-2day/tourimg/31",
      "img/eco-tour-2day/tourimg/32",
      "img/eco-tour-2day/tourimg/33"
    ],
  },
  {
    id: 2,
    price: "189",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "522"
      },
      {
        id: 2,
        persons: "2",
        price: "604"
      },
      {
        id: 3,
        persons: "3",
        price: "686"
      },
      {
        id: 4,
        persons: "4",
        price: "756"
      },

    ],
    srcitinerary: "img/eco-tour-2day/itinerary/rus",
    maxamount: "100+",
    category: "Aral",
    category1: "Top",
    tourlang: "rus",
    name: "Эко-тур на Аральское море",
    dayDuration: "(2 дня и 1 ночь)",
    aboutTour: "Откройте для себя Каракалпакстан: бескрайние каньоны, легендарное Аральское море и крепости древних цивилизаций",
    unitDay: "2",
    unitNight: "1",
    country: "8",
    startCountry: "Нукус",
    endCountry: "Нукус",
    mapstext1: "Более 700 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Муйнак - Плато Устюрт-Аральское море-Кладбище кочевников -Курганча Кала -Кубла Устюрт -озеро Судочье-Кунград-некрополь Миздакхан-Гаур кала-Нукус",
    inclusionOn: [

      {
        class: "fa fa-car",
        text: "Транспорт: Полноприводный внедоронжик;"
      },
      {
        class: "fa fa-cutlery",
        text: "Питание: 4 раза;"
      },
      {
        class: "fa fa-bed",
        text: "Проживание: 1 ночь в Юртовом лагере;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-globe",
        text: "Чаевые;"
      },
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "145"
      },
      {
        id: 3,
        name: "Солончак Барса Келмес",
        price: "50"
      },
      {
        id: 4,
        name: "Нукус-Хива Трансфер",
        price: "75"
      }
    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Приключение начинается в Нукусе",
            timeDistination: "Добро пожаловать в Каракалпакстан — край, где степь тянется за горизонт, где каждый холм шепчет истории прошлого, и где сама тишина говорит громче любых слов. Вы оказались в самом сердце Центральной Азии — месте, где природа и культура переплелись на протяжении веков, создав мир, не похожий ни на какой другой на Земле.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-2day/daysimg/1-08-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Муйнак — город-порт ушедшего Аральского моря",
            timeDistination: "Вы посетите Муйнак — город, который в прошлом был крупным портом Аральского моря и центром рыболовства, увидите Кладбище кораблей Муйнака и побываете в Муйнакский государственный краеведческий музей, где через экспозиции и документальный фильм раскрывается история Арала и жизнь города.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-2day/daysimg/1-11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Обед",
            timeDistination: "Обед в уютном Гостевом доме, где отведаете горячие блюда из местной кухни.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-2day/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:00",
            timeName: "Там, где было море: путь к каньонам Устюрта",
            timeDistination: "Маршрут проходит по дну ушедшего Аральского моря, где перед вами откроются необычные и сурово-красивые пейзажи бывшего морского пространства. По пути предусмотрены остановки для фотосъёмки — вы сможете запечатлеть уникальный ландшафт и величественные каньоны плато Устюрт. Здесь вы узнаете больше о древней истории региона и сделаете краткую остановку у кладбища кочевников — немого свидетеля жизни людей, веками населявших эти земли.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Устюрт",
            locationSrc: "https://maps.app.goo.gl/edkUA1k6bRFLELzN6",
            img: "img/eco-tour-2day/daysimg/1-14-00"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Кладбище кочевников на плато Устюрт",
            timeDistination: "Вы посетите кладбище кочевников на плато Устюрт — краткую остановку в пути среди сурового и выразительного ландшафта. Место хранящее следы жизни людей, которые веками кочевали по этим землям",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Плато Устюрт",
            locationSrc: "https://maps.app.goo.gl/bMriUXdZQD85aNXv5",
            img: "img/eco-tour-2day/daysimg/1-16-00"
          },
          {
            timeid: "6",
            time: "17:00",
            timeName: "Встреча с Аральским морем",
            timeDistination: "Вы окажетесь на берегу Аральского моря, где в сезон можно искупаться, прогуляться вдоль воды и собрать ракушки, наслаждаясь тишиной и особой атмосферой этого места.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аральское море",
            locationSrc: "https://maps.app.goo.gl/8UMc14PqDxubXGah7",
            img: "img/eco-tour-2day/daysimg/1-17-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Ночь в юртовом лагере у Аральского моря",
            timeDistination: "День завершается в уютном юртовом лагере на берегу Аральского моря. Вас ждёт ужин в традиционной атмосфере и ночь в комфортной юрте, создающие особое ощущение тишины и уединения. В лагере оборудованы душ с чистой пресной водой и уборная для удобства гостей.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Юртовый лагерь",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-2day/daysimg/1-18-00"
          },
        ],
      },
      {
        id: "day2",
        nameDay: "День 2",
        times: [
          {
            timeid: "1",
            time: "05:00",
            timeName: "Рассвет над Аральским морем",
            timeDistination: "Второй день начинается с восхода солнца над морем — тихого и по-настоящему волшебного зрелища, которое задаёт настроение всему утру. После этого вас ждёт вкусный завтрак, наполняющий энергией для предстоящего дня путешествия.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аральское море",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-2day/daysimg/2-05-00"
          },
          {
            timeid: "2",
            time: "08:00",
            timeName: "Курганча-кала — городище Великого шёлкового пути",
            timeDistination: "Обратный путь проходит по историческим городищам с нового ракурса. В программе — посещение Курганча-кала (XII–XIV вв.), укреплённой торговой фактории, располагавшейся на одном из маршрутов Великого шёлкового пути.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Курганча-кала",
            locationSrc: "https://maps.app.goo.gl/Z2ZShskvfvphyFLJ6",
            img: "img/eco-tour-2day/daysimg/2-08-00"
          },
          {
            timeid: "3",
            time: "10:30",
            timeName: "Кубла-Устюрт — самый отдалённый посёлок региона",
            timeDistination: "Следующая остановка — Кубла-Устюрт, один из самых отдалённых посёлков региона, построенный в советский период. Здесь вы сделаете остановку у взлётной полосы того времени и сможете запечатлеть интересные сооружения на фоне спокойного деревенского пейзажа.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Кубла-Устюрт",
            locationSrc: "https://maps.app.goo.gl/Z2ZShskvfvphyFLJ6",
            img: "img/eco-tour-2day/daysimg/2-10-30"
          },
          {
            timeid: "4",
            time: "12:00",
            timeName: "Озеро Судочье и покинутый посёлок Урга",
            timeDistination: "Вы посетите старый маяк, огонь которого в прошлом указывал путь к посёлку Урга. Далее по крутому спуску маршрут ведёт в покинутый рыбацкий посёлок Урга, расположенный у озера Судочье. Это озеро является местом остановки мигрирующих птиц — здесь можно увидеть розовых фламинго, пеликанов, уток, гусей и лебедей.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Озеро Судочье",
            locationSrc: "https://maps.app.goo.gl/myjzm7QPfxEx3KMu8",
            img: "img/eco-tour-2day/daysimg/2-12-00"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе в городе Кунград.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Кунград",
            locationSrc: "https://maps.app.goo.gl/jQfnM29Lkt8UTzdE8",
            img: "img/eco-tour-2day/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "16:00",
            timeName: "Миздакхан — сакральный комплекс",
            timeDistination: "Путешествие продолжается посещением исторического и священного комплекса Миздакхан (IV–II вв. до н.э., XIII–XVI вв.). В программе — осмотр мавзолеев Мазлумхан Сулу, Халифа Ережеп и Шамун Наби, а также городища Гяур-кала — памятника эпохи зороастризма (IV–III вв. до н.э.).",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ходжели",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/eco-tour-2day/daysimg/2-16-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Возвращение в Нукус",
            timeDistination: "Завершаем экстрим-тур возвращением в город Нукус, где заканчивается насыщенное путешествие по самым удалённым и уникальным уголкам региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-2day/daysimg/1-08-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1nS3XchOj5O8Ds3OeWyZkKn6km7N65j0&ehbc=2E312F&noprof=1",
    feedback: [
      {
        date: "",
        name: "Louisa & Kieran",
        gmail: "",
        messages:
          "Really well looked after, made sure we were warm & well fed.A beautiful place to camp and an incredible experience for a good night’s sleep.We recommend the vodka!",
        score: 5,
      },
      {
        date: "",
        name: "Sandro",
        gmail: "",
        messages:
          "Really nice hosts. Really nice place. Service was perfect.Everything was perfect and amazing experience and landscapes! :). We loved this really. A great experience, great hospitality and a warm & cozy yurt - even when it was cold outside.",
        score: 5,
      },
      {
        date: "2018-04-02",
        name: "Thomas & Camilla",
        gmail: "Sweden",
        messages:
          "En underbar afton vid Aralsjön! Gästfriheten vet inga gränser, god mat, mycket mot och excellent Karakalpakstansk vodka :) Sarsenbay är en perfekt värd/guide!",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "Frau Rainer und Markus",
        gmail: "Sweden",
        messages:
          "Sehnsüger Ausflug an den Aralsee! Super Reiseleiter und Fahrer. Alles wunderbar, wir kommen gerne wieder. Sehr eindrucksvoll hier in Karakalpakstan.",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "同海王",
        gmail: "",
        messages:
          "大家好，欢迎来到咸海。我是在此工作8年的中国人“咸海王”，每年要在此工作4-6个月，很荣幸和知名旅行公司成为邻居。如果有中国朋友要介绍朋友或者生意中的主人公，希望来咸海旅游的中国朋友请联系我，想更多了解咸海可加我微信或电话：乌兹电话: +99899 9686518 国内电: 186130543232",
        score: 5,
      },
      {
        date: "апрель 2018",
        name: "Дмитрий",
        gmail: "Москва",
        messages:
          "Огромное спасибо сотрудникам турбазы и людям за гостеприимство. Получили огромное удовольствие от общения с такими замечательными людьми. Спасибо за это открытие для нас Арал!",
        score: 5,
      },
      {
        date: "13.04.2018",
        name: "Друг из Владикавказа",
        gmail: "",
        messages:
          "Спасибо огромное за гостеприимство! Очень понравился прием и организованность лагеря. Радушие и теплое отношение всех. О киме ли ветер – тишина здесь. Нам нужно еще побывать у вас. Рассмотрели друзей, о прекрасно проведенном времени.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Анна Сергеевна Иванова",
        gmail: "",
        messages:
          "Отзыв о туре 'Нукус – Муйнак – Плато Устюрт – Аральское море': 'Этот тур оказался для меня настоящим открытием! С самого утра нас забрали из Нукуса, и началось наше путешествие по местам, которые буквально дышат историей. Кладбище кораблей в Муйнаке оставляет неизгладимое впечатление – когда-то здесь было море, а теперь на сухом дне стоят забытые корабли, что заставляет задуматься о масштабах природных изменений. Музеи в Муйнаке погружают в историю региона и трагедию Арала. Особенно запомнилась поездка через плато Устюрт – такие виды сложно описать словами. Местные каньоны, кладбище кочевников – всё это делает маршрут по-настоящему уникальным. Природа здесь потрясающая, и каждый момент хотелось запечатлеть на камеру. День завершился на берегу Аральского моря, где можно было искупаться и собирать ракушки. Юртовый лагерь на берегу – это отдельная магия. Ужин в традиционной обстановке, а затем ночь в уютной юрте под звёздами – идеальное завершение такого насыщенного дня. Большое спасибо команде за этот потрясающий опыт. Рекомендую всем, кто хочет прикоснуться к уникальной истории и природе этой области!",
        score: 5,
      },
      {
        date: "30.07.2023",
        name: "Beth W",
        gmail: "bethwison1991@gmail.com",
        messages:
          "We did not book a tour with a guide. We used the company for having the driver only to take us to the Ship Graveyard.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Janusz Tylus",
        gmail: "",
        messages:
          "Grupa z Polski, podróżnicy TOP TURYSTYKA Super miejscówka, niezwykła gościnność, wielogwiazdkowy camp pod gwiazdami. Było super! Bardzo miłe miejsce ♥ Astelie Eryk Kwasnica PS.Pan w agregacie WYMlATA:) Brestowice",
        score: 5,
      },

      {
        date: "",
        name: "Lisa & Alexander",
        gmail: "Liebe Grüße",
        messages:
          "Auf die Freude der Natur und die Gesellschaft der Menschen im Jurten Camp beim Mal See. Wir haben die Zeit sehr genossen, wurden sehr umsorgt, gut & korrekt informiert, und die Sonne hat uns allen das Aufstehen versüßt. Danke für alles!",
        score: 5,
      },
      {
        date: "14.04.2018",
        name: "Simon & Natasha",
        gmail: "Switzerland / Russia",
        messages:
          "Very nice camp with competent staff and lots of anecdotes! It’s sad to see to what level the Aral Sea shrunk and hope that the government starts taking action. Good Luck",
        score: 4,
      },
      {
        date: "April 15, 2018",
        name: "Marc, Jennifer,Lucas & Alexis",
        gmail: "Michigan, USA",
        messages:
          "Thank you for the great visit to the Aral Sea. The Yurt Camp was very comfortable and pleasant. Our family enjoyed the friendly atmosphere and comfortable accommodations. Thank you",
        score: 5,
      },
      {
        date: "12-16 августа 2019",
        name: "Den Garage",
        gmail: "БЕНЗИН И ГРЕЧА",
        messages:
          "Идеальный хостел для путешествующих на двух колесах и не только.Удачно расположен в центре и чуть в стороне от шумных улиц. Как только открываешь дверь, и заканчивай свой trip— всё начинает нравиться! Ковровое покрытие под капотом в комнате, выходное место пространства. В шкатках всё очень тщательно обустроено, нет ничего лишнего. В хостеле все отлично функционирует, никаких поломанных кранов и неисправных розеток… и так далее. А самое главное – это расположение администраторов и персонала.Мне не хотелось бы забыть, но не хотелось бы останавливаться с недугом в Besqala. Пожалуй, достаточно отзыв и завтрак индуский!",
        score: 5,
      },
      {
        date: "09.09.19",
        name: "Isabelle",
        gmail: "France",
        messages:
          "Super séjour à Nukus et à l’Aral Sea (impressionnant à voir). Expérience à faire : se baigner dans le lac et avoir les pieds pleins de boue. Équipe au petit soin, vraiment top ! Merci à Tazabay et à son équipe.Merci Taschkent (petit clin d’œil à mon guide K.)",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Antoine PELLERIN ",
        gmail: "",
        messages:
          "Excellent keeper Diana to his camp Elena & Vova. A magnificent piece of scenography. The beautiful desert & skies. Thanks a lot for this great moment for us.",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Annika,Viki ",
        gmail: "Germany,Hungary",
        messages:
          "We had a fantastic stay thanks to the warm hospitality of the team – and fun despite the noisy tourist group next door!",
        score: 5,
      },
      {
        date: "11.05.2026",
        name: "Liza Raitina",
        gmail: "",
        messages: "Нам тур понравился на 10 из 10. Особенная благодарность водителю - он просто гуру вождения вне трассы. Из пожеланий по улучшению: я бы озвучила аудиогид живым голосом вместо робота. Возможно, также можно добавить для желающих более расширенный контент, особенно с учетом долгой дороги. В остальном нам все очень понравилось, спасибо вам большое за помощь и организацию.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Jill Heyde",
        gmail: "",
        messages: "We just returned from an Aral Sea trip with Rakhmet. It was very interesting. We are not comfortable with video. Would you mind sending us the questions in writing?",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Gioacchino Pagano",
        gmail: "",
        messages: "The trip was very beautiful, especially with Max as guide. You did a great choice to suggest us him.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Martina & Manfred",
        gmail: "",
        messages: "We had a wonderful tour to the Besqala Aral camp. We spent two nights in the camp. All things are very well organized. The food was very good and the ladies were very friendly and helpful. The yurts were comfortable and clean. Our driver Muchtar was a very good driver, always driving safely on difficult off-road routes. One suggestion: switch off the camp light for an hour at night so guests can better enjoy the stars.",
        score: 5,
      },
      {
        date: "24.05.2026",
        name: "Ola Jodyna",
        gmail: "",
        messages: "It was a wonderful, well-organized adventure. We were picked up punctually from our hotel by a friendly driver. The vehicle was exactly as promised, equipped with air conditioning and 4WD. The scenery was stunning and unforgettable. The yurts were clean and the food was delicious. The optional excursion to the edge of the plateau was absolutely worth it.",
        score: 5,
      },
      {
        date: "26.05.2026",
        name: "Alessandro",
        gmail: "",
        messages: "The tour was beautiful and very touching. Even though the car broke down, the staff quickly found an alternative solution. Our guide Azat was amazing and exceeded all expectations. Everything was perfect and we highly recommend this experience.",
        score: 5,
      },
      {
        date: "29.05.2026",
        name: "Симоне Донди",
        gmail: "",
        messages: "Не могу назвать ничего отрицательного. Отличный водитель, своевременные остановки, позволившие насладиться местами, отличная и обильная еда.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Katia",
        gmail: "",
        messages: "I loved both of my trips with Besqala. The Aral Sea is a place worth seeing and the fortresses of ancient Khorezm are unique. Drivers were knowledgeable and attentive. If I had to suggest one improvement, it would be providing a clearer schedule and more information about stop durations.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Sibylle Kiss",
        gmail: "",
        messages: "We had 3 great days at the Aral Sea.",
        score: 5,
      },
      {
        date: "09.06.2026",
        name: "Крейдина Алиса",
        gmail: "",
        messages: "Хотела сказать вашей организации огромное спасибо за организацию тура, все было супер! Один из лучших опытов в моей жизни.",
        score: 5,
      }
    ],
    img: [
      "img/eco-tour-2day/tourimg/21",
      "img/eco-tour-2day/tourimg/27",
      "img/eco-tour-2day/tourimg/1",
      "img/eco-tour-2day/tourimg/2",
      "img/eco-tour-2day/tourimg/3",
      "img/eco-tour-2day/tourimg/4",
      "img/eco-tour-2day/tourimg/5",
      "img/eco-tour-2day/tourimg/6",
      "img/eco-tour-2day/tourimg/7",
      "img/eco-tour-2day/tourimg/8",
      "img/eco-tour-2day/tourimg/9",
      "img/eco-tour-2day/tourimg/10",
      "img/eco-tour-2day/tourimg/11",
      "img/eco-tour-2day/tourimg/12",
      "img/eco-tour-2day/tourimg/13",
      "img/eco-tour-2day/tourimg/14",
      "img/eco-tour-2day/tourimg/15",
      "img/eco-tour-2day/tourimg/16",
      "img/eco-tour-2day/tourimg/17",
      "img/eco-tour-2day/tourimg/18",
      "img/eco-tour-2day/tourimg/19",
      "img/eco-tour-2day/tourimg/22",
      "img/eco-tour-2day/tourimg/23",
      "img/eco-tour-2day/tourimg/24",
      "img/eco-tour-2day/tourimg/25",
      "img/eco-tour-2day/tourimg/26",
      "img/eco-tour-2day/tourimg/28",
      "img/eco-tour-2day/tourimg/29",
      "img/eco-tour-2day/tourimg/30",
      "img/eco-tour-2day/tourimg/31",
      "img/eco-tour-2day/tourimg/32",
      "img/eco-tour-2day/tourimg/33"
    ],
  },
  {
    id: 3,
    price: "275",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "695"
      },
      {
        id: 2,
        persons: "2",
        price: "830"
      },
      {
        id: 3,
        persons: "3",
        price: "965"
      },
      {
        id: 4,
        persons: "4",
        price: "1100"
      },

    ],
    srcitinerary: "img/eco-tour-3day/itinerary/eng",
    maxamount: "100+",
    category: "Aral",
    category1: "Top",
    tourlang: "eng",
    name: "Eco Tour to the Aral Sea",
    dayDuration: "(3 days and 2 nights)",
    aboutTour: "Discover Karakalpakstan: endless canyons, the legendary Aral Sea and fortresses of ancient civilizations",
    unitDay: "3",
    unitNight: "2",
    country: "11",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Over 900 km",
    mapstext2: "Tour season: Year-round",
    description: "Nukus – Muynak – Ustyurt Plateau – Nomads’ Cemetery – Aral Sea – Kurgancha Kala – Kunti Baba – Aktumsik Canyons – Kubla Ustyurt – Sudoche Lake – Barsakelmes Salt Flat – Mizdahkan – Nukus.",
    inclusionOn: [

      {
        class: "fa fa-car",
        text: "Transportation: 4×4 off-road vehicle;"
      },
      {
        class: "fa fa-cutlery",
        text: "Meals: 7 meals;"
      },
      {
        class: "fa fa-bed",
        text: "Accommodation: 2 nights in a yurt camp;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance fees;"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-globe",
        text: "Tips;"
      },
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Nukus-Khiva Transfer",
        price: "70"
      },
      {
        id: 2,
        name: "Professional guide",
        price: "215"
      }
    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "The adventure begins in Nukus",
            timeDistination: "Welcome to Karakalpakstan — a land where the steppe stretches beyond the horizon, where every hill whispers stories of the past, and where silence speaks louder than words. You have arrived in the very heart of Central Asia — a place where nature and culture have intertwined over centuries, creating a world unlike any other.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-3day/daysimg/1-08-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Muynak — the former port city of the Aral Sea",
            timeDistination: "You will visit Muynak, a city that was once a major port of the Aral Sea and a center of fishing. You will see the Muynak Ship Cemetery and visit the Muynak State Museum of Local History, where exhibitions and a documentary film reveal the dramatic history of the Aral Sea and the life of the city.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-3day/daysimg/1-11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Lunch",
            timeDistination: "Lunch at a cozy guest house, where you will be served hot dishes of traditional local cuisine.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:00",
            timeName: "Where the sea once was: journey to the Ustyurt canyons",
            timeDistination: "The route follows the dry seabed of the former Aral Sea, revealing harsh yet striking landscapes of the deserted seashore. Several stops are planned for photography, allowing you to capture the unique scenery and the majestic canyons of the Ustyurt Plateau. Along the way, you will learn about the ancient history of the region and make a short stop at the Nomads’ Cemetery — a silent witness to lives once lived on these lands.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ustyurt canyons",
            locationSrc: "https://maps.app.goo.gl/edkUA1k6bRFLELzN6",
            img: "img/eco-tour-3day/daysimg/1-14-00"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Nomads’ Cemetery on the Ustyurt Plateau",
            timeDistination: "You will visit the Nomads’ Cemetery on the Ustyurt Plateau — a brief stop amid a stark and expressive landscape. This place preserves traces of people who migrated across these lands for centuries.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ustyurt Plateau",
            locationSrc: "https://maps.app.goo.gl/bMriUXdZQD85aNXv5",
            img: "img/eco-tour-3day/daysimg/1-16-00"
          },
          {
            timeid: "6",
            time: "17:00",
            timeName: "Meeting the Aral Sea",
            timeDistination: "You will reach the shores of the Aral Sea, where, depending on the season, you can swim, walk along the water, and collect seashells, enjoying the silence and unique atmosphere of this place.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Aral Sea",
            locationSrc: "https://maps.app.goo.gl/8UMc14PqDxubXGah7",
            img: "img/eco-tour-3day/daysimg/1-17-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Overnight at the yurt camp by the Aral Sea",
            timeDistination: "The day ends at a cozy yurt camp on the shores of the Aral Sea. You will spend the night in a comfortable traditional yurt, immersed in a unique atmosphere that offers a deep sense of peace and solitude. The camp is equipped with showers with fresh water and restroom facilities for guests’ convenience.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Yurt camp",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/1-18-00"
          },
        ],
      },
      {
        id: "day2",
        nameDay: "Day 2",
        times: [
          {
            timeid: "1",
            time: "04:00",
            timeName: "Sunrise over the Aral Sea",
            timeDistination: "The second day begins with sunrise over the sea — a quiet and truly magical moment that sets the mood for the entire morning. Afterwards, you will enjoy a tasty breakfast, providing energy for the day ahead.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Aral Sea",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/2-04-00"
          },
          {
            timeid: "2",
            time: "08:30",
            timeName: "Kurgancha Kala — a settlement of the Great Silk Road",
            timeDistination: "The return journey follows historic settlements from a new perspective. The program includes a visit to Kurgancha Kala (12th–14th centuries), a fortified trading settlement located on one of the routes of the Great Silk Road.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Kurgancha Kala",
            locationSrc: "https://maps.app.goo.gl/Z2ZShskvfvphyFLJ6",
            img: "img/eco-tour-3day/daysimg/2-08-30"
          },
          {
            timeid: "3",
            time: "09:30",
            timeName: "Kunti Baba and stone landscapes",
            timeDistination: "A stop at the Kunti Baba nomads’ cemetery. The route then continues down from the plateau along a natural trail among impressive rock formations. You will see stone pillars shaped by wind and time, deep canyons, and cliffs resembling a natural sculpture park. Panoramic views open up over the surrounding landscapes and the former Aral Sea — one of the most photogenic locations of the route.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Kunti Baba",
            locationSrc: "https://yandex.uz/maps/-/CLxaQBI4",
            img: "img/eco-tour-3day/daysimg/2-09-30"
          },

          {
            timeid: "4",
            time: "13:00",
            timeName: "Lunch",
            timeDistination: "Lunch at the yurt camp.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Yurt camp",
            locationSrc: "https://maps.app.goo.gl/i9vw3PtnoeTdrW5j9",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "5",
            time: "14:00",
            timeName: "Aktumsik Canyons and Martian landscapes",
            timeDistination: "The journey continues to Cape Aktumsik, where the landscape impresses with its scale and forms. You will walk among high canyons and surreal, Martian-like scenery, explore a mysterious cave, and see stone slabs layered like pages of an ancient chronicle. Later, you will reach the seashore, where you can stroll along the beach and swim in season. The day ends with a return to the Besqala yurt camp, surrounded once again by the silence of the steppe.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Aktumsik",
            locationSrc: "https://maps.app.goo.gl/i9vw3PtnoeTdrW5j9",
            img: "img/eco-tour-3day/daysimg/2-14-00"
          },
          {
            timeid: "6",
            time: "19:00",
            timeName: "Traditional dinner and starry sky",
            timeDistination: "The evening is spent enjoying a traditional dinner. Afterward, you can observe the stars under the open sky, experiencing the vastness, silence, and special atmosphere of this place.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Yurt camp",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
        ],
      },
      {
        id: "day3",
        nameDay: "Day 3",
        times: [
          {
            timeid: "1",
            time: "06:00",
            timeName: "Meeting the sunrise",
            timeDistination: "An early rise to welcome the sunrise as it paints the sea in soft, delicate colors.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Yurt camp",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/3-06-00"
          },
          {
            timeid: "2",
            time: "09:30",
            timeName: "Kubla-Ustyurt — the most remote settlement",
            timeDistination: "The next stop is Kubla-Ustyurt, one of the most remote settlements in the region, built during the Soviet period. Here you will stop at a former airstrip and photograph unique structures against a calm rural landscape.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Kubla-Ustyurt",
            locationSrc: "https://maps.app.goo.gl/fgJcT7tVj5fqgw5Z8",
            img: "img/eco-tour-3day/daysimg/3-09-30"
          },
          {
            timeid: "3",
            time: "11:00",
            timeName: "Sudoche Lake and the abandoned village of Urga",
            timeDistination: "You will visit an old lighthouse that once guided ships to the village of Urga. The route then descends steeply to the abandoned fishing settlement of Urga, located near Sudoche Lake. The lake is a stopover for migratory birds, where you may see pink flamingos, pelicans, ducks, geese, and swans.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Sudoche Lake",
            locationSrc: "https://maps.app.goo.gl/myjzm7QPfxEx3KMu8",
            img: "img/eco-tour-3day/daysimg/3-11-00"
          },
          {
            timeid: "4",
            time: "12:30",
            timeName: "Barsakelmes Salt Flat",
            timeDistination: "The route continues to the Barsakelmes salt flat — a vast salt lake reminiscent of Bolivia’s famous salt flats and preserved since the era of the ancient Tethys Ocean. The interplay of light and space creates striking optical effects and offers ideal conditions for truly unique photography.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Barsakelmes",
            locationSrc: "https://maps.app.goo.gl/WDepughP8HpwsN8g8",
            img: "img/eco-tour-3day/daysimg/3-12-30"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café in the town of Kungrad.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Kungrad",
            locationSrc: "https://maps.app.goo.gl/jQfnM29Lkt8UTzdE8",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "16:00",
            timeName: "Mizdahkan — a sacred complex",
            timeDistination: "The journey continues with a visit to the historic and sacred Mizdahkan complex (4th–2nd centuries BCE, 13th–16th centuries). The program includes the mausoleums of Mazlumkhan Sulu, Khalifa Erejep, and Shamun Nabi, as well as the ancient settlement of Gyaur-Kala — a monument of the Zoroastrian era (4th–3rd centuries BCE).",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/eco-tour-3day/daysimg/3-16-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Return to Nukus",
            timeDistination: "The expedition concludes with a return to Nukus, marking the end of an intense journey through some of the most remote and unique places in the region.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-3day/daysimg/1-08-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=102NWQJAItnER0bWiJ3wyJtqJl8Kv0y8&ehbc=2E312F&noprof=1",
    feedback: [
      {
        date: "",
        name: "Louisa & Kieran",
        gmail: "",
        messages:
          "Really well looked after, made sure we were warm & well fed.A beautiful place to camp and an incredible experience for a good night’s sleep.We recommend the vodka!",
        score: 5,
      },
      {
        date: "",
        name: "Sandro",
        gmail: "",
        messages:
          "Really nice hosts. Really nice place. Service was perfect.Everything was perfect and amazing experience and landscapes! :). We loved this really. A great experience, great hospitality and a warm & cozy yurt - even when it was cold outside.",
        score: 5,
      },
      {
        date: "2018-04-02",
        name: "Thomas & Camilla",
        gmail: "Sweden",
        messages:
          "En underbar afton vid Aralsjön! Gästfriheten vet inga gränser, god mat, mycket mot och excellent Karakalpakstansk vodka :) Sarsenbay är en perfekt värd/guide!",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "Frau Rainer und Markus",
        gmail: "Sweden",
        messages:
          "Sehnsüger Ausflug an den Aralsee! Super Reiseleiter und Fahrer. Alles wunderbar, wir kommen gerne wieder. Sehr eindrucksvoll hier in Karakalpakstan.",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "同海王",
        gmail: "",
        messages:
          "大家好，欢迎来到咸海。我是在此工作8年的中国人“咸海王”，每年要在此工作4-6个月，很荣幸和知名旅行公司成为邻居。如果有中国朋友要介绍朋友或者生意中的主人公，希望来咸海旅游的中国朋友请联系我，想更多了解咸海可加我微信或电话：乌兹电话: +99899 9686518 国内电: 186130543232",
        score: 5,
      },
      {
        date: "апрель 2018",
        name: "Дмитрий",
        gmail: "Москва",
        messages:
          "Огромное спасибо сотрудникам турбазы и людям за гостеприимство. Получили огромное удовольствие от общения с такими замечательными людьми. Спасибо за это открытие для нас Арал!",
        score: 5,
      },
      {
        date: "13.04.2018",
        name: "Друг из Владикавказа",
        gmail: "",
        messages:
          "Спасибо огромное за гостеприимство! Очень понравился прием и организованность лагеря. Радушие и теплое отношение всех. О киме ли ветер – тишина здесь. Нам нужно еще побывать у вас. Рассмотрели друзей, о прекрасно проведенном времени.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Анна Сергеевна Иванова",
        gmail: "",
        messages:
          "Отзыв о туре 'Нукус – Муйнак – Плато Устюрт – Аральское море': 'Этот тур оказался для меня настоящим открытием! С самого утра нас забрали из Нукуса, и началось наше путешествие по местам, которые буквально дышат историей. Кладбище кораблей в Муйнаке оставляет неизгладимое впечатление – когда-то здесь было море, а теперь на сухом дне стоят забытые корабли, что заставляет задуматься о масштабах природных изменений. Музеи в Муйнаке погружают в историю региона и трагедию Арала. Особенно запомнилась поездка через плато Устюрт – такие виды сложно описать словами. Местные каньоны, кладбище кочевников – всё это делает маршрут по-настоящему уникальным. Природа здесь потрясающая, и каждый момент хотелось запечатлеть на камеру. День завершился на берегу Аральского моря, где можно было искупаться и собирать ракушки. Юртовый лагерь на берегу – это отдельная магия. Ужин в традиционной обстановке, а затем ночь в уютной юрте под звёздами – идеальное завершение такого насыщенного дня. Большое спасибо команде за этот потрясающий опыт. Рекомендую всем, кто хочет прикоснуться к уникальной истории и природе этой области!",
        score: 5,
      },
      {
        date: "30.07.2023",
        name: "Beth W",
        gmail: "bethwison1991@gmail.com",
        messages:
          "We did not book a tour with a guide. We used the company for having the driver only to take us to the Ship Graveyard.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Janusz Tylus",
        gmail: "",
        messages:
          "Grupa z Polski, podróżnicy TOP TURYSTYKA Super miejscówka, niezwykła gościnność, wielogwiazdkowy camp pod gwiazdami. Było super! Bardzo miłe miejsce ♥ Astelie Eryk Kwasnica PS.Pan w agregacie WYMlATA:) Brestowice",
        score: 5,
      },

      {
        date: "",
        name: "Lisa & Alexander",
        gmail: "Liebe Grüße",
        messages:
          "Auf die Freude der Natur und die Gesellschaft der Menschen im Jurten Camp beim Mal See. Wir haben die Zeit sehr genossen, wurden sehr umsorgt, gut & korrekt informiert, und die Sonne hat uns allen das Aufstehen versüßt. Danke für alles!",
        score: 5,
      },
      {
        date: "14.04.2018",
        name: "Simon & Natasha",
        gmail: "Switzerland / Russia",
        messages:
          "Very nice camp with competent staff and lots of anecdotes! It’s sad to see to what level the Aral Sea shrunk and hope that the government starts taking action. Good Luck",
        score: 4,
      },
      {
        date: "April 15, 2018",
        name: "Marc, Jennifer,Lucas & Alexis",
        gmail: "Michigan, USA",
        messages:
          "Thank you for the great visit to the Aral Sea. The Yurt Camp was very comfortable and pleasant. Our family enjoyed the friendly atmosphere and comfortable accommodations. Thank you",
        score: 5,
      },
      {
        date: "12-16 августа 2019",
        name: "Den Garage",
        gmail: "БЕНЗИН И ГРЕЧА",
        messages:
          "Идеальный хостел для путешествующих на двух колесах и не только.Удачно расположен в центре и чуть в стороне от шумных улиц. Как только открываешь дверь, и заканчивай свой trip— всё начинает нравиться! Ковровое покрытие под капотом в комнате, выходное место пространства. В шкатках всё очень тщательно обустроено, нет ничего лишнего. В хостеле все отлично функционирует, никаких поломанных кранов и неисправных розеток… и так далее. А самое главное – это расположение администраторов и персонала.Мне не хотелось бы забыть, но не хотелось бы останавливаться с недугом в Besqala. Пожалуй, достаточно отзыв и завтрак индуский!",
        score: 5,
      },
      {
        date: "09.09.19",
        name: "Isabelle",
        gmail: "France",
        messages:
          "Super séjour à Nukus et à l’Aral Sea (impressionnant à voir). Expérience à faire : se baigner dans le lac et avoir les pieds pleins de boue. Équipe au petit soin, vraiment top ! Merci à Tazabay et à son équipe.Merci Taschkent (petit clin d’œil à mon guide K.)",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Antoine PELLERIN ",
        gmail: "",
        messages:
          "Excellent keeper Diana to his camp Elena & Vova. A magnificent piece of scenography. The beautiful desert & skies. Thanks a lot for this great moment for us.",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Annika,Viki ",
        gmail: "Germany,Hungary",
        messages:
          "We had a fantastic stay thanks to the warm hospitality of the team – and fun despite the noisy tourist group next door!",
        score: 5,
      },
      {
        date: "11.05.2026",
        name: "Liza Raitina",
        gmail: "",
        messages: "Нам тур понравился на 10 из 10. Особенная благодарность водителю - он просто гуру вождения вне трассы. Из пожеланий по улучшению: я бы озвучила аудиогид живым голосом вместо робота. Возможно, также можно добавить для желающих более расширенный контент, особенно с учетом долгой дороги. В остальном нам все очень понравилось, спасибо вам большое за помощь и организацию.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Jill Heyde",
        gmail: "",
        messages: "We just returned from an Aral Sea trip with Rakhmet. It was very interesting. We are not comfortable with video. Would you mind sending us the questions in writing?",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Gioacchino Pagano",
        gmail: "",
        messages: "The trip was very beautiful, especially with Max as guide. You did a great choice to suggest us him.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Martina & Manfred",
        gmail: "",
        messages: "We had a wonderful tour to the Besqala Aral camp. We spent two nights in the camp. All things are very well organized. The food was very good and the ladies were very friendly and helpful. The yurts were comfortable and clean. Our driver Muchtar was a very good driver, always driving safely on difficult off-road routes. One suggestion: switch off the camp light for an hour at night so guests can better enjoy the stars.",
        score: 5,
      },
      {
        date: "24.05.2026",
        name: "Ola Jodyna",
        gmail: "",
        messages: "It was a wonderful, well-organized adventure. We were picked up punctually from our hotel by a friendly driver. The vehicle was exactly as promised, equipped with air conditioning and 4WD. The scenery was stunning and unforgettable. The yurts were clean and the food was delicious. The optional excursion to the edge of the plateau was absolutely worth it.",
        score: 5,
      },
      {
        date: "26.05.2026",
        name: "Alessandro",
        gmail: "",
        messages: "The tour was beautiful and very touching. Even though the car broke down, the staff quickly found an alternative solution. Our guide Azat was amazing and exceeded all expectations. Everything was perfect and we highly recommend this experience.",
        score: 5,
      },
      {
        date: "29.05.2026",
        name: "Симоне Донди",
        gmail: "",
        messages: "Не могу назвать ничего отрицательного. Отличный водитель, своевременные остановки, позволившие насладиться местами, отличная и обильная еда.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Katia",
        gmail: "",
        messages: "I loved both of my trips with Besqala. The Aral Sea is a place worth seeing and the fortresses of ancient Khorezm are unique. Drivers were knowledgeable and attentive. If I had to suggest one improvement, it would be providing a clearer schedule and more information about stop durations.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Sibylle Kiss",
        gmail: "",
        messages: "We had 3 great days at the Aral Sea.",
        score: 5,
      },
      {
        date: "09.06.2026",
        name: "Крейдина Алиса",
        gmail: "",
        messages: "Хотела сказать вашей организации огромное спасибо за организацию тура, все было супер! Один из лучших опытов в моей жизни.",
        score: 5,
      }
    ],
    img: [
      "img/eco-tour-3day/tourimg/40",
      "img/eco-tour-3day/tourimg/1",
      "img/eco-tour-3day/tourimg/2",
      "img/eco-tour-3day/tourimg/3",
      "img/eco-tour-3day/tourimg/4",
      "img/eco-tour-3day/tourimg/5",
      "img/eco-tour-3day/tourimg/6",
      "img/eco-tour-3day/tourimg/7",
      "img/eco-tour-3day/tourimg/8",
      "img/eco-tour-3day/tourimg/9",
      "img/eco-tour-3day/tourimg/10",
      "img/eco-tour-3day/tourimg/11",
      "img/eco-tour-3day/tourimg/12",
      "img/eco-tour-3day/tourimg/13",
      "img/eco-tour-3day/tourimg/14",
      "img/eco-tour-3day/tourimg/15",
      "img/eco-tour-3day/tourimg/16",
      "img/eco-tour-3day/tourimg/17",
      "img/eco-tour-3day/tourimg/18",
      "img/eco-tour-3day/tourimg/19",
      "img/eco-tour-3day/tourimg/20",
      "img/eco-tour-3day/tourimg/21",
      "img/eco-tour-3day/tourimg/22",
      "img/eco-tour-3day/tourimg/23",
      "img/eco-tour-3day/tourimg/24",
      "img/eco-tour-3day/tourimg/25",
      "img/eco-tour-3day/tourimg/26",
      "img/eco-tour-3day/tourimg/27",
      "img/eco-tour-3day/tourimg/28",
      "img/eco-tour-3day/tourimg/29",
      "img/eco-tour-3day/tourimg/30",
      "img/eco-tour-3day/tourimg/31",
      "img/eco-tour-3day/tourimg/32",
      "img/eco-tour-3day/tourimg/33",
      "img/eco-tour-3day/tourimg/34",
      "img/eco-tour-3day/tourimg/35",
      "img/eco-tour-3day/tourimg/36",
      "img/eco-tour-3day/tourimg/37",
      "img/eco-tour-3day/tourimg/38",
      "img/eco-tour-3day/tourimg/39",
      "img/eco-tour-3day/tourimg/41",
      "img/eco-tour-3day/tourimg/42",
      "img/eco-tour-3day/tourimg/43",
      "img/eco-tour-3day/tourimg/44",
      "img/eco-tour-3day/tourimg/45",
      "img/eco-tour-3day/tourimg/46",
      "img/eco-tour-3day/tourimg/47",
      "img/eco-tour-3day/tourimg/48",
      "img/eco-tour-3day/tourimg/49",
      "img/eco-tour-3day/tourimg/50",
      "img/eco-tour-3day/tourimg/51",
      "img/eco-tour-3day/tourimg/52"
    ],
  },
  {
    id: 4,
    price: "275",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "695"
      },
      {
        id: 2,
        persons: "2",
        price: "830"
      },
      {
        id: 3,
        persons: "3",
        price: "965"
      },
      {
        id: 4,
        persons: "4",
        price: "1100"
      },

    ],
    srcitinerary: "img/eco-tour-3day/itinerary/rus",
    maxamount: "100+",
    category: "Aral",
    category1: "Top",
    tourlang: "rus",
    name: "Эко-тур на Аральское море",
    dayDuration: "(3 дня и 2 ночи)",
    aboutTour: "Откройте для себя Каракалпакстан: бескрайние каньоны, легендарное Аральское море и крепости древних цивилизаций",
    unitDay: "3",
    unitNight: "2",
    country: "11",
    startCountry: "Нукус",
    endCountry: "Нукус",
    mapstext1: "Более 900 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус-Муйнак-Плато Устюрт-- Кладбище кочевников - Аральское море - Курганча Кала  - Кунти Баба - Каньоны Актумсык - Кубла Устюрт - Озеро Судочье - Солончак Барсакельмес - Миздакхан - Нукус",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт: Полноприводный внедоронжик;"
      },
      {
        class: "fa fa-cutlery",
        text: "Питание: 7 раза;"
      },
      {
        class: "fa fa-bed",
        text: "Проживание: 2 ночи в Юртовом лагере; "
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-globe",
        text: "Чаевые;"
      },
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Нукус-Хива Трансфер",
        price: "70"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "215"
      },
    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Приключение начинается в Нукусе",
            timeDistination: "Добро пожаловать в Каракалпакстан — край, где степь тянется за горизонт, где каждый холм шепчет истории прошлого, и где сама тишина говорит громче любых слов. Вы оказались в самом сердце Центральной Азии — месте, где природа и культура переплелись на протяжении веков, создав мир, не похожий ни на какой другой на Земле.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-3day/daysimg/1-08-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Муйнак — город-порт ушедшего Аральского моря",
            timeDistination: "Вы посетите Муйнак — город, который в прошлом был крупным портом Аральского моря и центром рыболовства, увидите Кладбище кораблей Муйнака и побываете в Муйнакский государственный краеведческий музей, где через экспозиции и документальный фильм раскрывается история Арала и жизнь города.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-3day/daysimg/1-11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Обед",
            timeDistination: "Обед в уютном Гостевом доме, где отведаете горячие блюда из местной кухни.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:00",
            timeName: "Там, где было море: путь к каньонам Устюрта",
            timeDistination: "Маршрут проходит по дну ушедшего Аральского моря, где перед вами откроются необычные и сурово-красивые пейзажи бывшего морского пространства. По пути предусмотрены остановки для фотосъёмки — вы сможете запечатлеть уникальный ландшафт и величественные каньоны плато Устюрт. Здесь вы узнаете больше о древней истории региона и сделаете краткую остановку у кладбища кочевников — немого свидетеля жизни людей, веками населявших эти земли.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Устюрт",
            locationSrc: "https://maps.app.goo.gl/edkUA1k6bRFLELzN6",
            img: "img/eco-tour-3day/daysimg/1-14-00"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Кладбище кочевников на плато Устюрт",
            timeDistination: "Вы посетите кладбище кочевников на плато Устюрт — краткую остановку в пути среди сурового и выразительного ландшафта. Место хранящее следы жизни людей, которые веками кочевали по этим землям",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Плато Устюрт",
            locationSrc: "https://maps.app.goo.gl/bMriUXdZQD85aNXv5",
            img: "img/eco-tour-3day/daysimg/1-16-00"
          },
          {
            timeid: "6",
            time: "17:00",
            timeName: "Встреча с Аральским морем",
            timeDistination: "Вы окажетесь на берегу Аральского моря, где в сезон можно искупаться, прогуляться вдоль воды и собрать ракушки, наслаждаясь тишиной и особой атмосферой этого места.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аральское море",
            locationSrc: "https://maps.app.goo.gl/8UMc14PqDxubXGah7",
            img: "img/eco-tour-3day/daysimg/1-17-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Ночь в юртовом лагере у Аральского моря",
            timeDistination: "День завершается в уютном юртовом лагере на берегу Аральского моря. Вас ждёт ужин в традиционной атмосфере и ночь в комфортной юрте, создающие особое ощущение тишины и уединения. В лагере оборудованы душ с чистой пресной водой и уборная для удобства гостей.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Юртовый лагерь",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/1-18-00"
          },
        ],
      },
      {
        id: "day2",
        nameDay: "День 2",
        times: [
          {
            timeid: "1",
            time: "04:00",
            timeName: "Рассвет над Аральским морем",
            timeDistination: "Ранний подъем даст возможность наблюдать за восхитительным рассветом над бескрайным морем и дает старт нашей экскурсии.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аральское море",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/2-04-00"
          },
          {
            timeid: "2",
            time: "08:30",
            timeName: "Курганча-кала — городище Великого шёлкового пути",
            timeDistination: "Обратный путь проходит по историческим городищам с нового ракурса. В программе — посещение Курганча-кала (XII–XIV вв.), укреплённой торговой фактории, располагавшейся на одном из маршрутов Великого шёлкового пути.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Курганча-кала",
            locationSrc: "https://maps.app.goo.gl/Z2ZShskvfvphyFLJ6",
            img: "img/eco-tour-3day/daysimg/2-08-30"
          },
          {
            timeid: "3",
            time: "09:30",
            timeName: "Кунти Баба и каменные ландшафты плато",
            timeDistination: "Остановка у кладбища кочевников Кунти Баба. Далее маршрут продолжается по спуску с плато по естественной тропе, проходящей среди впечатляющих скальных образований. Здесь вы увидите каменные останцы необычной формы, выточенные ветром и временем, а также каньоны и обрывы, создающие ощущение природного парка скульптур. С высоты открываются панорамные виды на окрестности и пространство бывшего Аральского моря — одно из самых фотогеничных мест маршрута.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Кунти Баба",
            locationSrc: "https://yandex.uz/maps/-/CLxaQBI4",
            img: "img/eco-tour-3day/daysimg/2-09-30"
          },

          {
            timeid: "4",
            time: "13:00",
            timeName: "Обед",
            timeDistination: "Обед в юртовом лагере",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Юртовый лагерь",
            locationSrc: "https://maps.app.goo.gl/i9vw3PtnoeTdrW5j9",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "5",
            time: "14:00",
            timeName: "Каньоны и марсианский ландшафт Актумсыка",
            timeDistination: "Путешествие продолжается к мысу Актумсык — месту, где ландшафт поражает своей формой и масштабом. Здесь вы пройдёте пешком среди высоких каньонов и марсианских пейзажей, будто сошедших с другой планеты, увидите таинственную пещеру и каменные плиты, сложенные временем, как страницы забытой хроники. Затем путь приведёт вас к берегу моря, где можно прогуляться по пляжу и, в сезон, искупаться в воде. День завершается возвращением в юртовый лагерь Besqala, где вас вновь окружат тишина и покой степи.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Актумсык",
            locationSrc: "https://maps.app.goo.gl/i9vw3PtnoeTdrW5j9",
            img: "img/eco-tour-3day/daysimg/2-14-00"
          },
          {
            timeid: "6",
            time: "19:00",
            timeName: "Традиционный ужин и звёздное небо",
            timeDistination: "Вечер проходит за ужином в традиционном стиле. После него можно понаблюдать за звёздами под открытым небом, оставаясь наедине с тишиной, простором и особой атмосферой этого места.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Юртовый лагерь",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
        ],
      },
      {
        id: "day3",
        nameDay: "День 3",
        times: [
          {
            timeid: "1",
            time: "06:00",
            timeName: "Встреча рассвета ",
            timeDistination: "Ранний подъем для встречи рассвета окрасивший море в нежные оттенки. ",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Юртовый лагерь",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-3day/daysimg/3-06-00"
          },
          {
            timeid: "2",
            time: "09:30",
            timeName: "Кубла-Устюрт — самый отдалённый посёлок региона",
            timeDistination: "Следующая остановка — Кубла-Устюрт, один из самых отдалённых посёлков региона, построенный в советский период. Здесь вы сделаете остановку у взлётной полосы того времени и сможете запечатлеть интересные сооружения на фоне спокойного деревенского пейзажа.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Кубла-Устюрт",
            locationSrc: "https://maps.app.goo.gl/fgJcT7tVj5fqgw5Z8",
            img: "img/eco-tour-3day/daysimg/3-09-30"
          },
          {
            timeid: "3",
            time: "11:00",
            timeName: "Озеро Судочье и покинутый посёлок Урга",
            timeDistination: "Вы посетите старый маяк, огонь которого в прошлом указывал путь к посёлку Урга. Далее по крутому спуску маршрут ведёт в покинутый рыбацкий посёлок Урга, расположенный у озера Судочье. Это озеро является местом остановки мигрирующих птиц — здесь можно увидеть розовых фламинго, пеликанов, уток, гусей и лебедей.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Озеро Судочье",
            locationSrc: "https://maps.app.goo.gl/myjzm7QPfxEx3KMu8",
            img: "img/eco-tour-3day/daysimg/3-11-00"
          },
          {
            timeid: "4",
            time: "12:30",
            timeName: "Солончак Барсакелмес",
            timeDistination: "Далее маршрут ведёт к солончаку Барсакелмес — огромному солёному озеру, напоминающему знаменитые солончаки Боливии и сохранившемуся со времён древнего океана Тетис. Здесь пространство и свет создают особую оптическую игру, а пейзажи открывают идеальные условия для по-настоящему уникальных фотографий.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Барсакелмес",
            locationSrc: "https://maps.app.goo.gl/WDepughP8HpwsN8g8",
            img: "img/eco-tour-3day/daysimg/3-12-30"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе в городе Кунград.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Кунград",
            locationSrc: "https://maps.app.goo.gl/jQfnM29Lkt8UTzdE8",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "16:00",
            timeName: "Миздакхан — сакральный комплекс",
            timeDistination: "Путешествие продолжается посещением исторического и священного комплекса Миздакхан (IV–II вв. до н.э., XIII–XVI вв.). В программе — осмотр мавзолеев Мазлумхан Сулу, Халифа Ережеп и Шамун Наби, а также городища Гяур-кала — памятника эпохи зороастризма (IV–III вв. до н.э.).",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ходжели",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/eco-tour-3day/daysimg/3-16-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Возвращение в Нукус",
            timeDistination: "Завершаем экстрим-тур возвращением в город Нукус, где заканчивается насыщенное путешествие по самым удалённым и уникальным уголкам региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-3day/daysimg/1-08-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=102NWQJAItnER0bWiJ3wyJtqJl8Kv0y8&ehbc=2E312F&noprof=1",
    feedback: [
      {
        date: "",
        name: "Louisa & Kieran",
        gmail: "",
        messages:
          "Really well looked after, made sure we were warm & well fed.A beautiful place to camp and an incredible experience for a good night’s sleep.We recommend the vodka!",
        score: 5,
      },
      {
        date: "",
        name: "Sandro",
        gmail: "",
        messages:
          "Really nice hosts. Really nice place. Service was perfect.Everything was perfect and amazing experience and landscapes! :). We loved this really. A great experience, great hospitality and a warm & cozy yurt - even when it was cold outside.",
        score: 5,
      },
      {
        date: "2018-04-02",
        name: "Thomas & Camilla",
        gmail: "Sweden",
        messages:
          "En underbar afton vid Aralsjön! Gästfriheten vet inga gränser, god mat, mycket mot och excellent Karakalpakstansk vodka :) Sarsenbay är en perfekt värd/guide!",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "Frau Rainer und Markus",
        gmail: "Sweden",
        messages:
          "Sehnsüger Ausflug an den Aralsee! Super Reiseleiter und Fahrer. Alles wunderbar, wir kommen gerne wieder. Sehr eindrucksvoll hier in Karakalpakstan.",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "同海王",
        gmail: "",
        messages:
          "大家好，欢迎来到咸海。我是在此工作8年的中国人“咸海王”，每年要在此工作4-6个月，很荣幸和知名旅行公司成为邻居。如果有中国朋友要介绍朋友或者生意中的主人公，希望来咸海旅游的中国朋友请联系我，想更多了解咸海可加我微信或电话：乌兹电话: +99899 9686518 国内电: 186130543232",
        score: 5,
      },
      {
        date: "апрель 2018",
        name: "Дмитрий",
        gmail: "Москва",
        messages:
          "Огромное спасибо сотрудникам турбазы и людям за гостеприимство. Получили огромное удовольствие от общения с такими замечательными людьми. Спасибо за это открытие для нас Арал!",
        score: 5,
      },
      {
        date: "13.04.2018",
        name: "Друг из Владикавказа",
        gmail: "",
        messages:
          "Спасибо огромное за гостеприимство! Очень понравился прием и организованность лагеря. Радушие и теплое отношение всех. О киме ли ветер – тишина здесь. Нам нужно еще побывать у вас. Рассмотрели друзей, о прекрасно проведенном времени.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Анна Сергеевна Иванова",
        gmail: "",
        messages:
          "Отзыв о туре 'Нукус – Муйнак – Плато Устюрт – Аральское море': 'Этот тур оказался для меня настоящим открытием! С самого утра нас забрали из Нукуса, и началось наше путешествие по местам, которые буквально дышат историей. Кладбище кораблей в Муйнаке оставляет неизгладимое впечатление – когда-то здесь было море, а теперь на сухом дне стоят забытые корабли, что заставляет задуматься о масштабах природных изменений. Музеи в Муйнаке погружают в историю региона и трагедию Арала. Особенно запомнилась поездка через плато Устюрт – такие виды сложно описать словами. Местные каньоны, кладбище кочевников – всё это делает маршрут по-настоящему уникальным. Природа здесь потрясающая, и каждый момент хотелось запечатлеть на камеру. День завершился на берегу Аральского моря, где можно было искупаться и собирать ракушки. Юртовый лагерь на берегу – это отдельная магия. Ужин в традиционной обстановке, а затем ночь в уютной юрте под звёздами – идеальное завершение такого насыщенного дня. Большое спасибо команде за этот потрясающий опыт. Рекомендую всем, кто хочет прикоснуться к уникальной истории и природе этой области!",
        score: 5,
      },
      {
        date: "30.07.2023",
        name: "Beth W",
        gmail: "bethwison1991@gmail.com",
        messages:
          "We did not book a tour with a guide. We used the company for having the driver only to take us to the Ship Graveyard.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Janusz Tylus",
        gmail: "",
        messages:
          "Grupa z Polski, podróżnicy TOP TURYSTYKA Super miejscówka, niezwykła gościnność, wielogwiazdkowy camp pod gwiazdami. Było super! Bardzo miłe miejsce ♥ Astelie Eryk Kwasnica PS.Pan w agregacie WYMlATA:) Brestowice",
        score: 5,
      },

      {
        date: "",
        name: "Lisa & Alexander",
        gmail: "Liebe Grüße",
        messages:
          "Auf die Freude der Natur und die Gesellschaft der Menschen im Jurten Camp beim Mal See. Wir haben die Zeit sehr genossen, wurden sehr umsorgt, gut & korrekt informiert, und die Sonne hat uns allen das Aufstehen versüßt. Danke für alles!",
        score: 5,
      },
      {
        date: "14.04.2018",
        name: "Simon & Natasha",
        gmail: "Switzerland / Russia",
        messages:
          "Very nice camp with competent staff and lots of anecdotes! It’s sad to see to what level the Aral Sea shrunk and hope that the government starts taking action. Good Luck",
        score: 4,
      },
      {
        date: "April 15, 2018",
        name: "Marc, Jennifer,Lucas & Alexis",
        gmail: "Michigan, USA",
        messages:
          "Thank you for the great visit to the Aral Sea. The Yurt Camp was very comfortable and pleasant. Our family enjoyed the friendly atmosphere and comfortable accommodations. Thank you",
        score: 5,
      },
      {
        date: "12-16 августа 2019",
        name: "Den Garage",
        gmail: "БЕНЗИН И ГРЕЧА",
        messages:
          "Идеальный хостел для путешествующих на двух колесах и не только.Удачно расположен в центре и чуть в стороне от шумных улиц. Как только открываешь дверь, и заканчивай свой trip— всё начинает нравиться! Ковровое покрытие под капотом в комнате, выходное место пространства. В шкатках всё очень тщательно обустроено, нет ничего лишнего. В хостеле все отлично функционирует, никаких поломанных кранов и неисправных розеток… и так далее. А самое главное – это расположение администраторов и персонала.Мне не хотелось бы забыть, но не хотелось бы останавливаться с недугом в Besqala. Пожалуй, достаточно отзыв и завтрак индуский!",
        score: 5,
      },
      {
        date: "09.09.19",
        name: "Isabelle",
        gmail: "France",
        messages:
          "Super séjour à Nukus et à l’Aral Sea (impressionnant à voir). Expérience à faire : se baigner dans le lac et avoir les pieds pleins de boue. Équipe au petit soin, vraiment top ! Merci à Tazabay et à son équipe.Merci Taschkent (petit clin d’œil à mon guide K.)",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Antoine PELLERIN ",
        gmail: "",
        messages:
          "Excellent keeper Diana to his camp Elena & Vova. A magnificent piece of scenography. The beautiful desert & skies. Thanks a lot for this great moment for us.",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Annika,Viki ",
        gmail: "Germany,Hungary",
        messages:
          "We had a fantastic stay thanks to the warm hospitality of the team – and fun despite the noisy tourist group next door!",
        score: 5,
      },
      {
        date: "11.05.2026",
        name: "Liza Raitina",
        gmail: "",
        messages: "Нам тур понравился на 10 из 10. Особенная благодарность водителю - он просто гуру вождения вне трассы. Из пожеланий по улучшению: я бы озвучила аудиогид живым голосом вместо робота. Возможно, также можно добавить для желающих более расширенный контент, особенно с учетом долгой дороги. В остальном нам все очень понравилось, спасибо вам большое за помощь и организацию.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Jill Heyde",
        gmail: "",
        messages: "We just returned from an Aral Sea trip with Rakhmet. It was very interesting. We are not comfortable with video. Would you mind sending us the questions in writing?",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Gioacchino Pagano",
        gmail: "",
        messages: "The trip was very beautiful, especially with Max as guide. You did a great choice to suggest us him.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Martina & Manfred",
        gmail: "",
        messages: "We had a wonderful tour to the Besqala Aral camp. We spent two nights in the camp. All things are very well organized. The food was very good and the ladies were very friendly and helpful. The yurts were comfortable and clean. Our driver Muchtar was a very good driver, always driving safely on difficult off-road routes. One suggestion: switch off the camp light for an hour at night so guests can better enjoy the stars.",
        score: 5,
      },
      {
        date: "24.05.2026",
        name: "Ola Jodyna",
        gmail: "",
        messages: "It was a wonderful, well-organized adventure. We were picked up punctually from our hotel by a friendly driver. The vehicle was exactly as promised, equipped with air conditioning and 4WD. The scenery was stunning and unforgettable. The yurts were clean and the food was delicious. The optional excursion to the edge of the plateau was absolutely worth it.",
        score: 5,
      },
      {
        date: "26.05.2026",
        name: "Alessandro",
        gmail: "",
        messages: "The tour was beautiful and very touching. Even though the car broke down, the staff quickly found an alternative solution. Our guide Azat was amazing and exceeded all expectations. Everything was perfect and we highly recommend this experience.",
        score: 5,
      },
      {
        date: "29.05.2026",
        name: "Симоне Донди",
        gmail: "",
        messages: "Не могу назвать ничего отрицательного. Отличный водитель, своевременные остановки, позволившие насладиться местами, отличная и обильная еда.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Katia",
        gmail: "",
        messages: "I loved both of my trips with Besqala. The Aral Sea is a place worth seeing and the fortresses of ancient Khorezm are unique. Drivers were knowledgeable and attentive. If I had to suggest one improvement, it would be providing a clearer schedule and more information about stop durations.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Sibylle Kiss",
        gmail: "",
        messages: "We had 3 great days at the Aral Sea.",
        score: 5,
      },
      {
        date: "09.06.2026",
        name: "Крейдина Алиса",
        gmail: "",
        messages: "Хотела сказать вашей организации огромное спасибо за организацию тура, все было супер! Один из лучших опытов в моей жизни.",
        score: 5,
      }
    ],
    img: [
      "img/eco-tour-3day/tourimg/40",
      "img/eco-tour-3day/tourimg/1",
      "img/eco-tour-3day/tourimg/2",
      "img/eco-tour-3day/tourimg/3",
      "img/eco-tour-3day/tourimg/4",
      "img/eco-tour-3day/tourimg/5",
      "img/eco-tour-3day/tourimg/6",
      "img/eco-tour-3day/tourimg/7",
      "img/eco-tour-3day/tourimg/8",
      "img/eco-tour-3day/tourimg/9",
      "img/eco-tour-3day/tourimg/10",
      "img/eco-tour-3day/tourimg/11",
      "img/eco-tour-3day/tourimg/12",
      "img/eco-tour-3day/tourimg/13",
      "img/eco-tour-3day/tourimg/14",
      "img/eco-tour-3day/tourimg/15",
      "img/eco-tour-3day/tourimg/16",
      "img/eco-tour-3day/tourimg/17",
      "img/eco-tour-3day/tourimg/18",
      "img/eco-tour-3day/tourimg/19",
      "img/eco-tour-3day/tourimg/20",
      "img/eco-tour-3day/tourimg/21",
      "img/eco-tour-3day/tourimg/22",
      "img/eco-tour-3day/tourimg/23",
      "img/eco-tour-3day/tourimg/24",
      "img/eco-tour-3day/tourimg/25",
      "img/eco-tour-3day/tourimg/26",
      "img/eco-tour-3day/tourimg/27",
      "img/eco-tour-3day/tourimg/28",
      "img/eco-tour-3day/tourimg/29",
      "img/eco-tour-3day/tourimg/30",
      "img/eco-tour-3day/tourimg/31",
      "img/eco-tour-3day/tourimg/32",
      "img/eco-tour-3day/tourimg/33",
      "img/eco-tour-3day/tourimg/34",
      "img/eco-tour-3day/tourimg/35",
      "img/eco-tour-3day/tourimg/36",
      "img/eco-tour-3day/tourimg/37",
      "img/eco-tour-3day/tourimg/38",
      "img/eco-tour-3day/tourimg/39",
      "img/eco-tour-3day/tourimg/41",
      "img/eco-tour-3day/tourimg/42",
      "img/eco-tour-3day/tourimg/43",
      "img/eco-tour-3day/tourimg/44",
      "img/eco-tour-3day/tourimg/45",
      "img/eco-tour-3day/tourimg/46",
      "img/eco-tour-3day/tourimg/47",
      "img/eco-tour-3day/tourimg/48",
      "img/eco-tour-3day/tourimg/49",
      "img/eco-tour-3day/tourimg/50",
      "img/eco-tour-3day/tourimg/51",
      "img/eco-tour-3day/tourimg/52"
    ],
  },
  {
    id: 5,
    price: "30",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "90"
      },
      {
        id: 2,
        persons: "2",
        price: "90"
      },
      {
        id: 3,
        persons: "3",
        price: "90"
      },
      {
        id: 4,
        persons: "4",
        price: "185"
      },
    ],
    srcitinerary: "img/tourmuynak/itinerary/eng",
    maxamount: "100+",
    category: "Aral",
    category1: "",
    tourlang: "eng",
    name: "Muynak Tour — to the shores of the dried Aral Sea",
    dayDuration: "(1 days)",
    aboutTour: "The day trip to one of the world's most haunting ecological sites — the dried Aral Sea",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Over 400 км",
    mapstext2: "Tour season: Year-round",
    description: "Nukus - Muynak - Cemetery of Ships - Mizdakhan - Gaur Kala - Nukus",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: Sedan / Minibus;"
      },

      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance tickets;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional Guide",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "The adventure begins in Nukus",
            timeDistination: "Welcome to Karakalpakstan — a land where the steppe stretches beyond the horizon, where every hill whispers stories of the past, and where silence itself speaks louder than words. You find yourself in the very heart of Central Asia, where nature and culture have intertwined over centuries, creating a world unlike any other on Earth.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/tourmuynak/daysimg/08-30"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Muynak — the former port city of the Aral Sea",
            timeDistination: "You will visit the Ship Cemetery — one of the most recognizable landmarks of Muynak. The vessels left on the sand stand as silent reminders of a time when the city was a major port of the Aral Sea and a center of fishing. Today, it is a symbol of a vanished maritime era and one of the most impressive stops on the route.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/7ekTCKuC6PZLKN6t7",
            img: "img/tourmuynak/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "12:30",
            timeName: "History of Muynak and the Aral Sea",
            timeDistination: "You will then visit the Muynak Museum, where exhibitions and a short documentary film reveal the history of the Aral Sea and the life of the city during its years of prosperity. The museum helps to better understand Muynak’s past and the scale of changes that have taken place in the region.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/F1sYnxeXyAqDY5qK8",
            img: "img/tourmuynak/daysimg/12-30"
          },
          {
            timeid: "4",
            time: "13:30",
            timeName: "Lunch",
            timeDistination: "Lunch at a cozy guesthouse, where you will enjoy hot dishes of traditional local cuisine.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/tourmuynak/daysimg/lunch"
          },
          {
            timeid: "5",
            time: "17:00",
            timeName: "Mizdahkan — a sacred complex",
            timeDistination: "In Khodjeyli, we stop at the Mizdahkan architectural complex — one of the most significant historical sites in the region. Here you will see the mausoleums of Nazlumkhansulu (12th–14th centuries), Khalifa Erejep (12th century), and Shamun Nabi (19th century), each reflecting a distinct stage in the history of these lands.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/tourmuynak/daysimg/17-00"
          },
          {
            timeid: "6",
            time: "18:00",
            timeName: "Gaur-Kala ancient settlement",
            timeDistination: "A separate stop is made at the ruins of Gaur-Kala — an ancient settlement dating back to the Zoroastrian era (6th century BCE – 9th century CE). These stone remains add a sense of depth and time to the journey, revealing the rich, layered history of the region.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/5LJrJXpi6LX7jgaK7",
            img: "img/tourmuynak/daysimg/18-00"
          },
          {
            timeid: "7",
            time: "19:00",
            timeName: "Return to Nukus",
            timeDistination: "The extreme tour concludes with a return to Nukus, marking the end of an intense journey through some of the most remote and unique places in the region.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/tourmuynak/daysimg/08-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1yVYOKXdz8odW3dSsUjmXwwuUJUrrWG4&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/tourmuynak/tourimg/3",
      "img/tourmuynak/tourimg/4",
      "img/tourmuynak/tourimg/10",
      "img/tourmuynak/tourimg/6",
      "img/tourmuynak/tourimg/1",
      "img/tourmuynak/tourimg/2",
      "img/tourmuynak/tourimg/5",
      "img/tourmuynak/tourimg/7",
      "img/tourmuynak/tourimg/8",
      "img/tourmuynak/tourimg/9",
      "img/tourmuynak/tourimg/11",
      "img/tourmuynak/tourimg/12",
      "img/tourmuynak/tourimg/13",
      "img/tourmuynak/tourimg/14",
      "img/tourmuynak/tourimg/15",
      "img/tourmuynak/tourimg/16",
      "img/tourmuynak/tourimg/17",
      "img/tourmuynak/tourimg/18",
    ],
  },
  {
    id: 6,
    price: "30",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "90"
      },
      {
        id: 2,
        persons: "2",
        price: "90"
      },
      {
        id: 3,
        persons: "3",
        price: "90"
      },
      {
        id: 4,
        persons: "4",
        price: "185"
      },
    ],
    srcitinerary: "img/tourmuynak/itinerary/rus",
    maxamount: "100+",
    category: "Aral",
    category1: "",
    tourlang: "rus",
    name: "Тур в Муйнак — к берегам осушенного Аральского моря",
    dayDuration: "(1 день)",
    aboutTour: "Однодневная поездка к одному из самых жутких экологических мест в мире — высохшему Аральскому морю",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Нукус",
    endCountry: "Нукус",
    mapstext1: "Более 400 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Муйнак - Кладбище Кораблей - Миздакхан - Гаур Кала - Нукус",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт:Седан/Микроавтобус;"
      },

      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Приключение начинается в Нукусе",
            timeDistination: "Добро пожаловать в Каракалпакстан — край, где степь тянется за горизонт, где каждый холм шепчет истории прошлого, и где сама тишина говорит громче любых слов. Вы оказались в самом сердце Центральной Азии — месте, где природа и культура переплелись на протяжении веков, создав мир, не похожий ни на какой другой на Земле.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/tourmuynak/daysimg/08-30"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Муйнак — город-порт ушедшего Аральского моря",
            timeDistination: "Вы посетите Кладбище кораблей — одно из самых узнаваемых мест Муйнака. Оставленные на песке суда стали молчаливым напоминанием о времени, когда город был крупным портом Аральского моря и центром рыболовства. Сегодня это символ ушедшей морской эпохи и одно из самых впечатляющих мест маршрута.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/7ekTCKuC6PZLKN6t7",
            img: "img/tourmuynak/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "12:30",
            timeName: "История Муйнака и Аральского моря",
            timeDistination: "Далее вы побываете в Муйнакском музее, где через экспозиции и короткометражный документальный фильм раскрывается история Аральского моря и жизнь города в годы его расцвета. Музей помогает глубже понять прошлое Муйнака и масштаб изменений, произошедших в регионе.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/F1sYnxeXyAqDY5qK8",
            img: "img/tourmuynak/daysimg/12-30"
          },
          {
            timeid: "4",
            time: "13:30",
            timeName: "Обед",
            timeDistination: "Обед в уютном Гостевом доме, где отведаете горячие блюда из местной кухни.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Муйнак",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/tourmuynak/daysimg/lunch"
          },
          {
            timeid: "5",
            time: "17:00",
            timeName: "Миздакхан — сакральный комплекс",
            timeDistination: "В Ходжели мы останавливаемся у архитектурного комплекса Миздакхан — одного из самых значимых исторических мест региона. Здесь вы увидите мавзолеи Назлумхансулу (XII–XIV вв.), Халифы Эрежепа (XII в.) и Шамун Наби (XIX в.), каждый из которых отражает отдельный этап в истории этих земель.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ходжели",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/tourmuynak/daysimg/17-00"
          },
          {
            timeid: "6",
            time: "18:00",
            timeName: "Городище Гаур-Кала",
            timeDistination: "Отдельной остановкой станут руины крепости Гаур-Кала — древнего городища, относящегося к эпохе зороастризма (VI в. до н.э. – IX в. н.э.). Эти каменные остатки прошлого добавляют путешествию ощущение глубины времени и позволяют увидеть, насколько многослойна история региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ходжели",
            locationSrc: "https://maps.app.goo.gl/5LJrJXpi6LX7jgaK7",
            img: "img/tourmuynak/daysimg/18-00"
          },
          {
            timeid: "7",
            time: "19:00",
            timeName: "Возвращение в Нукус",
            timeDistination: "Завершаем экстрим-тур возвращением в город Нукус, где заканчивается насыщенное путешествие по самым удалённым и уникальным уголкам региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/tourmuynak/daysimg/08-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1yVYOKXdz8odW3dSsUjmXwwuUJUrrWG4&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/tourmuynak/tourimg/3",
      "img/tourmuynak/tourimg/4",
      "img/tourmuynak/tourimg/10",
      "img/tourmuynak/tourimg/6",
      "img/tourmuynak/tourimg/1",
      "img/tourmuynak/tourimg/2",
      "img/tourmuynak/tourimg/5",
      "img/tourmuynak/tourimg/7",
      "img/tourmuynak/tourimg/8",
      "img/tourmuynak/tourimg/9",
      "img/tourmuynak/tourimg/11",
      "img/tourmuynak/tourimg/12",
      "img/tourmuynak/tourimg/13",
      "img/tourmuynak/tourimg/14",
      "img/tourmuynak/tourimg/15",
      "img/tourmuynak/tourimg/16",
      "img/tourmuynak/tourimg/17",
      "img/tourmuynak/tourimg/18",
    ],
  },
  {
    id: 7,
    price: "50",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "105"
      },
      {
        id: 2,
        persons: "2",
        price: "125"
      },
      {
        id: 3,
        persons: "3",
        price: "135"
      },
      {
        id: 4,
        persons: "4",
        price: "200"
      },

    ],
    srcitinerary: "img/ekskursiya-po-nukus/itinerary/eng",
    maxamount: "100+",
    category: "Nukus",
    category1: "",
    tourlang: "eng",
    name: "Nukus City Tour",
    dayDuration: "(1 days)",
    aboutTour: "The one that reveals Nukus through its artists, craftspeople, and the world-famous collection no one expected to find here",
    unitDay: "1",
    unitNight: "0",
    country: "5",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Over 50 km",
    mapstext2: "Tour season: Year-round",
    description: "Nukus – Savitsky Museum – Bazarbai Serekeev House-Museum – Bakhtiyar Serekeev House-Museum – Bibisary Kunnazarova’s Workshop – Kurpacha-Making Workshop",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: Sedan / Minibus;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance tickets;"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional Guide",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Savitsky Museum — the “Louvre in the Desert”",
            timeDistination: "The journey begins in Nukus with a visit to the I. V. Savitsky Karakalpak State Museum of Art — one of the most extraordinary art collections in the world. The museum houses a unique collection of Russian avant-garde art from the 1920s–1930s, where each work reflects an era of artistic and cultural revolutions. It is no coincidence that this place is called the “Louvre in the Desert” — a global cultural phenomenon that emerged far from traditional cultural centers.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ekskursiya-po-nukus/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "12:00",
            timeName: "Visiting Artist Serekeev",
            timeDistination: "A visit to the house-museum of Honored Artist Bazarbai Serekeev. This intimate and welcoming space preserves the master’s works and reflects the atmosphere of his life and creative journey.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/Yy5yVAQEotwu6sNW6",
            img: "img/ekskursiya-po-nukus/daysimg/12-00"
          },
          {
            timeid: "3",
            time: "13:30",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "",
            img: "img/ekskursiya-po-nukus/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "15:00",
            timeName: "Contemporary Art of Serekeev",
            timeDistination: "The tour continues with a visit to the studio of contemporary artist Bakhtier Serekeev, son of Bazarbai Serekeev. The studio presents modern-style artworks that reflect a contemporary artistic vision while continuing the legacy of a creative dynasty.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/AywY8Lk9ARib2Sg86",
            img: "img/ekskursiya-po-nukus/daysimg/15-00"
          },
          {
            timeid: "5",
            time: "15:45",
            timeName: "Revival of Traditions: Karakalpakstan Textiles",
            timeDistination: "A visit to the workshop of Bibisara Kunnazarova, where traditional Karakalpak carpet weaving is being revived. The products are created using ancient techniques and are now used to decorate modern yurts, blending cultural heritage with contemporary design.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/mE6tf9JYtcf44dWW9",
            img: "img/ekskursiya-po-nukus/daysimg/15-45"
          },
          {
            timeid: "6",
            time: "16:30",
            timeName: "Traditional Kurpacha Quilts",
            timeDistination: "A stop at the workshop of artisan Damekhan, who specializes in producing traditional kurpacha quilts. Here you will observe the process of creating these authentic textile items, still widely used in everyday life and in yurts throughout Karakalpakstan.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/gg4pCXEFCjybdjUbA",
            img: "img/ekskursiya-po-nukus/daysimg/16-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1_-shHter2HdI5uZ_6BCow8G2_vyNMVU&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/ekskursiya-po-nukus/tourimg/7",
      "img/ekskursiya-po-nukus/tourimg/1",
      "img/ekskursiya-po-nukus/tourimg/2",
      "img/ekskursiya-po-nukus/tourimg/3",
      "img/ekskursiya-po-nukus/tourimg/4",
      "img/ekskursiya-po-nukus/tourimg/5",
      "img/ekskursiya-po-nukus/tourimg/6",
      "img/ekskursiya-po-nukus/tourimg/8",
      "img/ekskursiya-po-nukus/tourimg/9",
      "img/ekskursiya-po-nukus/tourimg/10",
      "img/ekskursiya-po-nukus/tourimg/11",
      "img/ekskursiya-po-nukus/tourimg/12",
      "img/ekskursiya-po-nukus/tourimg/13",
      "img/ekskursiya-po-nukus/tourimg/14",
      "img/ekskursiya-po-nukus/tourimg/15",
      "img/ekskursiya-po-nukus/tourimg/16",
      "img/ekskursiya-po-nukus/tourimg/17",
    ],
  },
  {
    id: 8,
    price: "50",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "105"
      },
      {
        id: 2,
        persons: "2",
        price: "125"
      },
      {
        id: 3,
        persons: "3",
        price: "135"
      },
      {
        id: 4,
        persons: "4",
        price: "200"
      },

    ],
    srcitinerary: "img/ekskursiya-po-nukus/itinerary/rus",
    maxamount: "100+",
    category: "Nukus",
    category1: "",
    tourlang: "rus",
    name: "Экскурсия по Нукусу",
    dayDuration: "(1 день)",
    aboutTour: "Тот, что открывает Нукус через его художников, мастеров и всемирно известную коллекцию, которую здесь никто не ожидал найти",
    unitDay: "1",
    unitNight: "0",
    country: "5",
    startCountry: "Нукус",
    endCountry: "Нукус",
    mapstext1: "Более 50 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Музей Савицкого - Дом Музей Базарбая Серекеева - Дом Музей Бахтияра Серекеева - Мастрерская Бибисары Кунназаровой - Мастерская по изготовлению Курпачи",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт:Седан/Микроавтобус;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Музей Савицкого — «Лувр в пустыне»",
            timeDistination: "Путешествие начинается в Нукусе.Вас ждёт экскурсия в Каракалпакский государственный музей искусств имени И.В. Савицкого — одно из самых необычных художественных собраний мира. Музей хранит уникальную коллекцию русского авангарда 1920–1930-х годов, где каждое произведение словно переносит в эпоху художественных и культурных революций. Не случайно это место называют «Лувром в пустыне» — феноменом мирового масштаба, возникшим вдали от привычных культурных центров.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ekskursiya-po-nukus/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "12:00",
            timeName: "В гостях у художника Серекеева",
            timeDistination: "Визит в дом-музей заслуженного художника Базарбая Серекеева. Этот уютный уголок хранит работы мастера и атмосферу его жизни",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/Yy5yVAQEotwu6sNW6",
            img: "img/ekskursiya-po-nukus/daysimg/12-00"
          },
          {
            timeid: "3",
            time: "13:30",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "",
            img: "img/ekskursiya-po-nukus/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "15:00",
            timeName: "Современное искусство Серекеева",
            timeDistination: "Затем мы направляемся в студию современного художника Бахтиера Серекеева, сына Базарбая Серекеева. Здесь представлены работы в стиле модерна, отражающие современное художественное видение и преемственность творческой династии.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/AywY8Lk9ARib2Sg86",
            img: "img/ekskursiya-po-nukus/daysimg/15-00"
          },
          {
            timeid: "5",
            time: "15:45",
            timeName: "Возрождение традиций: текстиль Каракалпакстана",
            timeDistination: "Посещение мастерской Бибисары Кунназаровой, где возрождается традиционное ковроткачество каракалпаков. Изделия создаются по старинным технологиям и сегодня используются для оформления современных юрт, соединяя наследие и актуальный дизайн.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/mE6tf9JYtcf44dWW9",
            img: "img/ekskursiya-po-nukus/daysimg/15-45"
          },
          {
            timeid: "6",
            time: "16:30",
            timeName: "Традиционные курпачи",
            timeDistination: "Остановка у мастерицы Дамехан, занимающейся изготовлением традиционных курпацев. Здесь вы увидите процесс создания этих аутентичных текстильных изделий, до сих пор используемых в быту и юртах Каракалпакстана.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/gg4pCXEFCjybdjUbA",
            img: "img/ekskursiya-po-nukus/daysimg/16-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1_-shHter2HdI5uZ_6BCow8G2_vyNMVU&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/ekskursiya-po-nukus/tourimg/7",
      "img/ekskursiya-po-nukus/tourimg/1",
      "img/ekskursiya-po-nukus/tourimg/2",
      "img/ekskursiya-po-nukus/tourimg/3",
      "img/ekskursiya-po-nukus/tourimg/4",
      "img/ekskursiya-po-nukus/tourimg/5",
      "img/ekskursiya-po-nukus/tourimg/6",
      "img/ekskursiya-po-nukus/tourimg/8",
      "img/ekskursiya-po-nukus/tourimg/9",
      "img/ekskursiya-po-nukus/tourimg/10",
      "img/ekskursiya-po-nukus/tourimg/11",
      "img/ekskursiya-po-nukus/tourimg/12",
      "img/ekskursiya-po-nukus/tourimg/13",
      "img/ekskursiya-po-nukus/tourimg/14",
      "img/ekskursiya-po-nukus/tourimg/15",
      "img/ekskursiya-po-nukus/tourimg/16",
      "img/ekskursiya-po-nukus/tourimg/17",
    ],
  },
  {
    id: 9,
    price: "30",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "90"
      },
      {
        id: 2,
        persons: "2",
        price: "90"
      },
      {
        id: 3,
        persons: "3",
        price: "90"
      },
      {
        id: 4,
        persons: "4",
        price: "185"
      },
    ],
    srcitinerary: "img/citiesofalostcivilization/itinerary/eng",
    maxamount: "100+",
    category: "Khiva",
    category1: "",
    tourlang: "eng",
    name: "Cities of a Lost Civilization",
    dayDuration: "(1 days)",
    aboutTour: "The one that uncovers forgotten desert fortresses and the world's most surprising art museum",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Nukus",
    endCountry: "Khiva",
    mapstext1: "Over 400 км",
    mapstext2: "Tour season: Year-round",
    description: "Nukus - Savitsky Museum - Chilpik - Kyzyl Kala - Toprak Kala - Ayaz Kala - Khiva",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: Sedan / Minibus;"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance tickets;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional Guide",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Savitsky Museum — the “Louvre in the Desert”",
            timeDistination: "The journey begins in Nukus with a visit to the I. V. Savitsky Karakalpak State Museum of Art — one of the most extraordinary art collections in the world. The museum houses a unique collection of Russian avant-garde art from the 1920s–1930s, where each work reflects an era of artistic and cultural revolutions. It is no coincidence that this place is called the “Louvre in the Desert” — a global cultural phenomenon that emerged far from traditional cultural centers.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/citiesofalostcivilization/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Chilpik — the Tower of Silence",
            timeDistination: "The route then continues to Chilpik (1st century CE), one of the key sites associated with Zoroastrian culture. Here you will see a dakhma known as the “Tower of Silence,” offering panoramic views of the Amu Darya River. The surrounding space is filled with the atmosphere of ancient rituals and mysticism, allowing your imagination to travel back to the belief systems of distant eras.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chilpik",
            locationSrc: "https://maps.app.goo.gl/MRatFvGUaGni2GKu6",
            img: "img/citiesofalostcivilization/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "12:30",
            timeName: "Kyzyl-Kala — the Red Fortress",
            timeDistination: "You will visit Kyzyl-Kala (1st–4th–7th centuries CE), a defensive fortress that was part of the Khorezmian fortification system. This site offers insight into ancient architectural techniques and conveys the scale of history preserved in its powerful walls and structures.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "https://maps.app.goo.gl/Y77s9RPuHN7aEbbU7",
            img: "img/citiesofalostcivilization/daysimg/12-30"
          },
          {
            timeid: "4",
            time: "13:30",
            timeName: "Toprak-Kala — the palace of Ancient Khorezm",
            timeDistination: "A visit to Toprak-Kala (“The Clay Fortress”), dating from the 1st–4th centuries CE, once the royal residence of the kings of Ancient Khorezm during the Classical period. The preserved walls and layout of the complex allow visitors to sense the importance and scale of the events that shaped the region’s centuries-long history.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "https://maps.app.goo.gl/Jm83XKvVTawkEmHm6",
            img: "img/citiesofalostcivilization/daysimg/13-30"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "",
            img: "img/citiesofalostcivilization/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "15:30",
            timeName: "Ayaz-Kala — guardian of the oasis",
            timeDistination: "An encounter with the impressive Ayaz-Kala complex — the largest fortress of Ancient Khorezm, dating back to the 2nd–7th centuries CE. This powerful defensive structure once protected the oasis from nomadic raids. From the top of the fortress, sweeping panoramic views open over the sands of the Kyzylkum Desert, while the remaining walls preserve the legacy of the Kushan era. Leaving this site, you carry with you a strong sense of the scale and grandeur of an ancient civilization.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "https://maps.app.goo.gl/maXUteHR9nYHkZpx7",
            img: "img/citiesofalostcivilization/daysimg/15-30"
          },
          {
            timeid: "7",
            time: "18:30",
            timeName: "Arrival in Khiva",
            timeDistination: "Arrival in Khiva. The final stage of the route concludes a rich and immersive journey through the ancient lands of Khorezm.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khiva",
            locationSrc: "https://maps.app.goo.gl/yHVJvh7J1roERuheA",
            img: "img/citiesofalostcivilization/daysimg/18-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1nXCg7-tm5tWvLWGcX7vdZ11nT16d8b8&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/citiesofalostcivilization/tourimg/1",
      "img/citiesofalostcivilization/tourimg/2",
      "img/citiesofalostcivilization/tourimg/3",
      "img/citiesofalostcivilization/tourimg/4",
      "img/citiesofalostcivilization/tourimg/5",
      "img/citiesofalostcivilization/tourimg/6",
      "img/citiesofalostcivilization/tourimg/7",
      "img/citiesofalostcivilization/tourimg/8",
      "img/citiesofalostcivilization/tourimg/9",
      "img/citiesofalostcivilization/tourimg/10",
      "img/citiesofalostcivilization/tourimg/11",
      "img/citiesofalostcivilization/tourimg/12",
      "img/citiesofalostcivilization/tourimg/13",
      "img/citiesofalostcivilization/tourimg/14",
    ],
  },
  {
    id: 10,
    price: "30",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "90"
      },
      {
        id: 2,
        persons: "2",
        price: "90"
      },
      {
        id: 3,
        persons: "3",
        price: "90"
      },
      {
        id: 4,
        persons: "4",
        price: "185"
      },
    ],
    srcitinerary: "img/citiesofalostcivilization/itinerary/rus",
    maxamount: "100+",
    category: "Khiva",
    category1: "",
    tourlang: "rus",
    name: "Города исчезнувшей цивилизаций",
    dayDuration: "(1 день)",
    aboutTour: "Тот, что открывает забытые крепости пустыни и самый неожиданный художественный музей в мире",
    unitDay: "1",
    unitNight: "0",
    country: "5",
    startCountry: "Нукус",
    endCountry: "Хива",
    mapstext1: "Более 400 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Музей Савицкого - Чилпик - Кызыл Кала - Топрак Кала - Аяз Кала - Хива",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт:Седан/Микроавтобус;"
      },

      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Музей Савицкого — «Лувр в пустыне»",
            timeDistination: "Путешествие начинается в Нукусе.Вас ждёт экскурсия в Каракалпакский государственный музей искусств имени И.В. Савицкого — одно из самых необычных художественных собраний мира. Музей хранит уникальную коллекцию русского авангарда 1920–1930-х годов, где каждое произведение словно переносит в эпоху художественных и культурных революций. Не случайно это место называют «Лувром в пустыне» — феноменом мирового масштаба, возникшим вдали от привычных культурных центров.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/citiesofalostcivilization/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Чилпик — Башня молчания",
            timeDistination: "Далее маршрут ведёт в Чилпик (I век н.э.) — одно из ключевых мест, связанных с зороастрийской культурой. Здесь перед вами возвышается дахма, известная как «Башня молчания», откуда открываются панорамные виды на реку Амударья. Пространство вокруг наполнено ощущением древних ритуалов и особой мистики, позволяя воображению перенестись в мир верований далёких эпох.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чилпик",
            locationSrc: "https://maps.app.goo.gl/MRatFvGUaGni2GKu6",
            img: "img/citiesofalostcivilization/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "12:30",
            timeName: "Кызыл-Кала — Красная крепость",
            timeDistination: "Вы посетите крепость Кызыл-Кала (I–IV–VII вв.) — оборонительное сооружение, входившее в цепь хорезмских укреплений. Здесь можно рассмотреть особенности древней архитектуры и ощутить масштаб истории, сохранившейся в мощных стенах и формах крепости.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Элликкала",
            locationSrc: "https://maps.app.goo.gl/Y77s9RPuHN7aEbbU7",
            img: "img/citiesofalostcivilization/daysimg/12-30"
          },
          {
            timeid: "4",
            time: "13:30",
            timeName: "Топрак-Кала — дворец древнего Хорезма",
            timeDistination: "Визит во дворец Топрак-Кала («Глиняная крепость») I–IV вв. н.э. — бывшую резиденцию царей древнего Хорезма в античный период. Сохранившиеся стены и планировка этого комплекса позволяют почувствовать масштаб и значимость событий, формировавших многовековую историю региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Элликкала",
            locationSrc: "https://maps.app.goo.gl/Jm83XKvVTawkEmHm6",
            img: "img/citiesofalostcivilization/daysimg/13-30"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Элликкала",
            locationSrc: "",
            img: "img/citiesofalostcivilization/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "15:30",
            timeName: "Аяз-Кала — сторож оазиса",
            timeDistination: "Встреча с величественным ансамблем Аяз-Калы — крупнейшей крепостью Древнего Хорезма, относящейся ко II–VII вв. н.э. Этот мощный оборонительный комплекс защищал оазис от набегов кочевых племён пустыни. С вершины крепости открывается широкий панорамный вид на пески Кызылкума, а сохранившиеся стены хранят память эпохи Кушанской империи. Покидая это место, вы увозите с собой яркое ощущение масштаба и величия древней цивилизации.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Элликкала",
            locationSrc: "https://maps.app.goo.gl/maXUteHR9nYHkZpx7",
            img: "img/citiesofalostcivilization/daysimg/15-30"
          },
          {
            timeid: "7",
            time: "18:30",
            timeName: "Прибытье в Хиву",
            timeDistination: "Прибытье в Хиву. Завершающий этап маршрута подводит итог насыщенному путешествию по древним землям Хорезма.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Хива",
            locationSrc: "https://maps.app.goo.gl/yHVJvh7J1roERuheA",
            img: "img/citiesofalostcivilization/daysimg/18-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1nXCg7-tm5tWvLWGcX7vdZ11nT16d8b8&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/citiesofalostcivilization/tourimg/1",
      "img/citiesofalostcivilization/tourimg/2",
      "img/citiesofalostcivilization/tourimg/3",
      "img/citiesofalostcivilization/tourimg/4",
      "img/citiesofalostcivilization/tourimg/5",
      "img/citiesofalostcivilization/tourimg/6",
      "img/citiesofalostcivilization/tourimg/7",
      "img/citiesofalostcivilization/tourimg/8",
      "img/citiesofalostcivilization/tourimg/9",
      "img/citiesofalostcivilization/tourimg/10",
      "img/citiesofalostcivilization/tourimg/11",
      "img/citiesofalostcivilization/tourimg/12",
      "img/citiesofalostcivilization/tourimg/13",
      "img/citiesofalostcivilization/tourimg/14",
    ],
  },
  {
    id: 11,
    price: "123,3",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "220"
      },
      {
        id: 2,
        persons: "2",
        price: "295"
      },
      {
        id: 3,
        persons: "3",
        price: "370"
      },
      {
        id: 4,
        persons: "4",
        price: "580"
      },

    ],
    srcitinerary: "img/inthefootstepsofancientcivilizations/itinerary/eng",
    maxamount: "100+",
    category: "Khiva",
    category1: "",
    tourlang: "eng",
    name: "In the Footsteps of Ancient Civilizations",
    dayDuration: "(2 days and 1 night)",
    aboutTour: "The one that uncovers forgotten desert fortresses and the world's most surprising art museum",
    unitDay: "2",
    unitNight: "1",
    country: "9",
    startCountry: "Nukus",
    endCountry: "Khiva",
    mapstext1: "Over 270 км",
    mapstext2: "Tour season: Year-round",
    description: "Nukus – Savitsky Museum – Chilpik – Jampyk Kala – Baday Tugay – Ayaz Kala – Jambas Kala – Kyzyl Kala – Toprak Kala – Big Guldursun – Khiva",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: Sedan / Minibus;"
      },
      {
        class: "fa fa-bed",
        text: "Accommodation: Overnight stay at the Ayaz Kala Yurt Camp;"
      },
      {
        class: "fa fa-cutlery",
        text: "Meals: Breakfast and dinner"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance tickets;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional Guide",
        price: "145"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Savitsky Museum — the “Louvre in the Desert”",
            timeDistination: "The journey begins in Nukus with a visit to the I. V. Savitsky Karakalpak State Museum of Art — one of the most extraordinary art collections in the world. The museum houses a unique collection of Russian avant-garde art from the 1920s–1930s, where each work reflects an era of artistic and cultural revolutions. It is no coincidence that this place is called the “Louvre in the Desert” — a global cultural phenomenon that emerged far from traditional cultural centers.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-09-00"
          },
          {
            timeid: "2",
            time: "12:00",
            timeName: "Chilpik — the Tower of Silence",
            timeDistination: "The route continues to Chilpik (1st century AD), one of the key sites associated with Zoroastrian culture. Here you will see the dakhma, known as the Tower of Silence, rising above the landscape and offering panoramic views of the Amu Darya River. The atmosphere is filled with a sense of ancient rituals and mysticism, allowing visitors to immerse themselves in the spiritual world of distant epochs.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chilpik",
            locationSrc: "https://maps.app.goo.gl/MRatFvGUaGni2GKu6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-12-00"
          },
          {
            timeid: "3",
            time: "13:30",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Local Cafe",
            locationSrc: "",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:30",
            timeName: "Jampyk-Kala — a Fortress of Different Epochs",
            timeDistination: "Visit to Jampyk-Kala Fortress (4th–1st centuries BC, 10th–12th centuries AD), one of the lesser-known archaeological sites of the region. The fortress offers scenic views of the surrounding landscape and excellent opportunities for expressive photography against the backdrop of ancient walls and natural forms.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Jampyk-Kala",
            locationSrc: "https://maps.app.goo.gl/quoShEJbbXBy5T1W8",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-14-30"
          },
          {
            timeid: "5",
            time: "16:30",
            timeName: "Baday-Tugay Nature Reserve",
            timeDistination: "Arrival at the Baday-Tugay National Nature Reserve — a unique natural area where Bukhara deer, saiga antelopes, foxes, and other rare animals listed in the Red Book of Uzbekistan live in their natural habitat. This is a rare opportunity to experience the region’s wildlife far from standard tourist routes.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Baday-Tugay",
            locationSrc: "https://maps.app.goo.gl/Q1ebjmqLuXNkb4vy9",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-16-30"
          },
          {
            timeid: "6",
            time: "19:00",
            timeName: "Evening at the Walls of Ayaz-Kala",
            timeDistination: "Arrival at the Ayaz-Kala Yurt Camp. The evening includes a traditional national dinner, followed by stargazing and relaxation in the peaceful atmosphere of nomadic life.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ayaz-Kala",
            locationSrc: "https://maps.app.goo.gl/fTm3C7rHpUEEQtVK6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-19-00"
          },

        ],
      },
      {
        id: "day2",
        nameDay: "Day 2",
        times: [
          {
            timeid: "1",
            time: "07:00",
            timeName: "Breakfast",
            timeDistination: "Breakfast at the yurt camp.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ayaz-Kala",
            locationSrc: "https://maps.app.goo.gl/fTm3C7rHpUEEQtVK6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "2",
            time: "08:30",
            timeName: "Ayaz-Kala — Guardian of the Oasis",
            timeDistination: "Free time near the Ayaz-Kala fortress complex — the largest fortress ensemble of Ancient Khorezm, dating back to the 2nd–7th centuries AD. This powerful defensive complex once protected the oasis from nomadic raids. From the top of the fortress, panoramic views of the Kyzylkum Desert unfold, while the preserved walls carry the legacy of the Kushan Empire. Leaving this place, you take with you a strong sense of the scale and grandeur of an ancient civilization.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ayaz-Kala",
            locationSrc: "https://maps.app.goo.gl/vN4XGyJ64KSR9e3n7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-08-30"
          },
          {
            timeid: "3",
            time: "10:30",
            timeName: "Jambas-Kala — Fortress of the Kangju Period",
            timeDistination: "Visit to Jambas-Kala Fortress (4th century BC – 1st century AD), one of the key monuments of the Kangju period.You will explore massive defensive walls that remain a symbol of the strength and organization of ancient society.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Jambas-Kala",
            locationSrc: "https://maps.app.goo.gl/VxhcJHq5dF3FF94e8",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-10-30"
          },
          {
            timeid: "4",
            time: "11:30",
            timeName: "Kyzyl-Kala — the Red Fortress",
            timeDistination: "Visit to Kyzyl-Kala Fortress (1st–4th–7th centuries AD), a defensive structure that was part of the Khorezmian chain of fortifications. Here you can observe the features of ancient architecture and feel the scale of history preserved in its powerful walls and forms.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Kyzyl-Kala",
            locationSrc: "https://maps.app.goo.gl/Y77s9RPuHN7aEbbU7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-11-30"
          },
          {
            timeid: "5",
            time: "12:30",
            timeName: "Toprak-Kala — Palace of Ancient Khorezm",
            timeDistination: "Visit to Toprak-Kala (“Clay Fortress”, 1st–4th centuries AD) — the former royal residence of the kings of Ancient Khorezm during the classical period. The preserved walls and layout allow you to sense the importance and scale of historical events that shaped the region over centuries.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Toprak-Kala",
            locationSrc: "https://maps.app.goo.gl/Jm83XKvVTawkEmHm6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-12-30"
          },
          {
            timeid: "6",
            time: "13:00",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Local cafe",
            locationSrc: "",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "7",
            time: "16:00",
            timeName: "Big Guldursun — the Grandeur of Khorezm’s Ancient Walls",
            timeDistination: "Stop at Big Guldursun Fortress, one of the most impressive and monumental defensive complexes in the region.Its massive walls and grand ruins vividly convey the power and greatness of the ancient civilization that existed here thousands of years ago.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Guldursun",
            locationSrc: "https://maps.app.goo.gl/eUjHtrjFv6Qv6Bzm6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-16-00"
          },
          {
            timeid: "8",
            time: "19:00",
            timeName: "Arrival in Khiva",
            timeDistination: "Arrival in Khiva. The final point of the route concludes an intense and immersive journey through the ancient lands of Khorezm.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khiva",
            locationSrc: "https://maps.app.goo.gl/maXUteHR9nYHkZpx7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-19-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=10S879HNnUhYm-tyECyPNL4gVo9oMTRE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/inthefootstepsofancientcivilizations/tourimg/2",
      "img/inthefootstepsofancientcivilizations/tourimg/1",
      "img/inthefootstepsofancientcivilizations/tourimg/3",
      "img/inthefootstepsofancientcivilizations/tourimg/4",
      "img/inthefootstepsofancientcivilizations/tourimg/5",
      "img/inthefootstepsofancientcivilizations/tourimg/6",
      "img/inthefootstepsofancientcivilizations/tourimg/7",
      "img/inthefootstepsofancientcivilizations/tourimg/8",
      "img/inthefootstepsofancientcivilizations/tourimg/9",
      "img/inthefootstepsofancientcivilizations/tourimg/10",
      "img/inthefootstepsofancientcivilizations/tourimg/11",
      "img/inthefootstepsofancientcivilizations/tourimg/12",
      "img/inthefootstepsofancientcivilizations/tourimg/13",
      "img/inthefootstepsofancientcivilizations/tourimg/14",
      "img/inthefootstepsofancientcivilizations/tourimg/15",
      "img/inthefootstepsofancientcivilizations/tourimg/16",
      "img/inthefootstepsofancientcivilizations/tourimg/17",
      "img/inthefootstepsofancientcivilizations/tourimg/18",
      "img/inthefootstepsofancientcivilizations/tourimg/19",
      "img/inthefootstepsofancientcivilizations/tourimg/20",
      "img/inthefootstepsofancientcivilizations/tourimg/21",
    ],
  },
  {
    id: 12,
    price: "123,3",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "220"
      },
      {
        id: 2,
        persons: "2",
        price: "295"
      },
      {
        id: 3,
        persons: "3",
        price: "370"
      },
      {
        id: 4,
        persons: "4",
        price: "580"
      },

    ],
    srcitinerary: "img/inthefootstepsofancientcivilizations/itinerary/rus",
    maxamount: "100+",
    category: "Khiva",
    category1: "",
    tourlang: "rus",
    name: "По следам древней цивилизаций",
    dayDuration: "(2 дня и 1 ночь)",
    aboutTour: "Тот, что открывает забытые крепости пустыни и самый неожиданный художественный музей в мире",
    unitDay: "2",
    unitNight: "1",
    country: "9",
    startCountry: "Нукус",
    endCountry: "Хива",
    mapstext1: "Более 270 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Музей Савицкого - Чилпик - Жампык Кала - Бадай Тугай - Аяз Кала- Джамбас Кала - Кызыл Кала - Топрак Кала -  Большой Гульдурсун - Хива ",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт:Седан/Микроавтобус;"
      },
      {
        class: "fa fa-bed",
        text: "Проживание: В юртовом лагере Аяз Кале;"
      },
      {
        class: "fa fa-cutlery",
        text: "Питание: завтрак, ужин"
      },
      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "145"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Музей Савицкого — «Лувр в пустыне»",
            timeDistination: "Путешествие начинается в Нукусе.Вас ждёт экскурсия в Каракалпакский государственный музей искусств имени И.В. Савицкого — одно из самых необычных художественных собраний мира. Музей хранит уникальную коллекцию русского авангарда 1920–1930-х годов, где каждое произведение словно переносит в эпоху художественных и культурных революций. Не случайно это место называют «Лувром в пустыне» — феноменом мирового масштаба, возникшим вдали от привычных культурных центров.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-09-00"
          },
          {
            timeid: "2",
            time: "12:00",
            timeName: "Чилпик — Башня молчания",
            timeDistination: "Далее маршрут ведёт в Чилпик (I век н.э.) — одно из ключевых мест, связанных с зороастрийской культурой. Здесь перед вами возвышается дахма, известная как «Башня молчания», откуда открываются панорамные виды на реку Амударья. Пространство вокруг наполнено ощущением древних ритуалов и особой мистики, позволяя воображению перенестись в мир верований далёких эпох.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чилпик",
            locationSrc: "https://maps.app.goo.gl/MRatFvGUaGni2GKu6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-12-00"
          },
          {
            timeid: "3",
            time: "13:30",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Местном",
            locationSrc: "",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:30",
            timeName: "Жампык-Кала — крепость разных эпох",
            timeDistination: "Посещение крепости Жампык-Кала (IV–I вв. до н.э., X–XII вв. н.э.) — одного из малоизученных памятников региона. Здесь открываются живописные виды на окружающий ландшафт, а сама крепость создаёт отличные условия для выразительных фотографий на фоне древних стен и природных форм.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Жампык-Кала",
            locationSrc: "https://maps.app.goo.gl/quoShEJbbXBy5T1W8",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-14-30"
          },
          {
            timeid: "5",
            time: "16:30",
            timeName: "Природный заповедник Бадай-Тугай",
            timeDistination: "Заезд в национальный заповедник Бадай-Тугай — уникальную природную территорию, где в естественной среде обитают бухарские олени, сайгаки, лисы и другие редкие животные, занесённые в Красную книгу Узбекистана. Это редкая возможность увидеть живую природу региона вдали от туристических маршрутов.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Бадай-Тугай",
            locationSrc: "https://maps.app.goo.gl/Q1ebjmqLuXNkb4vy9",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-16-30"
          },
          {
            timeid: "6",
            time: "19:00",
            timeName: "Вечер у стен Аяз-Калы",
            timeDistination: "Прибытие в юртовый лагерь Аяз-Кала. Вечер проходит за ужином в национальном стиле, после которого можно наблюдать звёздное небо и отдохнуть в спокойной атмосфере кочевнической жизни.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аяз-Кала",
            locationSrc: "https://maps.app.goo.gl/fTm3C7rHpUEEQtVK6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-19-00"
          },

        ],
      },
      {
        id: "day2",
        nameDay: "Day 2",
        times: [
          {
            timeid: "1",
            time: "07:00",
            timeName: "Завтрак",
            timeDistination: "Завтрак в юртовом лагере.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аяз-Кала",
            locationSrc: "https://maps.app.goo.gl/fTm3C7rHpUEEQtVK6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "2",
            time: "08:30",
            timeName: "Аяз-Кала — сторож оазиса",
            timeDistination: "Свободное время у крепостей Аяз-Кала. Встреча с величественным ансамблем Аяз-Калы — крупнейшей крепостью Древнего Хорезма, относящейся ко II–VII вв. н.э. Этот мощный оборонительный комплекс защищал оазис от набегов кочевых племён пустыни. С вершины крепости открывается широкий панорамный вид на пески Кызылкума, а сохранившиеся стены хранят память эпохи Кушанской империи. Покидая это место, вы увозите с собой яркое ощущение масштаба и величия древней цивилизации.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Аяз-Кала",
            locationSrc: "https://maps.app.goo.gl/vN4XGyJ64KSR9e3n7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-08-30"
          },
          {
            timeid: "3",
            time: "10:30",
            timeName: "Джамбас-Кала — крепость кангюйского периода",
            timeDistination: "Посещение крепости Джамбас-Кала (IV в. до н.э. – I в. н.э.) — одного из ключевых памятников кангюйского периода. Вы осмотрите мощные оборонительные стены, сохранившиеся как символ силы и организованности древней цивилизации.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Джамбас-Кала",
            locationSrc: "https://maps.app.goo.gl/VxhcJHq5dF3FF94e8",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-10-30"
          },
          {
            timeid: "4",
            time: "11:30",
            timeName: "Кызыл-Кала — Красная крепость",
            timeDistination: "Вы посетите крепость Кызыл-Кала (I–IV–VII вв.) — оборонительное сооружение, входившее в цепь хорезмских укреплений. Здесь можно рассмотреть особенности древней архитектуры и ощутить масштаб истории, сохранившейся в мощных стенах и формах крепости.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Кызыл-Кала",
            locationSrc: "https://maps.app.goo.gl/Y77s9RPuHN7aEbbU7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-11-30"
          },
          {
            timeid: "5",
            time: "12:30",
            timeName: "Топрак-Кала — дворец древнего Хорезма",
            timeDistination: "Визит во дворец Топрак-Кала («Глиняная крепость») I–IV вв. н.э. — бывшую резиденцию царей древнего Хорезма в античный период. Сохранившиеся стены и планировка этого комплекса позволяют почувствовать масштаб и значимость событий, формировавших многовековую историю региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Топрак-Кала",
            locationSrc: "https://maps.app.goo.gl/Jm83XKvVTawkEmHm6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-12-30"
          },
          {
            timeid: "6",
            time: "13:00",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Местном кафе",
            locationSrc: "",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "7",
            time: "16:00",
            timeName: "Большой Гульдурсун — величие древних стен Хорезма",
            timeDistination: "Остановка у крепости Большой Гульдурсун — одного из самых впечатляющих и масштабных оборонительных комплексов региона, где мощные стены и грандиозные руины наглядно передают величие и силу древней цивилизации, существовавшей здесь тысячи лет назад.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Гульдурсун",
            locationSrc: "https://maps.app.goo.gl/eUjHtrjFv6Qv6Bzm6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-16-00"
          },
          {
            timeid: "8",
            time: "19:00",
            timeName: "Прибытье в Хиву",
            timeDistination: "Прибытье в Хиву. Завершающий этап маршрута подводит итог насыщенному путешествию по древним землям Хорезма.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Хива",
            locationSrc: "https://maps.app.goo.gl/maXUteHR9nYHkZpx7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-19-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=10S879HNnUhYm-tyECyPNL4gVo9oMTRE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/inthefootstepsofancientcivilizations/tourimg/2",
      "img/inthefootstepsofancientcivilizations/tourimg/1",
      "img/inthefootstepsofancientcivilizations/tourimg/3",
      "img/inthefootstepsofancientcivilizations/tourimg/4",
      "img/inthefootstepsofancientcivilizations/tourimg/5",
      "img/inthefootstepsofancientcivilizations/tourimg/6",
      "img/inthefootstepsofancientcivilizations/tourimg/7",
      "img/inthefootstepsofancientcivilizations/tourimg/8",
      "img/inthefootstepsofancientcivilizations/tourimg/9",
      "img/inthefootstepsofancientcivilizations/tourimg/10",
      "img/inthefootstepsofancientcivilizations/tourimg/11",
      "img/inthefootstepsofancientcivilizations/tourimg/12",
      "img/inthefootstepsofancientcivilizations/tourimg/13",
      "img/inthefootstepsofancientcivilizations/tourimg/14",
      "img/inthefootstepsofancientcivilizations/tourimg/15",
      "img/inthefootstepsofancientcivilizations/tourimg/16",
      "img/inthefootstepsofancientcivilizations/tourimg/17",
      "img/inthefootstepsofancientcivilizations/tourimg/18",
      "img/inthefootstepsofancientcivilizations/tourimg/19",
      "img/inthefootstepsofancientcivilizations/tourimg/20",
      "img/inthefootstepsofancientcivilizations/tourimg/21",
    ],
  },
  {
    id: 13,
    price: "60",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "60"
      },
      {
        id: 2,
        persons: "2",
        price: "60"
      },
      {
        id: 3,
        persons: "3",
        price: "60"
      },
      {
        id: 4,
        persons: "4",
        price: "110"
      },

    ],
    srcitinerary: "img/tourofnukusandtheancientmizdakhannecropolis/itinerary/eng",
    maxamount: "100+",
    category: "Nukus",
    category1: "",
    tourlang: "eng",
    name: "Tour of Nukus and the Ancient Mizdakhan Necropolis",
    dayDuration: "(1 days)",
    aboutTour: "The one that walks you through 2,000 years of history — from avant-garde masterpieces to an ancient necropolis in the desert",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Over 50 км",
    mapstext2: "Tour season: Year-round",
    description: "Nukus – Savitsky Museum – State Museum of History and Culture of the Republic of Karakalpakstan – Mizdakhan Necropolis – Gaur-Kala – Nukus",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: Sedan / Minibus;"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance tickets;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional Guide",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Savitsky Museum — the “Louvre in the Desert”",
            timeDistination: "The journey begins in Nukus with a visit to the I. V. Savitsky Karakalpak State Museum of Art — one of the most extraordinary art collections in the world. The museum houses a unique collection of Russian avant-garde art from the 1920s–1930s, where each work reflects an era of artistic and cultural revolutions. It is no coincidence that this place is called the “Louvre in the Desert” — a global cultural phenomenon that emerged far from traditional cultural centers.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/VtrV6RN14CGbHB9T7",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "History and Culture of Karakalpakstan",
            timeDistination: "The tour continues at the State Museum of History and Culture of the Republic of Karakalpakstan. Here, you will immerse yourself in the region’s centuries-old history and explore archaeological, ethnographic, and historical artifacts that gradually reveal the past of these lands and form a comprehensive understanding of Karakalpak culture.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/spvK6zZkb6ZfhfZM9",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Lunch",
            timeDistination: "Lunch at a local café.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:30",
            timeName: "Mizdakhan — Sacred Complex",
            timeDistination: "In the town of Khojeli, we stop at the Mizdakhan architectural complex — one of the most significant historical sites in the region. You will see the mausoleums of Nazlumkhansulu (12th–14th centuries), Khalifa Erezhep (12th century), and Shamun Nabi (19th century), each reflecting a distinct period in the history of these lands.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/14-30"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Gaur-Kala Ancient Settlement",
            timeDistination: "Another highlight is the ruins of the Gaur-Kala fortress — an ancient settlement dating back to the era of Zoroastrianism (6th century BC – 9th century AD). These stone remains add a sense of deep time to the journey and vividly illustrate the multi-layered history of the region.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/5LJrJXpi6LX7jgaK7",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/16-00"
          },
          {
            timeid: "6",
            time: "17:30",
            timeName: "Return to Nukus",
            timeDistination: "Return to Nukus filled with vivid impressions and a wealth of new knowledge. End of the program.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/hKSoS5wJYHi81A5s5",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/09-00"
          },

        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1-Adi-b_kjA3HJ4Rt14YW6i2ZZ5OPglE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/15",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/1",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/2",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/3",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/4",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/5",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/6",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/7",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/8",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/9",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/10",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/11",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/12",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/13",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/14",
    ],
  },
  {
    id: 14,
    price: "60",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "60"
      },
      {
        id: 2,
        persons: "2",
        price: "60"
      },
      {
        id: 3,
        persons: "3",
        price: "60"
      },
      {
        id: 4,
        persons: "4",
        price: "110"
      },

    ],
    srcitinerary: "img/tourofnukusandtheancientmizdakhannecropolis/itinerary/rus",
    maxamount: "100+",
    category: "Nukus",
    category1: "",
    tourlang: "rus",
    name: "Экскурсия по Нукусу и древнему некрополю Миздакхан",
    dayDuration: "(1 день)",
    aboutTour: "Тот, что проведёт вас сквозь 2000 лет истории — от шедевров авангарда до древнего некрополя в пустыне",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Нукус",
    endCountry: "Хива",
    mapstext1: "Более 50 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Музей Савицкого  - Государственный музей истории и культуры Республики Каракалпакстана - Некрополь Миздакхан - Гаур Кала - Нукус",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт:Седан/Микроавтобус;"
      },
      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "День 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Музей Савицкого — «Лувр в пустыне»",
            timeDistination: "Путешествие начинается в Нукусе.Вас ждёт экскурсия в Каракалпакский государственный музей искусств имени И.В. Савицкого — одно из самых необычных художественных собраний мира. Музей хранит уникальную коллекцию русского авангарда 1920–1930-х годов, где каждое произведение словно переносит в эпоху художественных и культурных революций. Не случайно это место называют «Лувром в пустыне» — феноменом мирового масштаба, возникшим вдали от привычных культурных центров.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/VtrV6RN14CGbHB9T7",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "История и культура Каракалпакстана",
            timeDistination: "Вы продолжите экскурсию в Государственном музее истории и культуры Республики Каракалпакстан. Здесь вы погрузитесь в многовековую историю региона, познакомитесь с археологическими, этнографическими и историческими артефактами, которые шаг за шагом раскрывают прошлое этих земель и формируют целостное представление о культуре Каракалпакстана.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/spvK6zZkb6ZfhfZM9",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Обед",
            timeDistination: "Обед в местном кафе",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:30",
            timeName: "Миздакхан — сакральный комплекс",
            timeDistination: "В Ходжели мы останавливаемся у архитектурного комплекса Миздакхан — одного из самых значимых исторических мест региона. Здесь вы увидите мавзолеи Назлумхансулу (XII–XIV вв.), Халифы Эрежепа (XII в.) и Шамун Наби (XIX в.), каждый из которых отражает отдельный этап в истории этих земель.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ходжели",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/14-30"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Городище Гаур-Кала",
            timeDistination: "Отдельной остановкой станут руины крепости Гаур-Кала — древнего городища, относящегося к эпохе зороастризма (VI в. до н.э. – IX в. н.э.). Эти каменные остатки прошлого добавляют путешествию ощущение глубины времени и позволяют увидеть, насколько многослойна история региона.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ходжели",
            locationSrc: "https://maps.app.goo.gl/5LJrJXpi6LX7jgaK7",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/16-00"
          },
          {
            timeid: "6",
            time: "17:30",
            timeName: "Возвращение в Нукус",
            timeDistination: "Возвращение в Нукус с захватывающими впечатлениями и огромным багажом информации. Завершение программы.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/hKSoS5wJYHi81A5s5",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/09-00"
          },

        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1-Adi-b_kjA3HJ4Rt14YW6i2ZZ5OPglE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/15",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/1",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/2",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/3",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/4",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/5",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/6",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/7",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/8",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/9",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/10",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/11",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/12",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/13",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/14",
    ],
  },
  {
    id: 15,
    price: "81,6",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "180"
      },
      {
        id: 2,
        persons: "2",
        price: "225"
      },
      {
        id: 3,
        persons: "3",
        price: "245"
      },
      {
        id: 4,
        persons: "4",
        price: "365"
      },
    ],
    srcitinerary: "img/ethnodayinchimbay/itinerary/eng",
    maxamount: "100+",
    category: "Chimbay",
    category1: "",
    tourlang: "eng",
    name: "Ethno Day in Chimbay",
    dayDuration: "(1 days)",
    aboutTour: "The one that brings Karakalpak craftsmanship to life — from yurt-making to hand-stitched kurpacha",
    unitDay: "1",
    unitNight: "0",
    country: "7",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Over 150 км",
    mapstext2: "Tour season: Year-round",
    description: "Nukus – Yurt-Making Workshop – Chimbay Dehkan Bazaar – Sculptor’s House-Museum – Ornek Village – Bibisary Kunnazarova’s Workshop – Kurpacha-Making Workshop",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Transportation: Sedan / Minibus;"
      },
      {
        class: "fa fa-cutlery",
        text: "Meals: Lunch;"
      },
      {
        class: "fa fa-cutlery",
        text: "Master classes;"
      },
      {
        class: "fa fa-language",
        text: "Guide services;"
      },
      {
        class: "fa fa-list-alt",
        text: "Entrance tickets;"
      },
      {
        class: "fa fa-list-alt",
        text: "Drinking water during the trip;"
      },


    ],
    inclusionX: [

    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Mobile Guide",
        price: "10"
      },
      {
        id: 2,
        name: "Professional Guide",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "The Adventure Begins in Nukus",
            timeDistination: "Welcome to Karakalpakstan — a land where the steppe stretches beyond the horizon, where every hill whispers stories of the past, and where silence itself speaks louder than words. You are in the very heart of Central Asia, a place where nature and culture have intertwined for centuries, creating a world unlike any other on Earth.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ethnodayinchimbay/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "10:00",
            timeName: "How a Karakalpak Yurt Is Born",
            timeDistination: "Arrival in Chimbay and visit to yurt craftsmen’s workshops. Here, guests discover the unique technologies behind the construction of the Karakalpak yurt. Master craftsmen demonstrate the handmade production of the yurt’s key elements — terme, uyq, kerege, shanyrak — using traditional tools and structures whose origins go back centuries.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/MNSkE5muRHpEkG149",
            img: "img/ethnodayinchimbay/daysimg/10-00"
          },

          {
            timeid: "3",
            time: "11:00",
            timeName: "Chimbay Bazaar — The Heart of Local Life",
            timeDistination: "You will visit Chimbay Bazaar, one of the most colorful markets in Karakalpakstan. Here you will see piles of fresh fruits, vegetables, and spices, traditional basma fabrics, and handmade jewelry. You will also have the opportunity to taste national dishes and local products: fermented dairy drinks, izhan, shelpek, takan, kaunkak, ubi mayol (clarified butter), and other flavors without which local cuisine cannot be imagined.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/PfXj7uRptEjL1QYp7",
            img: "img/ethnodayinchimbay/daysimg/11-00"
          },
          {
            timeid: "4",
            time: "11:30",
            timeName: "Sculpture and Wood: The Artist’s Workshop",
            timeDistination: "You will visit the house-museum of the renowned artist and sculptor Daribay Tadjimuratov (PH-2).Here you will see works dedicated to nomadic life, the steppe, and traditional female images, as well as a unique collection of wood carvings and sculptures. The exhibition includes early sketches and awards of the master.The workshop has a vibrant creative atmosphere — the scent of wood and paint creates a special mood and allows you to feel the artistic process from within.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/fXgaxTpzGh8KfjwZ7",
            img: "img/ethnodayinchimbay/daysimg/11-30"
          },
          {
            timeid: "5",
            time: "12:30",
            timeName: "Departure to the Village of Ornek",
            timeDistination: "The road leads through rural landscapes, where guests can observe the authentic village life of Karakalpakstan.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/12-30"
          },
          {
            timeid: "6",
            time: "13:15",
            timeName: "Arrival in Ornek. Lunch in a Local Home",
            timeDistination: "Guests are welcomed with a warm, homely atmosphere and traditional dishes:• participation in preparing zhugara gurtik or beshbarmak;• introduction to the customs of hospitality;• opportunity to taste fresh dairy products — sary may and katyk.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/13-15"
          },
          {
            timeid: "7",
            time: "14:30",
            timeName: "Traditional Karakalpak Baking",
            timeDistination: "You will take part in preparing baursaks, bread, and zagary. Local women will demonstrate traditional techniques of rolling and frying bread products preserved in Karakalpak culture and passed down from generation to generation.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/14-30"
          },
          {
            timeid: "8",
            time: "17:00",
            timeName: "Revival of Traditions: Karakalpak Textiles",
            timeDistination: "Visit to the workshop of Bibisary Kunnazarova, where traditional Karakalpak carpet weaving is being revived. The textiles are created using ancient techniques and are now used to decorate modern yurts, blending cultural heritage with contemporary design.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/mE6tf9JYtcf44dWW9",
            img: "img/ethnodayinchimbay/daysimg/17-00"
          },
          {
            timeid: "9",
            time: "17:45",
            timeName: "Traditional Kurpacha",
            timeDistination: "A stop at the workshop of artisan Damekhan, who produces traditional kurpacha quilts. Here you will see the process of creating these authentic textile items, still widely used in everyday life and in yurts across Karakalpakstan.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/gg4pCXEFCjybdjUbA",
            img: "img/ethnodayinchimbay/daysimg/17-45"
          },
          {
            timeid: "10",
            time: "18:30",
            timeName: "End of the Tour",
            timeDistination: "",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ethnodayinchimbay/daysimg/09-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1UYlw0wT8BRzC5Dheo1nnwSgx0O13zCE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/ethnodayinchimbay/tourimg/10",
      "img/ethnodayinchimbay/tourimg/1",
      "img/ethnodayinchimbay/tourimg/2",
      "img/ethnodayinchimbay/tourimg/3",
      "img/ethnodayinchimbay/tourimg/4",
      "img/ethnodayinchimbay/tourimg/5",
      "img/ethnodayinchimbay/tourimg/6",
      "img/ethnodayinchimbay/tourimg/7",
      "img/ethnodayinchimbay/tourimg/8",
      "img/ethnodayinchimbay/tourimg/9",
      "img/ethnodayinchimbay/tourimg/11",
      "img/ethnodayinchimbay/tourimg/12",
      "img/ethnodayinchimbay/tourimg/13",
      "img/ethnodayinchimbay/tourimg/14",
      "img/ethnodayinchimbay/tourimg/15",
    ],
  },
  {
    id: 16,
    price: "81,6",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "180"
      },
      {
        id: 2,
        persons: "2",
        price: "225"
      },
      {
        id: 3,
        persons: "3",
        price: "245"
      },
      {
        id: 4,
        persons: "4",
        price: "365"
      },
    ],
    srcitinerary: "img/ethnodayinchimbay/itinerary/rus",
    maxamount: "100+",
    category: "Chimbay",
    category1: "",
    tourlang: "rus",
    name: "Этно день в Чимбае",
    dayDuration: "(1 день)",
    aboutTour: "Тот, что погружает в живое ремесло Каракалпакстана — от юртостроения до ручной вышивки курпачи",
    unitDay: "1",
    unitNight: "0",
    country: "7",
    startCountry: "Нукус",
    endCountry: "Нукус",
    mapstext1: "Более 150 км",
    mapstext2: "Сезон тура: Круглый год",
    description: "Нукус - Мастерская по изготовлению юрт - Дихан Базар Чимбая - Дом музей Скульптура - Поселек Орнек - Мастреская Бибисары Кунназаровой - Мастерская по изготовлению Курпачи",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Транспорт:Седан/Микроавтобус;"
      },
      {
        class: "fa fa-cutlery",
        text: "Питание: обед;"
      },
      {
        class: "fa fa-cutlery",
        text: "Мастер-Классы;"
      },
      {
        class: "fa fa-language",
        text: "Услуги гида;"
      },
      {
        class: "fa fa-list-alt",
        text: "Питьевая вода во время поездки;"
      },
      {
        class: "fa fa-list-alt",
        text: "Входные билеты;"
      },

    ],
    inclusionX: [

    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Мобильный гид",
        price: "10"
      },
      {
        id: 2,
        name: "Професиональный гид",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Day 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Приключение начинается в Нукусе",
            timeDistination: "Добро пожаловать в Каракалпакстан — край, где степь тянется за горизонт, где каждый холм шепчет истории прошлого, и где сама тишина говорит громче любых слов. Вы оказались в самом сердце Центральной Азии — месте, где природа и культура переплелись на протяжении веков, создав мир, не похожий ни на какой другой на Земле.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ethnodayinchimbay/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "10:00",
            timeName: "Как рождается каракалпакская юрта",
            timeDistination: "Прибытие в Чимбай и посещение мастерских мастеров юрт.Здесь гости знакомятся с уникальными технологиями изготовления каракалпакской юрты. Мастера демонстрируют ручное производство основных элементов юрты — терме, уык, кереге, шанырак — с использованием традиционных инструментов и конструкций, чьё происхождение уходит в глубину веков.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/MNSkE5muRHpEkG149",
            img: "img/ethnodayinchimbay/daysimg/10-00"
          },

          {
            timeid: "3",
            time: "11:00",
            timeName: "Чимбайский базар — сердце местной жизни",
            timeDistination: "Вы окажетесь на Чимбайском базаре — одном из самых колоритных рынков Каракалпакстана. Здесь вы увидите горы свежих фруктов, овощей и специй, традиционные ткани басма и украшения ручной работы. Вы сможете попробовать национальные блюда и местные продукты: кисломолочные напитки, ижан, шелпеки, такан, каункaк, уби майол (топлёное масло) и другие вкусы, без которых невозможно представить местную кухню.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/PfXj7uRptEjL1QYp7",
            img: "img/ethnodayinchimbay/daysimg/11-00"
          },
          {
            timeid: "4",
            time: "11:30",
            timeName: "Скульптура и дерево: мастерская художника",
            timeDistination: "Вы посетите дом-музей известного художника и скульптора Дарибай Таджимуратов (PH-2).Здесь вы увидите работы, посвящённые быту кочевников, степи и женским традиционным образам, а также уникальную коллекцию деревянной резьбы и скульптур. В экспозиции представлены ранние этюды и награды мастера. В мастерской ощущается живая рабочая атмосфера — запах древесины и краски создаёт особое настроение и помогает прочувствовать процесс создания искусства изнутри.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/fXgaxTpzGh8KfjwZ7",
            img: "img/ethnodayinchimbay/daysimg/11-30"
          },
          {
            timeid: "5",
            time: "12:30",
            timeName: "Отправление в аул (поселение) Орнек.",
            timeDistination: "Путь пролегает через сельскую местность, где гости могут ознакомиться с самобытным деревенской жизнью Каракалпакстана.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/12-30"
          },
          {
            timeid: "6",
            time: "13:15",
            timeName: "Прибытие в Орнек. Обед в доме местного жителя.",
            timeDistination: "Гостей ждёт домашняя атмосфера и традиционные блюда:• участие в приготовлении жүгара гуртык или бешбармак;• знакомство с обычаями гостеприимства ;• возможность попробовать свежие молочные продукты — сары май, катык.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/13-15"
          },
          {
            timeid: "7",
            time: "14:30",
            timeName: "Традиционная выпечка каракалпаков",
            timeDistination: "Вы примете участие в приготовлении баурсаков, хлеба и загары. Местные женщины покажут технику раскатки и жарки хлебных изделий, сохранившуюся в каракалпакских традициях и передаваемую из поколения в поколение.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/14-30"
          },
          {
            timeid: "8",
            time: "17:00",
            timeName: "Возрождение традиций: текстиль Каракалпакстана",
            timeDistination: "Посещение мастерской Бибисары Кунназаровой, где возрождается традиционное ковроткачество каракалпаков. Изделия создаются по старинным технологиям и сегодня используются для оформления современных юрт, соединяя наследие и актуальный дизайн.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/mE6tf9JYtcf44dWW9",
            img: "img/ethnodayinchimbay/daysimg/17-00"
          },
          {
            timeid: "9",
            time: "17:45",
            timeName: "Традиционные курпачи",
            timeDistination: "Остановка у мастерицы Дамехан, занимающейся изготовлением традиционных курпацев. Здесь вы увидите процесс создания этих аутентичных текстильных изделий, до сих пор используемых в быту и юртах Каракалпакстана.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Чимбай",
            locationSrc: "https://maps.app.goo.gl/gg4pCXEFCjybdjUbA",
            img: "img/ethnodayinchimbay/daysimg/17-45"
          },
          {
            timeid: "10",
            time: "18:30",
            timeName: "Завершение тура",
            timeDistination: "",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Нукус",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ethnodayinchimbay/daysimg/09-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1UYlw0wT8BRzC5Dheo1nnwSgx0O13zCE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/ethnodayinchimbay/tourimg/10",
      "img/ethnodayinchimbay/tourimg/1",
      "img/ethnodayinchimbay/tourimg/2",
      "img/ethnodayinchimbay/tourimg/3",
      "img/ethnodayinchimbay/tourimg/4",
      "img/ethnodayinchimbay/tourimg/5",
      "img/ethnodayinchimbay/tourimg/6",
      "img/ethnodayinchimbay/tourimg/7",
      "img/ethnodayinchimbay/tourimg/8",
      "img/ethnodayinchimbay/tourimg/9",
      "img/ethnodayinchimbay/tourimg/11",
      "img/ethnodayinchimbay/tourimg/12",
      "img/ethnodayinchimbay/tourimg/13",
      "img/ethnodayinchimbay/tourimg/14",
      "img/ethnodayinchimbay/tourimg/15",
    ],
  },
  {
    id: 17,
    price: "189",
    prices: [
      { id: 1, persons: "1", price: "522" },
      { id: 2, persons: "2", price: "604" },
      { id: 3, persons: "3", price: "686" },
      { id: 4, persons: "4", price: "756" },
    ],
    srcitinerary: "img/eco-tour-2day/itinerary/eng",
    maxamount: "100+",
    category: "Aral",
    category1: "Top",
    tourlang: "itl",
    name: "Tour Ecologico al Mare d'Aral",
    dayDuration: "(2 giorni e 1 notte)",
    aboutTour: "Scopri il Karakalpakstan: canyon sconfinati, il leggendario Mare d'Aral e le fortezze delle civiltà antiche",
    unitDay: "2",
    unitNight: "1",
    country: "8",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Oltre 700 km",
    mapstext2: "Stagione del tour: tutto l'anno",
    description: "Nukus – Muynak – Mare d'Aral – Cimitero dei Nomadi – Kurgancha Kala – Area di Kubla – Lago Sudochye – Kungrad – Necropoli di Mizdakhan – Gaur Kala – Nukus",

    inclusionOn: [
      { class: "fa fa-car", text: "Trasporto: veicolo fuoristrada 4×4;" },
      { class: "fa fa-cutlery", text: "Pasti: 4 volte;" },
      { class: "fa fa-bed", text: "Alloggio: 1 notte in un campo di yurte;" },
      { class: "fa fa-list-alt", text: "Biglietti d’ingresso;" },
      { class: "fa fa-list-alt", text: "Acqua potabile durante il viaggio;" },
    ],

    inclusionX: [
      { class: "fa fa-globe", text: "Mance / gratuità" },
      { class: "fa fa-language", text: "Servizi di guida" },
    ],

    inclusionBuy: [
      { id: 1, name: "Guida mobile", price: "10" },
      { id: 2, name: "Guida professionale", price: "145" },
      { id: 3, name: "Barsa Kelmes", price: "50" },
      { id: 4, name: "Transfer Nukus-Khiva", price: "75" }
    ],

    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "L'avventura inizia a Nukus",
            timeDistination: "Benvenuti in Karakalpakstan — una terra dove la steppa si estende oltre l’orizzonte, dove ogni collina sussurra storie del passato e dove il silenzio parla più forte delle parole. Siete arrivati nel cuore dell’Asia Centrale — un luogo dove natura e cultura si sono intrecciate nel corso dei secoli, creando un mondo unico nel suo genere.",
            timeVideoSrc: "https://www.youtube.com/embed/Io1Cj4c8mTE?si=JgvUoSawUWtlTiUK",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-2day/daysimg/1-08-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Muynak — l'ex città portuale del Mare d'Aral",
            timeDistination: "Visiterete Muynak, una città che un tempo era un importante porto del Mare d'Aral e un centro della pesca. Vedrete il Cimitero delle Navi e visiterete il Museo Statale di Storia Locale di Muynak, dove esposizioni e un film documentario raccontano la drammatica storia del Mare d'Aral e della vita della città.",
            timeVideoSrc: "https://www.youtube.com/embed/HRM2Ek40taw?si=3ZkV3OKx8ZXka-BS",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-2day/daysimg/1-11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Pranzo",
            timeDistination: "Pranzo in una accogliente guest house, dove vi verranno serviti piatti caldi della cucina tradizionale locale.",
            timeVideoSrc: "",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-2day/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:00",
            timeName: "Viaggio attraverso il fondale del mare",
            timeDistination: "Il percorso segue il fondo asciutto dell'antico Mare d'Aral, rivelando paesaggi duri ma spettacolari. Sono previste soste fotografiche e una visita al Cimitero dei Nomadi.",
            timeVideoSrc: "https://youtu.be/ZyK0XZqPNSA",
            location: "Ustyurt canyons",
            locationSrc: "https://maps.app.goo.gl/edkUA1k6bRFLELzN6",
            img: "img/eco-tour-2day/daysimg/1-14-00"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Cimitero dei Nomadi",
            timeDistination: "Una breve sosta in un paesaggio suggestivo che conserva tracce di antiche migrazioni.",
            timeVideoSrc: "https://youtube.com/shorts/tg3_p0wkTmM?feature=share",
            location: "Ustyurt Plateau",
            locationSrc: "https://maps.app.goo.gl/bMriUXdZQD85aNXv5",
            img: "img/eco-tour-2day/daysimg/1-16-00"
          },
          {
            timeid: "6",
            time: "17:00",
            timeName: "Arrivo al Mare d'Aral",
            timeDistination: "Passeggiata lungo la riva, possibilità di nuotare e raccogliere conchiglie.",
            timeVideoSrc: "https://youtu.be/EEvEC6w_OR0",
            location: "Aral Sea",
            locationSrc: "https://maps.app.goo.gl/8UMc14PqDxubXGah7",
            img: "img/eco-tour-2day/daysimg/1-17-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Campo di yurte",
            timeDistination: "Pernottamento in una yurta tradizionale con servizi e docce disponibili.",
            timeVideoSrc: "https://youtu.be/NO8NKm8yyKY",
            location: "Yurt camp",
            locationSrc: "https://maps.app.goo.gl/NVfyZiYU7qQ7BcgP6",
            img: "img/eco-tour-2day/daysimg/1-18-00"
          }
        ]
      }
    ],

    maps: "https://www.google.com/maps/d/u/2/embed?mid=1nS3XchOj5O8Ds3OeWyZkKn6km7N65j0&ehbc=2E312F&noprof=1",

    feedback: [
      {
        date: "",
        name: "Louisa & Kieran",
        gmail: "",
        messages:
          "Really well looked after, made sure we were warm & well fed.A beautiful place to camp and an incredible experience for a good night’s sleep.We recommend the vodka!",
        score: 5,
      },
      {
        date: "",
        name: "Sandro",
        gmail: "",
        messages:
          "Really nice hosts. Really nice place. Service was perfect.Everything was perfect and amazing experience and landscapes! :). We loved this really. A great experience, great hospitality and a warm & cozy yurt - even when it was cold outside.",
        score: 5,
      },
      {
        date: "2018-04-02",
        name: "Thomas & Camilla",
        gmail: "Sweden",
        messages:
          "En underbar afton vid Aralsjön! Gästfriheten vet inga gränser, god mat, mycket mot och excellent Karakalpakstansk vodka :) Sarsenbay är en perfekt värd/guide!",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "Frau Rainer und Markus",
        gmail: "Sweden",
        messages:
          "Sehnsüger Ausflug an den Aralsee! Super Reiseleiter und Fahrer. Alles wunderbar, wir kommen gerne wieder. Sehr eindrucksvoll hier in Karakalpakstan.",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "同海王",
        gmail: "",
        messages:
          "大家好，欢迎来到咸海。我是在此工作8年的中国人“咸海王”，每年要在此工作4-6个月，很荣幸和知名旅行公司成为邻居。如果有中国朋友要介绍朋友或者生意中的主人公，希望来咸海旅游的中国朋友请联系我，想更多了解咸海可加我微信或电话：乌兹电话: +99899 9686518 国内电: 186130543232",
        score: 5,
      },
      {
        date: "апрель 2018",
        name: "Дмитрий",
        gmail: "Москва",
        messages:
          "Огромное спасибо сотрудникам турбазы и людям за гостеприимство. Получили огромное удовольствие от общения с такими замечательными людьми. Спасибо за это открытие для нас Арал!",
        score: 5,
      },
      {
        date: "13.04.2018",
        name: "Друг из Владикавказа",
        gmail: "",
        messages:
          "Спасибо огромное за гостеприимство! Очень понравился прием и организованность лагеря. Радушие и теплое отношение всех. О киме ли ветер – тишина здесь. Нам нужно еще побывать у вас. Рассмотрели друзей, о прекрасно проведенном времени.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Анна Сергеевна Иванова",
        gmail: "",
        messages:
          "Отзыв о туре 'Нукус – Муйнак – Плато Устюрт – Аральское море': 'Этот тур оказался для меня настоящим открытием! С самого утра нас забрали из Нукуса, и началось наше путешествие по местам, которые буквально дышат историей. Кладбище кораблей в Муйнаке оставляет неизгладимое впечатление – когда-то здесь было море, а теперь на сухом дне стоят забытые корабли, что заставляет задуматься о масштабах природных изменений. Музеи в Муйнаке погружают в историю региона и трагедию Арала. Особенно запомнилась поездка через плато Устюрт – такие виды сложно описать словами. Местные каньоны, кладбище кочевников – всё это делает маршрут по-настоящему уникальным. Природа здесь потрясающая, и каждый момент хотелось запечатлеть на камеру. День завершился на берегу Аральского моря, где можно было искупаться и собирать ракушки. Юртовый лагерь на берегу – это отдельная магия. Ужин в традиционной обстановке, а затем ночь в уютной юрте под звёздами – идеальное завершение такого насыщенного дня. Большое спасибо команде за этот потрясающий опыт. Рекомендую всем, кто хочет прикоснуться к уникальной истории и природе этой области!",
        score: 5,
      },
      {
        date: "30.07.2023",
        name: "Beth W",
        gmail: "bethwison1991@gmail.com",
        messages:
          "We did not book a tour with a guide. We used the company for having the driver only to take us to the Ship Graveyard.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Janusz Tylus",
        gmail: "",
        messages:
          "Grupa z Polski, podróżnicy TOP TURYSTYKA Super miejscówka, niezwykła gościnność, wielogwiazdkowy camp pod gwiazdami. Było super! Bardzo miłe miejsce ♥ Astelie Eryk Kwasnica PS.Pan w agregacie WYMlATA:) Brestowice",
        score: 5,
      },

      {
        date: "",
        name: "Lisa & Alexander",
        gmail: "Liebe Grüße",
        messages:
          "Auf die Freude der Natur und die Gesellschaft der Menschen im Jurten Camp beim Mal See. Wir haben die Zeit sehr genossen, wurden sehr umsorgt, gut & korrekt informiert, und die Sonne hat uns allen das Aufstehen versüßt. Danke für alles!",
        score: 5,
      },
      {
        date: "14.04.2018",
        name: "Simon & Natasha",
        gmail: "Switzerland / Russia",
        messages:
          "Very nice camp with competent staff and lots of anecdotes! It’s sad to see to what level the Aral Sea shrunk and hope that the government starts taking action. Good Luck",
        score: 4,
      },
      {
        date: "April 15, 2018",
        name: "Marc, Jennifer,Lucas & Alexis",
        gmail: "Michigan, USA",
        messages:
          "Thank you for the great visit to the Aral Sea. The Yurt Camp was very comfortable and pleasant. Our family enjoyed the friendly atmosphere and comfortable accommodations. Thank you",
        score: 5,
      },
      {
        date: "12-16 августа 2019",
        name: "Den Garage",
        gmail: "БЕНЗИН И ГРЕЧА",
        messages:
          "Идеальный хостел для путешествующих на двух колесах и не только.Удачно расположен в центре и чуть в стороне от шумных улиц. Как только открываешь дверь, и заканчивай свой trip— всё начинает нравиться! Ковровое покрытие под капотом в комнате, выходное место пространства. В шкатках всё очень тщательно обустроено, нет ничего лишнего. В хостеле все отлично функционирует, никаких поломанных кранов и неисправных розеток… и так далее. А самое главное – это расположение администраторов и персонала.Мне не хотелось бы забыть, но не хотелось бы останавливаться с недугом в Besqala. Пожалуй, достаточно отзыв и завтрак индуский!",
        score: 5,
      },
      {
        date: "09.09.19",
        name: "Isabelle",
        gmail: "France",
        messages:
          "Super séjour à Nukus et à l’Aral Sea (impressionnant à voir). Expérience à faire : se baigner dans le lac et avoir les pieds pleins de boue. Équipe au petit soin, vraiment top ! Merci à Tazabay et à son équipe.Merci Taschkent (petit clin d’œil à mon guide K.)",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Antoine PELLERIN ",
        gmail: "",
        messages:
          "Excellent keeper Diana to his camp Elena & Vova. A magnificent piece of scenography. The beautiful desert & skies. Thanks a lot for this great moment for us.",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Annika,Viki ",
        gmail: "Germany,Hungary",
        messages:
          "We had a fantastic stay thanks to the warm hospitality of the team – and fun despite the noisy tourist group next door!",
        score: 5,
      },
      {
        date: "11.05.2026",
        name: "Liza Raitina",
        gmail: "",
        messages: "Нам тур понравился на 10 из 10. Особенная благодарность водителю - он просто гуру вождения вне трассы. Из пожеланий по улучшению: я бы озвучила аудиогид живым голосом вместо робота. Возможно, также можно добавить для желающих более расширенный контент, особенно с учетом долгой дороги. В остальном нам все очень понравилось, спасибо вам большое за помощь и организацию.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Jill Heyde",
        gmail: "",
        messages: "We just returned from an Aral Sea trip with Rakhmet. It was very interesting. We are not comfortable with video. Would you mind sending us the questions in writing?",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Gioacchino Pagano",
        gmail: "",
        messages: "The trip was very beautiful, especially with Max as guide. You did a great choice to suggest us him.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Martina & Manfred",
        gmail: "",
        messages: "We had a wonderful tour to the Besqala Aral camp. We spent two nights in the camp. All things are very well organized. The food was very good and the ladies were very friendly and helpful. The yurts were comfortable and clean. Our driver Muchtar was a very good driver, always driving safely on difficult off-road routes. One suggestion: switch off the camp light for an hour at night so guests can better enjoy the stars.",
        score: 5,
      },
      {
        date: "24.05.2026",
        name: "Ola Jodyna",
        gmail: "",
        messages: "It was a wonderful, well-organized adventure. We were picked up punctually from our hotel by a friendly driver. The vehicle was exactly as promised, equipped with air conditioning and 4WD. The scenery was stunning and unforgettable. The yurts were clean and the food was delicious. The optional excursion to the edge of the plateau was absolutely worth it.",
        score: 5,
      },
      {
        date: "26.05.2026",
        name: "Alessandro",
        gmail: "",
        messages: "The tour was beautiful and very touching. Even though the car broke down, the staff quickly found an alternative solution. Our guide Azat was amazing and exceeded all expectations. Everything was perfect and we highly recommend this experience.",
        score: 5,
      },
      {
        date: "29.05.2026",
        name: "Симоне Донди",
        gmail: "",
        messages: "Не могу назвать ничего отрицательного. Отличный водитель, своевременные остановки, позволившие насладиться местами, отличная и обильная еда.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Katia",
        gmail: "",
        messages: "I loved both of my trips with Besqala. The Aral Sea is a place worth seeing and the fortresses of ancient Khorezm are unique. Drivers were knowledgeable and attentive. If I had to suggest one improvement, it would be providing a clearer schedule and more information about stop durations.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Sibylle Kiss",
        gmail: "",
        messages: "We had 3 great days at the Aral Sea.",
        score: 5,
      },
      {
        date: "09.06.2026",
        name: "Крейдина Алиса",
        gmail: "",
        messages: "Хотела сказать вашей организации огромное спасибо за организацию тура, все было супер! Один из лучших опытов в моей жизни.",
        score: 5,
      }
    ],
    img: [
      "img/eco-tour-2day/tourimg/21",
      "img/eco-tour-2day/tourimg/27",
      "img/eco-tour-2day/tourimg/1",
      "img/eco-tour-2day/tourimg/2",
      "img/eco-tour-2day/tourimg/3",
      "img/eco-tour-2day/tourimg/4",
      "img/eco-tour-2day/tourimg/5",
      "img/eco-tour-2day/tourimg/6",
      "img/eco-tour-2day/tourimg/7",
      "img/eco-tour-2day/tourimg/8",
      "img/eco-tour-2day/tourimg/9",
      "img/eco-tour-2day/tourimg/10",
      "img/eco-tour-2day/tourimg/11",
      "img/eco-tour-2day/tourimg/12",
      "img/eco-tour-2day/tourimg/13",
      "img/eco-tour-2day/tourimg/14",
      "img/eco-tour-2day/tourimg/15",
      "img/eco-tour-2day/tourimg/16",
      "img/eco-tour-2day/tourimg/17",
      "img/eco-tour-2day/tourimg/18",
      "img/eco-tour-2day/tourimg/19",
      "img/eco-tour-2day/tourimg/22",
      "img/eco-tour-2day/tourimg/23",
      "img/eco-tour-2day/tourimg/24",
      "img/eco-tour-2day/tourimg/25",
      "img/eco-tour-2day/tourimg/26",
      "img/eco-tour-2day/tourimg/28",
      "img/eco-tour-2day/tourimg/29",
      "img/eco-tour-2day/tourimg/30",
      "img/eco-tour-2day/tourimg/31",
      "img/eco-tour-2day/tourimg/32",
      "img/eco-tour-2day/tourimg/33"
    ],
  },
  {
    id: 18,
    price: "275",
    prices: [
      { id: 1, persons: "1", price: "695" },
      { id: 2, persons: "2", price: "830" },
      { id: 3, persons: "3", price: "965" },
      { id: 4, persons: "4", price: "1100" },
    ],

    srcitinerary: "img/eco-tour-3day/itinerary/eng",
    maxamount: "100+",
    category: "Aral",
    category1: "Top",
    tourlang: "itl",

    name: "Tour Ecologico al Mare d'Aral",
    dayDuration: "(3 giorni e 2 notti)",
    aboutTour: "Scopri il Karakalpakstan: canyon sconfinati, il leggendario Mare d'Aral e le fortezze delle civiltà antiche",
    unitDay: "3",
    unitNight: "2",

    country: "11",
    startCountry: "Nukus",
    endCountry: "Nukus",

    mapstext1: "Oltre 900 km",
    mapstext2: "Stagione del tour: tutto l'anno",

    description: "Nukus – Muynak – Mare d'Aral – Cimitero dei Nomadi – Kurgancha Kala – Kunti Baba – Canyon di Aktumsik – Kubla Ustyurt – Lago Sudochye – Salina di Barsakelmes – Mizdakhan – Nukus",

    inclusionOn: [
      { class: "fa fa-car", text: "Trasporto: veicolo fuoristrada 4×4;" },
      { class: "fa fa-cutlery", text: "Pasti: 7 volte;" },
      { class: "fa fa-bed", text: "Alloggio: 2 notti in campo di yurte;" },
      { class: "fa fa-list-alt", text: "Biglietti d’ingresso;" },
      { class: "fa fa-list-alt", text: "Acqua potabile durante il viaggio;" },
    ],

    inclusionX: [
      { class: "fa fa-globe", text: "Mance;" },
      { class: "fa fa-language", text: "Servizi di guida;" },
    ],

    inclusionBuy: [
      { id: 1, name: "Transfer Nukus-Khiva", price: "70" },
      { id: 2, name: "Guida professionale", price: "215" }
    ],

    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "L'avventura inizia a Nukus",
            timeDistination: "Benvenuti in Karakalpakstan — una terra dove la steppa si estende oltre l’orizzonte e il silenzio racconta storie antiche. Siete nel cuore dell’Asia Centrale.",
            timeVideoSrc: "",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/eco-tour-3day/daysimg/1-08-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Muynak — ex porto del Mare d'Aral",
            timeDistination: "Visita al Cimitero delle Navi e al museo locale che racconta la storia del disastro ecologico.",
            timeVideoSrc: "",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/eco-tour-3day/daysimg/1-11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Pranzo",
            timeDistination: "Pranzo in guest house con cucina tradizionale.",
            timeVideoSrc: "",
            location: "Muynak",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:00",
            timeName: "Viaggio nel fondale del mare",
            timeDistination: "Attraversamento del fondo asciutto del Mare d'Aral con soste fotografiche.",
            timeVideoSrc: "",
            location: "Aral",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/1-14-00"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Cimitero dei Nomadi",
            timeDistination: "Breve visita a un sito storico nel deserto.",
            timeVideoSrc: "",
            location: "Nomads",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/1-16-00"
          },
          {
            timeid: "6",
            time: "17:00",
            timeName: "Arrivo al Mare d'Aral",
            timeDistination: "Passeggiata, relax e possibilità di fare il bagno.",
            timeVideoSrc: "",
            location: "Aral Sea",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/1-17-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Campo di yurte",
            timeDistination: "Cena e pernottamento in yurta.",
            timeVideoSrc: "",
            location: "Yurt camp",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/1-18-00"
          }
        ]
      },

      {
        id: "day2",
        nameDay: "Giorno 2",
        times: [
          {
            timeid: "1",
            time: "04:00",
            timeName: "Alba sul Mare d'Aral",
            timeDistination: "Momento magico all'alba e colazione.",
            timeVideoSrc: "",
            location: "Aral Sea",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/2-04-00"
          },
          {
            timeid: "2",
            time: "08:30",
            timeName: "Kurgancha Kala",
            timeDistination: "Antico insediamento della Via della Seta.",
            timeVideoSrc: "",
            location: "Kurgancha",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/2-08-30"
          },
          {
            timeid: "3",
            time: "09:30",
            timeName: "Kunti Baba",
            timeDistination: "Paesaggi rocciosi e panorami spettacolari.",
            timeVideoSrc: "",
            location: "Kunti Baba",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/2-09-30"
          },
          {
            timeid: "4",
            time: "13:00",
            timeName: "Pranzo",
            timeDistination: "Pranzo nel campo di yurte.",
            timeVideoSrc: "",
            location: "Camp",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "5",
            time: "14:00",
            timeName: "Canyon di Aktumsik",
            timeDistination: "Paesaggi 'marziani' e visita alla costa.",
            timeVideoSrc: "",
            location: "Aktumsik",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/2-14-00"
          },
          {
            timeid: "6",
            time: "19:00",
            timeName: "Cena tradizionale",
            timeDistination: "Cena e osservazione delle stelle.",
            timeVideoSrc: "",
            location: "Camp",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/lunch"
          }
        ]
      },

      {
        id: "day3",
        nameDay: "Giorno 3",
        times: [
          {
            timeid: "1",
            time: "06:00",
            timeName: "Alba",
            timeDistination: "Mattina tranquilla e relax.",
            timeVideoSrc: "",
            location: "Camp",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/3-06-00"
          },
          {
            timeid: "2",
            time: "09:30",
            timeName: "Kubla-Ustyurt",
            timeDistination: "Villaggio remoto dell’epoca sovietica.",
            timeVideoSrc: "",
            location: "Kubla",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/3-09-30"
          },
          {
            timeid: "3",
            time: "11:00",
            timeName: "Lago Sudochye",
            timeDistination: "Birdwatching: fenicotteri e pellicani.",
            timeVideoSrc: "",
            location: "Sudochye",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/3-11-00"
          },
          {
            timeid: "4",
            time: "12:30",
            timeName: "Salina Barsakelmes",
            timeDistination: "Paesaggi simili a Salar de Uyuni.",
            timeVideoSrc: "",
            location: "Barsakelmes",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/3-12-30"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Pranzo",
            timeDistination: "Pranzo a Kungrad.",
            timeVideoSrc: "",
            location: "Kungrad",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "16:00",
            timeName: "Mizdakhan",
            timeDistination: "Complesso storico sacro.",
            timeVideoSrc: "",
            location: "Mizdakhan",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/3-16-00"
          },
          {
            timeid: "7",
            time: "18:00",
            timeName: "Ritorno a Nukus",
            timeDistination: "Fine del tour.",
            timeVideoSrc: "",
            location: "Nukus",
            locationSrc: "",
            img: "img/eco-tour-3day/daysimg/1-08-00"
          }
        ]
      }
    ],

    maps: "https://www.google.com/maps/d/u/2/embed?mid=102NWQJAItnER0bWiJ3wyJtqJl8Kv0y8&ehbc=2E312F&noprof=1",

    feedback: [
      {
        date: "",
        name: "Louisa & Kieran",
        gmail: "",
        messages:
          "Really well looked after, made sure we were warm & well fed.A beautiful place to camp and an incredible experience for a good night’s sleep.We recommend the vodka!",
        score: 5,
      },
      {
        date: "",
        name: "Sandro",
        gmail: "",
        messages:
          "Really nice hosts. Really nice place. Service was perfect.Everything was perfect and amazing experience and landscapes! :). We loved this really. A great experience, great hospitality and a warm & cozy yurt - even when it was cold outside.",
        score: 5,
      },
      {
        date: "2018-04-02",
        name: "Thomas & Camilla",
        gmail: "Sweden",
        messages:
          "En underbar afton vid Aralsjön! Gästfriheten vet inga gränser, god mat, mycket mot och excellent Karakalpakstansk vodka :) Sarsenbay är en perfekt värd/guide!",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "Frau Rainer und Markus",
        gmail: "Sweden",
        messages:
          "Sehnsüger Ausflug an den Aralsee! Super Reiseleiter und Fahrer. Alles wunderbar, wir kommen gerne wieder. Sehr eindrucksvoll hier in Karakalpakstan.",
        score: 5,
      },
      {
        date: "2018-04-08",
        name: "同海王",
        gmail: "",
        messages:
          "大家好，欢迎来到咸海。我是在此工作8年的中国人“咸海王”，每年要在此工作4-6个月，很荣幸和知名旅行公司成为邻居。如果有中国朋友要介绍朋友或者生意中的主人公，希望来咸海旅游的中国朋友请联系我，想更多了解咸海可加我微信或电话：乌兹电话: +99899 9686518 国内电: 186130543232",
        score: 5,
      },
      {
        date: "апрель 2018",
        name: "Дмитрий",
        gmail: "Москва",
        messages:
          "Огромное спасибо сотрудникам турбазы и людям за гостеприимство. Получили огромное удовольствие от общения с такими замечательными людьми. Спасибо за это открытие для нас Арал!",
        score: 5,
      },
      {
        date: "13.04.2018",
        name: "Друг из Владикавказа",
        gmail: "",
        messages:
          "Спасибо огромное за гостеприимство! Очень понравился прием и организованность лагеря. Радушие и теплое отношение всех. О киме ли ветер – тишина здесь. Нам нужно еще побывать у вас. Рассмотрели друзей, о прекрасно проведенном времени.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Анна Сергеевна Иванова",
        gmail: "",
        messages:
          "Отзыв о туре 'Нукус – Муйнак – Плато Устюрт – Аральское море': 'Этот тур оказался для меня настоящим открытием! С самого утра нас забрали из Нукуса, и началось наше путешествие по местам, которые буквально дышат историей. Кладбище кораблей в Муйнаке оставляет неизгладимое впечатление – когда-то здесь было море, а теперь на сухом дне стоят забытые корабли, что заставляет задуматься о масштабах природных изменений. Музеи в Муйнаке погружают в историю региона и трагедию Арала. Особенно запомнилась поездка через плато Устюрт – такие виды сложно описать словами. Местные каньоны, кладбище кочевников – всё это делает маршрут по-настоящему уникальным. Природа здесь потрясающая, и каждый момент хотелось запечатлеть на камеру. День завершился на берегу Аральского моря, где можно было искупаться и собирать ракушки. Юртовый лагерь на берегу – это отдельная магия. Ужин в традиционной обстановке, а затем ночь в уютной юрте под звёздами – идеальное завершение такого насыщенного дня. Большое спасибо команде за этот потрясающий опыт. Рекомендую всем, кто хочет прикоснуться к уникальной истории и природе этой области!",
        score: 5,
      },
      {
        date: "30.07.2023",
        name: "Beth W",
        gmail: "bethwison1991@gmail.com",
        messages:
          "We did not book a tour with a guide. We used the company for having the driver only to take us to the Ship Graveyard.",
        score: 5,
      },
      {
        date: "12.08.2024",
        name: "Janusz Tylus",
        gmail: "",
        messages:
          "Grupa z Polski, podróżnicy TOP TURYSTYKA Super miejscówka, niezwykła gościnność, wielogwiazdkowy camp pod gwiazdami. Było super! Bardzo miłe miejsce ♥ Astelie Eryk Kwasnica PS.Pan w agregacie WYMlATA:) Brestowice",
        score: 5,
      },

      {
        date: "",
        name: "Lisa & Alexander",
        gmail: "Liebe Grüße",
        messages:
          "Auf die Freude der Natur und die Gesellschaft der Menschen im Jurten Camp beim Mal See. Wir haben die Zeit sehr genossen, wurden sehr umsorgt, gut & korrekt informiert, und die Sonne hat uns allen das Aufstehen versüßt. Danke für alles!",
        score: 5,
      },
      {
        date: "14.04.2018",
        name: "Simon & Natasha",
        gmail: "Switzerland / Russia",
        messages:
          "Very nice camp with competent staff and lots of anecdotes! It’s sad to see to what level the Aral Sea shrunk and hope that the government starts taking action. Good Luck",
        score: 4,
      },
      {
        date: "April 15, 2018",
        name: "Marc, Jennifer,Lucas & Alexis",
        gmail: "Michigan, USA",
        messages:
          "Thank you for the great visit to the Aral Sea. The Yurt Camp was very comfortable and pleasant. Our family enjoyed the friendly atmosphere and comfortable accommodations. Thank you",
        score: 5,
      },
      {
        date: "12-16 августа 2019",
        name: "Den Garage",
        gmail: "БЕНЗИН И ГРЕЧА",
        messages:
          "Идеальный хостел для путешествующих на двух колесах и не только.Удачно расположен в центре и чуть в стороне от шумных улиц. Как только открываешь дверь, и заканчивай свой trip— всё начинает нравиться! Ковровое покрытие под капотом в комнате, выходное место пространства. В шкатках всё очень тщательно обустроено, нет ничего лишнего. В хостеле все отлично функционирует, никаких поломанных кранов и неисправных розеток… и так далее. А самое главное – это расположение администраторов и персонала.Мне не хотелось бы забыть, но не хотелось бы останавливаться с недугом в Besqala. Пожалуй, достаточно отзыв и завтрак индуский!",
        score: 5,
      },
      {
        date: "09.09.19",
        name: "Isabelle",
        gmail: "France",
        messages:
          "Super séjour à Nukus et à l’Aral Sea (impressionnant à voir). Expérience à faire : se baigner dans le lac et avoir les pieds pleins de boue. Équipe au petit soin, vraiment top ! Merci à Tazabay et à son équipe.Merci Taschkent (petit clin d’œil à mon guide K.)",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Antoine PELLERIN ",
        gmail: "",
        messages:
          "Excellent keeper Diana to his camp Elena & Vova. A magnificent piece of scenography. The beautiful desert & skies. Thanks a lot for this great moment for us.",
        score: 5,
      },
      {
        date: "28.04.2018",
        name: "Annika,Viki ",
        gmail: "Germany,Hungary",
        messages:
          "We had a fantastic stay thanks to the warm hospitality of the team – and fun despite the noisy tourist group next door!",
        score: 5,
      },
      {
        date: "11.05.2026",
        name: "Liza Raitina",
        gmail: "",
        messages: "Нам тур понравился на 10 из 10. Особенная благодарность водителю - он просто гуру вождения вне трассы. Из пожеланий по улучшению: я бы озвучила аудиогид живым голосом вместо робота. Возможно, также можно добавить для желающих более расширенный контент, особенно с учетом долгой дороги. В остальном нам все очень понравилось, спасибо вам большое за помощь и организацию.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Jill Heyde",
        gmail: "",
        messages: "We just returned from an Aral Sea trip with Rakhmet. It was very interesting. We are not comfortable with video. Would you mind sending us the questions in writing?",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Gioacchino Pagano",
        gmail: "",
        messages: "The trip was very beautiful, especially with Max as guide. You did a great choice to suggest us him.",
        score: 5,
      },
      {
        date: "20.05.2026",
        name: "Martina & Manfred",
        gmail: "",
        messages: "We had a wonderful tour to the Besqala Aral camp. We spent two nights in the camp. All things are very well organized. The food was very good and the ladies were very friendly and helpful. The yurts were comfortable and clean. Our driver Muchtar was a very good driver, always driving safely on difficult off-road routes. One suggestion: switch off the camp light for an hour at night so guests can better enjoy the stars.",
        score: 5,
      },
      {
        date: "24.05.2026",
        name: "Ola Jodyna",
        gmail: "",
        messages: "It was a wonderful, well-organized adventure. We were picked up punctually from our hotel by a friendly driver. The vehicle was exactly as promised, equipped with air conditioning and 4WD. The scenery was stunning and unforgettable. The yurts were clean and the food was delicious. The optional excursion to the edge of the plateau was absolutely worth it.",
        score: 5,
      },
      {
        date: "26.05.2026",
        name: "Alessandro",
        gmail: "",
        messages: "The tour was beautiful and very touching. Even though the car broke down, the staff quickly found an alternative solution. Our guide Azat was amazing and exceeded all expectations. Everything was perfect and we highly recommend this experience.",
        score: 5,
      },
      {
        date: "29.05.2026",
        name: "Симоне Донди",
        gmail: "",
        messages: "Не могу назвать ничего отрицательного. Отличный водитель, своевременные остановки, позволившие насладиться местами, отличная и обильная еда.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Katia",
        gmail: "",
        messages: "I loved both of my trips with Besqala. The Aral Sea is a place worth seeing and the fortresses of ancient Khorezm are unique. Drivers were knowledgeable and attentive. If I had to suggest one improvement, it would be providing a clearer schedule and more information about stop durations.",
        score: 5,
      },
      {
        date: "30.05.2026",
        name: "Sibylle Kiss",
        gmail: "",
        messages: "We had 3 great days at the Aral Sea.",
        score: 5,
      },
      {
        date: "09.06.2026",
        name: "Крейдина Алиса",
        gmail: "",
        messages: "Хотела сказать вашей организации огромное спасибо за организацию тура, все было супер! Один из лучших опытов в моей жизни.",
        score: 5,
      }
    ],
    img: [
      "img/eco-tour-3day/tourimg/40",
      "img/eco-tour-3day/tourimg/1",
      "img/eco-tour-3day/tourimg/2",
      "img/eco-tour-3day/tourimg/3",
      "img/eco-tour-3day/tourimg/4",
      "img/eco-tour-3day/tourimg/5",
      "img/eco-tour-3day/tourimg/6",
      "img/eco-tour-3day/tourimg/7",
      "img/eco-tour-3day/tourimg/8",
      "img/eco-tour-3day/tourimg/9",
      "img/eco-tour-3day/tourimg/10",
      "img/eco-tour-3day/tourimg/11",
      "img/eco-tour-3day/tourimg/12",
      "img/eco-tour-3day/tourimg/13",
      "img/eco-tour-3day/tourimg/14",
      "img/eco-tour-3day/tourimg/15",
      "img/eco-tour-3day/tourimg/16",
      "img/eco-tour-3day/tourimg/17",
      "img/eco-tour-3day/tourimg/18",
      "img/eco-tour-3day/tourimg/19",
      "img/eco-tour-3day/tourimg/20",
      "img/eco-tour-3day/tourimg/21",
      "img/eco-tour-3day/tourimg/22",
      "img/eco-tour-3day/tourimg/23",
      "img/eco-tour-3day/tourimg/24",
      "img/eco-tour-3day/tourimg/25",
      "img/eco-tour-3day/tourimg/26",
      "img/eco-tour-3day/tourimg/27",
      "img/eco-tour-3day/tourimg/28",
      "img/eco-tour-3day/tourimg/29",
      "img/eco-tour-3day/tourimg/30",
      "img/eco-tour-3day/tourimg/31",
      "img/eco-tour-3day/tourimg/32",
      "img/eco-tour-3day/tourimg/33",
      "img/eco-tour-3day/tourimg/34",
      "img/eco-tour-3day/tourimg/35",
      "img/eco-tour-3day/tourimg/36",
      "img/eco-tour-3day/tourimg/37",
      "img/eco-tour-3day/tourimg/38",
      "img/eco-tour-3day/tourimg/39",
      "img/eco-tour-3day/tourimg/41",
      "img/eco-tour-3day/tourimg/42",
      "img/eco-tour-3day/tourimg/43",
      "img/eco-tour-3day/tourimg/44",
      "img/eco-tour-3day/tourimg/45",
      "img/eco-tour-3day/tourimg/46",
      "img/eco-tour-3day/tourimg/47",
      "img/eco-tour-3day/tourimg/48",
      "img/eco-tour-3day/tourimg/49",
      "img/eco-tour-3day/tourimg/50",
      "img/eco-tour-3day/tourimg/51",
      "img/eco-tour-3day/tourimg/52"
    ],
  },
  {
    id: 19,
    price: "30",
    prices: [
      { id: 1, persons: "1", price: "90" },
      { id: 2, persons: "2", price: "90" },
      { id: 3, persons: "3", price: "90" },
      { id: 4, persons: "4", price: "185" },
    ],

    srcitinerary: "img/tourmuynak/itinerary/eng",
    maxamount: "100+",
    category: "Aral",
    category1: "",
    tourlang: "itl",

    name: "Tour di Muynak — verso le rive del Mare d'Aral prosciugato",
    dayDuration: "(1 giorno)",
    aboutTour: "La gita di un giorno in uno dei luoghi ecologici più inquietanti del mondo — il Mare d'Aral prosciugato",
    unitDay: "1",
    unitNight: "0",

    country: "4",
    startCountry: "Nukus",
    endCountry: "Nukus",

    mapstext1: "Oltre 400 km",
    mapstext2: "Stagione del tour: tutto l'anno",

    description: "Nukus – Muynak – Cimitero delle Navi – Mizdakhan – Gaur Kala – Nukus",

    inclusionOn: [
      { class: "fa fa-car", text: "Trasporto: berlina / minibus;" },
      { class: "fa fa-list-alt", text: "Acqua potabile durante il viaggio;" },
    ],

    inclusionX: [
      { class: "fa fa-language", text: "Servizi di guida;" },
      { class: "fa fa-list-alt", text: "Biglietti d’ingresso;" },
    ],

    inclusionBuy: [
      { id: 1, name: "Guida mobile", price: "10" },
      { id: 2, name: "Guida professionale", price: "60" },
    ],

    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "L'avventura inizia a Nukus",
            timeDistination: "Benvenuti in Karakalpakstan — una terra dove la steppa si estende oltre l’orizzonte e il silenzio racconta storie del passato. Vi trovate nel cuore dell’Asia Centrale, dove natura e cultura si intrecciano da secoli.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/tourmuynak/daysimg/08-30"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Muynak — ex città portuale del Mare d'Aral",
            timeDistination: "Visita al Cimitero delle Navi — uno dei simboli più iconici della regione. Le navi abbandonate nella sabbia raccontano la storia di un mare scomparso.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/7ekTCKuC6PZLKN6t7",
            img: "img/tourmuynak/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "12:30",
            timeName: "Museo di Muynak",
            timeDistination: "Visita al museo locale con esposizioni e documentari sulla storia del Mare d'Aral.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/F1sYnxeXyAqDY5qK8",
            img: "img/tourmuynak/daysimg/12-30"
          },
          {
            timeid: "4",
            time: "13:30",
            timeName: "Pranzo",
            timeDistination: "Pranzo in una guest house accogliente con cucina tradizionale.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Muynak",
            locationSrc: "https://maps.app.goo.gl/krcXFoj6BAMjUB937",
            img: "img/tourmuynak/daysimg/lunch"
          },
          {
            timeid: "5",
            time: "17:00",
            timeName: "Mizdakhan — complesso sacro",
            timeDistination: "Visita al complesso architettonico di Mizdakhan con mausolei storici.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/tourmuynak/daysimg/17-00"
          },
          {
            timeid: "6",
            time: "18:00",
            timeName: "Gaur-Kala — antico insediamento",
            timeDistination: "Visita alle rovine dell’antica città di Gaur-Kala dell’epoca zoroastriana.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/5LJrJXpi6LX7jgaK7",
            img: "img/tourmuynak/daysimg/18-00"
          },
          {
            timeid: "7",
            time: "19:00",
            timeName: "Ritorno a Nukus",
            timeDistination: "Fine del tour e ritorno in città.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/tourmuynak/daysimg/08-30"
          }
        ]
      }
    ],

    maps: "https://www.google.com/maps/d/u/2/embed?mid=1yVYOKXdz8odW3dSsUjmXwwuUJUrrWG4&ehbc=2E312F&noprof=1",

    feedback: [],

    img: [
      "img/tourmuynak/tourimg/3",
      "img/tourmuynak/tourimg/4",
      "img/tourmuynak/tourimg/10",
      "img/tourmuynak/tourimg/6",
      "img/tourmuynak/tourimg/1",
      "img/tourmuynak/tourimg/2",
      "img/tourmuynak/tourimg/5",
      "img/tourmuynak/tourimg/7",
      "img/tourmuynak/tourimg/8",
      "img/tourmuynak/tourimg/9",
      "img/tourmuynak/tourimg/11",
      "img/tourmuynak/tourimg/12",
      "img/tourmuynak/tourimg/13",
      "img/tourmuynak/tourimg/14",
      "img/tourmuynak/tourimg/15",
      "img/tourmuynak/tourimg/16",
      "img/tourmuynak/tourimg/17",
      "img/tourmuynak/tourimg/18"
    ]
  },
  {
    id: 20,
    price: "50",
    prices: [
      { id: 1, persons: "1", price: "105" },
      { id: 2, persons: "2", price: "125" },
      { id: 3, persons: "3", price: "135" },
      { id: 4, persons: "4", price: "200" },
    ],

    srcitinerary: "img/ekskursiya-po-nukus/itinerary/eng",
    maxamount: "100+",
    category: "Nukus",
    category1: "",
    tourlang: "itl",

    name: "Tour della città di Nukus",
    dayDuration: "(1 giorno)",
    aboutTour: "Quello che svela Nukus attraverso i suoi artisti, artigiani e la collezione di fama mondiale che nessuno si aspettava di trovare qui",
    unitDay: "1",
    unitNight: "0",

    country: "5",
    startCountry: "Nukus",
    endCountry: "Nukus",

    mapstext1: "Oltre 50 km",
    mapstext2: "Stagione del tour: tutto l'anno",

    description: "Nukus – Museo Savitsky – Casa-museo di Bazarbai Serekeev – Casa-museo di Bakhtiyar Serekeev – Laboratorio di Bibisary Kunnazarova – Laboratorio di produzione di kurpacha",

    inclusionOn: [
      { class: "fa fa-car", text: "Trasporto: berlina / minibus;" },
      { class: "fa fa-list-alt", text: "Biglietti d’ingresso;" },
      { class: "fa fa-list-alt", text: "Acqua potabile durante il viaggio;" },
    ],

    inclusionX: [
      { class: "fa fa-language", text: "Servizi di guida;" },
    ],

    inclusionBuy: [
      { id: 1, name: "Guida mobile", price: "10" },
      { id: 2, name: "Guida professionale", price: "60" },
    ],

    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Museo Savitsky — il “Louvre nel deserto”",
            timeDistination: "Il viaggio inizia a Nukus con la visita al Museo Statale d’Arte del Karakalpakstan I. V. Savitsky — una delle collezioni artistiche più straordinarie al mondo. Il museo ospita una raccolta unica dell’avanguardia russa degli anni 1920–1930, dove ogni opera riflette un’epoca di rivoluzioni artistiche e culturali.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ekskursiya-po-nukus/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "12:00",
            timeName: "Visita all’artista Serekeev",
            timeDistination: "Visita alla casa-museo dell’artista onorato Bazarbai Serekeev. Questo spazio accogliente conserva le opere del maestro e riflette l’atmosfera della sua vita e del suo percorso creativo.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/Yy5yVAQEotwu6sNW6",
            img: "img/ekskursiya-po-nukus/daysimg/12-00"
          },
          {
            timeid: "3",
            time: "13:30",
            timeName: "Pranzo",
            timeDistination: "Pranzo in un caffè locale.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "",
            img: "img/ekskursiya-po-nukus/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "15:00",
            timeName: "Arte contemporanea di Serekeev",
            timeDistination: "Il tour continua con la visita allo studio dell’artista contemporaneo Bakhtiyar Serekeev. Le opere presentano una visione moderna mantenendo la tradizione artistica familiare.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/AywY8Lk9ARib2Sg86",
            img: "img/ekskursiya-po-nukus/daysimg/15-00"
          },
          {
            timeid: "5",
            time: "15:45",
            timeName: "Rinascita delle tradizioni: tessuti karakalpaki",
            timeDistination: "Visita al laboratorio di Bibisary Kunnazarova, dove viene preservata e sviluppata la tradizione della tessitura dei tappeti karakalpaki.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/mE6tf9JYtcf44dWW9",
            img: "img/ekskursiya-po-nukus/daysimg/15-45"
          },
          {
            timeid: "6",
            time: "16:30",
            timeName: "Coperte tradizionali Kurpacha",
            timeDistination: "Visita al laboratorio dell’artigiana Damekhan, specializzata nella produzione di coperte tradizionali kurpacha utilizzate nella vita quotidiana e nelle yurte.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/gg4pCXEFCjybdjUbA",
            img: "img/ekskursiya-po-nukus/daysimg/16-30"
          }
        ]
      }
    ],

    maps: "https://www.google.com/maps/d/u/2/embed?mid=1_-shHter2HdI5uZ_6BCow8G2_vyNMVU&ehbc=2E312F&noprof=1",

    feedback: [],

    img: [
      "img/ekskursiya-po-nukus/tourimg/7",
      "img/ekskursiya-po-nukus/tourimg/1",
      "img/ekskursiya-po-nukus/tourimg/2",
      "img/ekskursiya-po-nukus/tourimg/3",
      "img/ekskursiya-po-nukus/tourimg/4",
      "img/ekskursiya-po-nukus/tourimg/5",
      "img/ekskursiya-po-nukus/tourimg/6",
      "img/ekskursiya-po-nukus/tourimg/8",
      "img/ekskursiya-po-nukus/tourimg/9",
      "img/ekskursiya-po-nukus/tourimg/10",
      "img/ekskursiya-po-nukus/tourimg/11",
      "img/ekskursiya-po-nukus/tourimg/12",
      "img/ekskursiya-po-nukus/tourimg/13",
      "img/ekskursiya-po-nukus/tourimg/14",
      "img/ekskursiya-po-nukus/tourimg/15",
      "img/ekskursiya-po-nukus/tourimg/16",
      "img/ekskursiya-po-nukus/tourimg/17"
    ]
  },
  {
    id: 21,
    price: "30",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "90"
      },
      {
        id: 2,
        persons: "2",
        price: "90"
      },
      {
        id: 3,
        persons: "3",
        price: "90"
      },
      {
        id: 4,
        persons: "4",
        price: "185"
      },
    ],
    srcitinerary: "img/citiesofalostcivilization/itinerary/eng",
    maxamount: "100+",
    category: "Khiva",
    category1: "",
    tourlang: "itl",
    name: "Città di una civiltà perduta",
    dayDuration: "(1 giorno)",
    aboutTour: "Quello che svela fortezze dimenticate nel deserto e il museo d'arte più sorprendente del mondo",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Nukus",
    endCountry: "Khiva",
    mapstext1: "Oltre 400 km",
    mapstext2: "Stagione del tour: tutto l'anno",
    description: "Nukus - Museo Savitsky - Chilpik - Kyzyl Kala - Toprak Kala - Ayaz Kala - Khiva",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Trasporto: berlina / minibus;"
      },
      {
        class: "fa fa-list-alt",
        text: "Acqua potabile durante il viaggio;"
      },
    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Servizi di guida;"
      },
      {
        class: "fa fa-list-alt",
        text: "Biglietti d'ingresso;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Guida mobile",
        price: "10"
      },
      {
        id: 2,
        name: "Guida professionale",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Museo Savitsky — il “Louvre nel Deserto”",
            timeDistination: "Il viaggio inizia a Nukus con una visita al Museo Statale d'Arte del Karakalpakstan I. V. Savitsky — una delle collezioni artistiche più straordinarie al mondo. Il museo ospita una raccolta unica di avanguardia russa degli anni 1920–1930, in cui ogni opera riflette un'epoca di rivoluzioni artistiche e culturali. Non è un caso che questo luogo venga chiamato il “Louvre nel Deserto” — un fenomeno culturale di livello mondiale nato lontano dai tradizionali centri culturali.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/citiesofalostcivilization/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Chilpik — la Torre del Silenzio",
            timeDistination: "Il percorso prosegue verso Chilpik (I secolo d.C.), uno dei siti principali associati alla cultura zoroastriana. Qui vedrete una dakhma conosciuta come la “Torre del Silenzio”, da cui si aprono viste panoramiche sul fiume Amu Darya. L'ambiente circostante è avvolto da un'atmosfera di antichi rituali e mistero, che permette di immaginare i sistemi di credenze di epoche lontane.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chilpik",
            locationSrc: "https://maps.app.goo.gl/MRatFvGUaGni2GKu6",
            img: "img/citiesofalostcivilization/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "12:30",
            timeName: "Kyzyl-Kala — la Fortezza Rossa",
            timeDistination: "Visiterete Kyzyl-Kala (I–IV–VII secolo d.C.), una fortezza difensiva che faceva parte del sistema di fortificazioni del Khorezm. Questo sito offre una visione delle tecniche architettoniche antiche e trasmette la scala della storia conservata nelle sue imponenti mura e strutture.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "https://maps.app.goo.gl/Y77s9RPuHN7aEbbU7",
            img: "img/citiesofalostcivilization/daysimg/12-30"
          },
          {
            timeid: "4",
            time: "13:30",
            timeName: "Toprak-Kala — il palazzo dell'Antico Khorezm",
            timeDistination: "Visita a Toprak-Kala (“La Fortezza di Argilla”), risalente al I–IV secolo d.C., un tempo residenza reale dei re dell'Antico Khorezm durante il periodo classico. Le mura conservate e la disposizione del complesso permettono di percepire l'importanza e la portata degli eventi che hanno segnato la lunga storia della regione.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "https://maps.app.goo.gl/Jm83XKvVTawkEmHm6",
            img: "img/citiesofalostcivilization/daysimg/13-30"
          },
          {
            timeid: "5",
            time: "14:30",
            timeName: "Pranzo",
            timeDistination: "Pranzo in un caffè locale.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "",
            img: "img/citiesofalostcivilization/daysimg/lunch"
          },
          {
            timeid: "6",
            time: "15:30",
            timeName: "Ayaz-Kala — guardiana dell'oasi",
            timeDistination: "Un incontro con l'imponente complesso di Ayaz-Kala — la più grande fortezza dell'Antico Khorezm, risalente al II–VII secolo d.C. Questa possente struttura difensiva proteggeva un tempo l'oasi dalle incursioni dei nomadi. Dalla sommità della fortezza si aprono ampie vedute panoramiche sulle sabbie del deserto del Kyzylkum, mentre le mura rimaste conservano l'eredità dell'epoca kushana. Lasciando questo luogo, porterete con voi una forte sensazione della grandezza e della portata di un'antica civiltà.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ellikqala",
            locationSrc: "https://maps.app.goo.gl/maXUteHR9nYHkZpx7",
            img: "img/citiesofalostcivilization/daysimg/15-30"
          },
          {
            timeid: "7",
            time: "18:30",
            timeName: "Arrivo a Khiva",
            timeDistination: "Arrivo a Khiva. L'ultima parte del percorso conclude un viaggio ricco e coinvolgente attraverso le antiche terre del Khorezm.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khiva",
            locationSrc: "https://maps.app.goo.gl/yHVJvh7J1roERuheA",
            img: "img/citiesofalostcivilization/daysimg/18-30"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1nXCg7-tm5tWvLWGcX7vdZ11nT16d8b8&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/citiesofalostcivilization/tourimg/1",
      "img/citiesofalostcivilization/tourimg/2",
      "img/citiesofalostcivilization/tourimg/3",
      "img/citiesofalostcivilization/tourimg/4",
      "img/citiesofalostcivilization/tourimg/5",
      "img/citiesofalostcivilization/tourimg/6",
      "img/citiesofalostcivilization/tourimg/7",
      "img/citiesofalostcivilization/tourimg/8",
      "img/citiesofalostcivilization/tourimg/9",
      "img/citiesofalostcivilization/tourimg/10",
      "img/citiesofalostcivilization/tourimg/11",
      "img/citiesofalostcivilization/tourimg/12",
      "img/citiesofalostcivilization/tourimg/13",
      "img/citiesofalostcivilization/tourimg/14",
    ],
  },
  {
    id: 22,
    price: "123,3",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "220"
      },
      {
        id: 2,
        persons: "2",
        price: "295"
      },
      {
        id: 3,
        persons: "3",
        price: "370"
      },
      {
        id: 4,
        persons: "4",
        price: "580"
      },

    ],
    srcitinerary: "img/inthefootstepsofancientcivilizations/itinerary/eng",
    maxamount: "100+",
    category: "Khiva",
    category1: "",
    tourlang: "itl",
    name: "Sulle Orme delle Antiche Civiltà",
    dayDuration: "(2 giorni e 1 notte)",
    aboutTour: "",
    unitDay: "2",
    unitNight: "1",
    country: "9",
    startCountry: "Nukus",
    endCountry: "Khiva",
    mapstext1: "Oltre 270 km",
    mapstext2: "Stagione del tour: tutto l'anno",
    description: "Nukus – Museo Savitsky – Chilpik – Jampyk Kala – Baday Tugay – Ayaz Kala – Jambas Kala – Kyzyl Kala – Toprak Kala – Big Guldursun – Khiva",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Trasporto: berlina / minibus;"
      },
      {
        class: "fa fa-bed",
        text: "Alloggio: pernottamento nel campo di yurte di Ayaz Kala;"
      },
      {
        class: "fa fa-cutlery",
        text: "Pasti: colazione e cena"
      },
      {
        class: "fa fa-list-alt",
        text: "Acqua potabile durante il viaggio;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Servizi di guida;"
      },
      {
        class: "fa fa-list-alt",
        text: "Biglietti d'ingresso;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Guida mobile",
        price: "10"
      },
      {
        id: 2,
        name: "Guida professionale",
        price: "120"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Museo Savitsky — il “Louvre nel Deserto”",
            timeDistination: "Il viaggio inizia a Nukus con una visita al Museo Statale d'Arte del Karakalpakstan I. V. Savitsky — una delle collezioni artistiche più straordinarie al mondo. Il museo ospita una raccolta unica di avanguardia russa degli anni 1920–1930, in cui ogni opera riflette un'epoca di rivoluzioni artistiche e culturali. Non è un caso che questo luogo venga chiamato il “Louvre nel Deserto” — un fenomeno culturale di livello mondiale nato lontano dai tradizionali centri culturali.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-09-00"
          },
          {
            timeid: "2",
            time: "12:00",
            timeName: "Chilpik — la Torre del Silenzio",
            timeDistination: "Il percorso prosegue verso Chilpik (I secolo d.C.), uno dei siti principali associati alla cultura zoroastriana. Qui vedrete la dakhma, conosciuta come la Torre del Silenzio, che si innalza sopra il paesaggio e offre viste panoramiche sul fiume Amu Darya. L'atmosfera è piena del senso di antichi rituali e mistero, permettendo ai visitatori di immergersi nel mondo spirituale di epoche lontane.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chilpik",
            locationSrc: "https://maps.app.goo.gl/MRatFvGUaGni2GKu6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-12-00"
          },
          {
            timeid: "3",
            time: "13:30",
            timeName: "Pranzo",
            timeDistination: "Pranzo in un caffè locale.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Local Cafe",
            locationSrc: "",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:30",
            timeName: "Jampyk-Kala — una fortezza di epoche diverse",
            timeDistination: "Visita alla fortezza di Jampyk-Kala (IV–I secolo a.C., X–XII secolo d.C.), uno dei siti archeologici meno conosciuti della regione. La fortezza offre viste pittoresche sul paesaggio circostante e ottime opportunità per fotografie espressive sullo sfondo di antiche mura e forme naturali.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Jampyk-Kala",
            locationSrc: "https://maps.app.goo.gl/quoShEJbbXBy5T1W8",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-14-30"
          },
          {
            timeid: "5",
            time: "16:30",
            timeName: "Riserva Naturale Baday-Tugay",
            timeDistination: "Arrivo alla Riserva Naturale Nazionale di Baday-Tugay — un'area naturale unica dove cervi di Bukhara, saighe, volpi e altri animali rari inclusi nel Libro Rosso dell'Uzbekistan vivono nel loro habitat naturale. Questa è una rara opportunità per conoscere la fauna della regione lontano dai normali itinerari turistici.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Baday-Tugay",
            locationSrc: "https://maps.app.goo.gl/Q1ebjmqLuXNkb4vy9",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-16-30"
          },
          {
            timeid: "6",
            time: "19:00",
            timeName: "Sera alle mura di Ayaz-Kala",
            timeDistination: "Arrivo al campo di yurte di Ayaz-Kala. La serata include una cena tradizionale nazionale, seguita dall’osservazione delle stelle e dal relax nella tranquilla atmosfera della vita nomade.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ayaz-Kala",
            locationSrc: "https://maps.app.goo.gl/fTm3C7rHpUEEQtVK6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/1-19-00"
          },

        ],
      },
      {
        id: "day2",
        nameDay: "Giorno 2",
        times: [
          {
            timeid: "1",
            time: "07:00",
            timeName: "Colazione",
            timeDistination: "Colazione al campo di yurte.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ayaz-Kala",
            locationSrc: "https://maps.app.goo.gl/fTm3C7rHpUEEQtVK6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "2",
            time: "08:30",
            timeName: "Ayaz-Kala — guardiana dell'oasi",
            timeDistination: "Tempo libero vicino al complesso fortificato di Ayaz-Kala — il più grande insieme di fortezze dell'Antico Khorezm, risalente al II–VII secolo d.C. Questo potente complesso difensivo proteggeva un tempo l'oasi dalle incursioni dei nomadi. Dalla sommità della fortezza si aprono panorami sul deserto del Kyzylkum, mentre le mura conservate portano l'eredità dell'Impero Kushan. Lasciando questo luogo, porterete con voi una forte sensazione della grandezza e della portata di un'antica civiltà.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Ayaz-Kala",
            locationSrc: "https://maps.app.goo.gl/vN4XGyJ64KSR9e3n7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-08-30"
          },
          {
            timeid: "3",
            time: "10:30",
            timeName: "Jambas-Kala — fortezza del periodo Kangju",
            timeDistination: "Visita alla fortezza di Jambas-Kala (IV secolo a.C. – I secolo d.C.), uno dei monumenti più importanti del periodo Kangju. Esplorerete possenti mura difensive che rimangono simbolo della forza e dell'organizzazione dell'antica società.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Jambas-Kala",
            locationSrc: "https://maps.app.goo.gl/VxhcJHq5dF3FF94e8",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-10-30"
          },
          {
            timeid: "4",
            time: "11:30",
            timeName: "Kyzyl-Kala — la Fortezza Rossa",
            timeDistination: "Visita alla fortezza di Kyzyl-Kala (I–IV–VII secolo d.C.), una struttura difensiva che faceva parte della catena di fortificazioni del Khorezm. Qui potrete osservare le caratteristiche dell'architettura antica e percepire la scala della storia conservata nelle sue potenti mura e forme.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Kyzyl-Kala",
            locationSrc: "https://maps.app.goo.gl/Y77s9RPuHN7aEbbU7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-11-30"
          },
          {
            timeid: "5",
            time: "12:30",
            timeName: "Toprak-Kala — palazzo dell'Antico Khorezm",
            timeDistination: "Visita a Toprak-Kala (“Fortezza di Argilla”, I–IV secolo d.C.) — l'antica residenza reale dei re dell'Antico Khorezm durante il periodo classico. Le mura e la pianta conservate permettono di percepire l'importanza e la portata degli eventi storici che hanno plasmato la regione nel corso dei secoli.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Toprak-Kala",
            locationSrc: "https://maps.app.goo.gl/Jm83XKvVTawkEmHm6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-12-30"
          },
          {
            timeid: "6",
            time: "13:00",
            timeName: "Pranzo",
            timeDistination: "Pranzo in un caffè locale.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Local cafe",
            locationSrc: "",
            img: "img/inthefootstepsofancientcivilizations/daysimg/lunch"
          },
          {
            timeid: "7",
            time: "16:00",
            timeName: "Big Guldursun — la grandezza delle antiche mura del Khorezm",
            timeDistination: "Sosta alla fortezza di Big Guldursun, uno dei complessi difensivi più impressionanti e monumentali della regione. Le sue mura massicce e le grandiose rovine trasmettono vividamente la potenza e la grandezza dell'antica civiltà che esisteva qui migliaia di anni fa.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Guldursun",
            locationSrc: "https://maps.app.goo.gl/eUjHtrjFv6Qv6Bzm6",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-16-00"
          },
          {
            timeid: "8",
            time: "19:00",
            timeName: "Arrivo a Khiva",
            timeDistination: "Arrivo a Khiva. Il punto finale del percorso conclude un viaggio intenso e coinvolgente attraverso le antiche terre del Khorezm.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khiva",
            locationSrc: "https://maps.app.goo.gl/maXUteHR9nYHkZpx7",
            img: "img/inthefootstepsofancientcivilizations/daysimg/2-19-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=10S879HNnUhYm-tyECyPNL4gVo9oMTRE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/inthefootstepsofancientcivilizations/tourimg/2",
      "img/inthefootstepsofancientcivilizations/tourimg/1",
      "img/inthefootstepsofancientcivilizations/tourimg/3",
      "img/inthefootstepsofancientcivilizations/tourimg/4",
      "img/inthefootstepsofancientcivilizations/tourimg/5",
      "img/inthefootstepsofancientcivilizations/tourimg/6",
      "img/inthefootstepsofancientcivilizations/tourimg/7",
      "img/inthefootstepsofancientcivilizations/tourimg/8",
      "img/inthefootstepsofancientcivilizations/tourimg/9",
      "img/inthefootstepsofancientcivilizations/tourimg/10",
      "img/inthefootstepsofancientcivilizations/tourimg/11",
      "img/inthefootstepsofancientcivilizations/tourimg/12",
      "img/inthefootstepsofancientcivilizations/tourimg/13",
      "img/inthefootstepsofancientcivilizations/tourimg/14",
      "img/inthefootstepsofancientcivilizations/tourimg/15",
      "img/inthefootstepsofancientcivilizations/tourimg/16",
      "img/inthefootstepsofancientcivilizations/tourimg/17",
      "img/inthefootstepsofancientcivilizations/tourimg/18",
      "img/inthefootstepsofancientcivilizations/tourimg/19",
      "img/inthefootstepsofancientcivilizations/tourimg/20",
      "img/inthefootstepsofancientcivilizations/tourimg/21",
    ],
  },
  {
    id: 23,
    price: "60",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "60"
      },
      {
        id: 2,
        persons: "2",
        price: "60"
      },
      {
        id: 3,
        persons: "3",
        price: "60"
      },
      {
        id: 4,
        persons: "4",
        price: "110"
      },
    ],
    srcitinerary: "img/tourofnukusandtheancientmizdakhannecropolis/itinerary/eng",
    maxamount: "100+",
    category: "Nukus",
    category1: "",
    tourlang: "itl",
    name: "Tour di Nukus e dell’Antica Necropoli di Mizdakhan",
    dayDuration: "(1 giorno)",
    aboutTour: "Quello che ti guida attraverso 2.000 anni di storia — dai capolavori dell'avanguardia a un antico necropoli nel deserto",
    unitDay: "1",
    unitNight: "0",
    country: "4",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Oltre 50 km",
    mapstext2: "Stagione del tour: tutto l'anno",
    description: "Nukus – Museo Savitsky – Museo Statale di Storia e Cultura della Repubblica del Karakalpakstan – Necropoli di Mizdakhan – Gaur-Kala – Nukus",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Trasporto: berlina / minibus;"
      },
      {
        class: "fa fa-list-alt",
        text: "Acqua potabile durante il viaggio;"
      },


    ],
    inclusionX: [
      {
        class: "fa fa-language",
        text: "Servizi di guida;"
      },
      {
        class: "fa fa-list-alt",
        text: "Biglietti d'ingresso;"
      },
    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Guida mobile",
        price: "10"
      },
      {
        id: 2,
        name: "Guida professionale",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "Museo Savitsky — il “Louvre nel Deserto”",
            timeDistination: "Il viaggio inizia a Nukus con una visita al Museo Statale d'Arte del Karakalpakstan I. V. Savitsky — una delle collezioni artistiche più straordinarie al mondo. Il museo ospita una raccolta unica di avanguardia russa degli anni 1920–1930, in cui ogni opera riflette un'epoca di rivoluzioni artistiche e culturali. Non è un caso che questo luogo venga chiamato il “Louvre nel Deserto” — un fenomeno culturale di livello mondiale nato lontano dai tradizionali centri culturali.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/VtrV6RN14CGbHB9T7",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "11:30",
            timeName: "Storia e Cultura del Karakalpakstan",
            timeDistination: "Il tour continua al Museo Statale di Storia e Cultura della Repubblica del Karakalpakstan. Qui vi immergerete nella storia secolare della regione ed esplorerete reperti archeologici, etnografici e storici che rivelano gradualmente il passato di queste terre e offrono una comprensione completa della cultura karakalpaka.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/spvK6zZkb6ZfhfZM9",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/11-30"
          },
          {
            timeid: "3",
            time: "13:00",
            timeName: "Pranzo",
            timeDistination: "Pranzo in un caffè locale.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/lunch"
          },
          {
            timeid: "4",
            time: "14:30",
            timeName: "Mizdakhan — complesso sacro",
            timeDistination: "Nella città di Khojeli, ci fermiamo al complesso architettonico di Mizdakhan — uno dei siti storici più significativi della regione. Qui vedrete i mausolei di Nazlumkhansulu (XII–XIV secolo), Khalifa Erezhep (XII secolo) e Shamun Nabi (XIX secolo), ognuno dei quali riflette una fase distinta della storia di queste terre.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/LLqDnaYLnMAU24cb9",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/14-30"
          },
          {
            timeid: "5",
            time: "16:00",
            timeName: "Insediamento antico di Gaur-Kala",
            timeDistination: "Un altro punto forte è la visita alle rovine della fortezza di Gaur-Kala — un antico insediamento risalente all'epoca dello zoroastrismo (VI secolo a.C. – IX secolo d.C.). Questi resti in pietra aggiungono una profonda dimensione temporale al viaggio e illustrano chiaramente la storia stratificata della regione.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Khodjeli",
            locationSrc: "https://maps.app.goo.gl/5LJrJXpi6LX7jgaK7",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/16-00"
          },
          {
            timeid: "6",
            time: "17:30",
            timeName: "Ritorno a Nukus",
            timeDistination: "Ritorno a Nukus ricchi di impressioni vivide e nuove conoscenze. Fine del programma.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/hKSoS5wJYHi81A5s5",
            img: "img/tourofnukusandtheancientmizdakhannecropolis/daysimg/09-00"
          },

        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1-Adi-b_kjA3HJ4Rt14YW6i2ZZ5OPglE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/15",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/1",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/2",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/3",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/4",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/5",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/6",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/7",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/8",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/9",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/10",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/11",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/12",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/13",
      "img/tourofnukusandtheancientmizdakhannecropolis/tourimg/14",
    ],
  },
  {
    id: 24,
    price: "81,6",
    prices: [
      {
        id: 1,
        persons: "1",
        price: "180"
      },
      {
        id: 2,
        persons: "2",
        price: "225"
      },
      {
        id: 3,
        persons: "3",
        price: "245"
      },
      {
        id: 4,
        persons: "4",
        price: "365"
      },
    ],
    srcitinerary: "img/ethnodayinchimbay/itinerary/eng",
    maxamount: "100+",
    category: "Chimbay",
    category1: "",
    tourlang: "itl",
    name: "Giornata Etno a Chimbay",
    dayDuration: "(1 giorno)",
    aboutTour: "Quello che dà vita all'artigianato karakalpako — dalla costruzione delle yurte alle kurpacha cucite a mano",
    unitDay: "1",
    unitNight: "0",
    country: "7",
    startCountry: "Nukus",
    endCountry: "Nukus",
    mapstext1: "Oltre 150 km",
    mapstext2: "Stagione del tour: tutto l'anno",
    description: "Nukus – Laboratorio di costruzione della yurta – Bazar di Chimbay – Casa-museo dello scultore – Villaggio Ornek – Laboratorio di Bibisary Kunnazarova – Laboratorio di produzione dei kurpacha",
    inclusionOn: [
      {
        class: "fa fa-car",
        text: "Trasporto: berlina / minibus;"
      },
      {
        class: "fa fa-cutlery",
        text: "Pasti: pranzo;"
      },
      {
        class: "fa fa-cutlery",
        text: "Masterclass;"
      },
      {
        class: "fa fa-language",
        text: "Servizi di guida;"
      },
      {
        class: "fa fa-list-alt",
        text: "Biglietti d'ingresso;"
      },
      {
        class: "fa fa-list-alt",
        text: "Acqua potabile durante il viaggio;"
      },


    ],
    inclusionX: [

    ],
    inclusionBuy: [
      {
        id: 1,
        name: "Guida mobile",
        price: "10"
      },
      {
        id: 2,
        name: "Guida professionale",
        price: "60"
      },

    ],
    day: [
      {
        id: "day1",
        nameDay: "Giorno 1",
        times: [
          {
            timeid: "1",
            time: "09:00",
            timeName: "L’avventura inizia a Nukus",
            timeDistination: "Benvenuti in Karakalpakstan — una terra dove la steppa si estende oltre l’orizzonte, dove ogni collina sussurra storie del passato e dove il silenzio parla più forte delle parole. Vi trovate nel cuore dell’Asia Centrale, un luogo in cui natura e cultura si sono intrecciate per secoli creando un mondo unico.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ethnodayinchimbay/daysimg/09-00"
          },
          {
            timeid: "2",
            time: "10:00",
            timeName: "Come nasce una yurta karakalpaka",
            timeDistination: "Arrivo a Chimbay e visita ai laboratori degli artigiani della yurta. Qui scoprirete le tecnologie uniche della costruzione della yurta karakalpaka. I maestri mostreranno la produzione artigianale degli elementi principali — terme, uyq, kerege, shanyrak — utilizzando strumenti e tecniche tradizionali tramandati da secoli.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/MNSkE5muRHpEkG149",
            img: "img/ethnodayinchimbay/daysimg/10-00"
          },

          {
            timeid: "3",
            time: "11:00",
            timeName: "Bazar di Chimbay — il cuore della vita locale",
            timeDistination: "Visiterete il bazar di Chimbay, uno dei mercati più colorati del Karakalpakstan. Qui vedrete frutta fresca, verdure, spezie, tessuti tradizionali e gioielli artigianali. Avrete anche l’opportunità di assaggiare piatti nazionali e prodotti locali come bevande lattiero-casearie fermentate, izhan, shelpek, takan, kaunkak, ubi mayol (burro chiarificato) e molto altro.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/PfXj7uRptEjL1QYp7",
            img: "img/ethnodayinchimbay/daysimg/11-00"
          },
          {
            timeid: "4",
            time: "11:30",
            timeName: "Scultura e legno: il laboratorio dell’artista",
            timeDistination: "Visita alla casa-museo del famoso artista e scultore Daribay Tadjimuratov. Qui vedrete opere dedicate alla vita nomade, alla steppa e alle immagini femminili tradizionali, oltre a una collezione unica di sculture in legno. L’atmosfera creativa è intensa e permette di sentire il processo artistico dall’interno.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/fXgaxTpzGh8KfjwZ7",
            img: "img/ethnodayinchimbay/daysimg/11-30"
          },
          {
            timeid: "5",
            time: "12:30",
            timeName: "Partenza per il villaggio Ornek",
            timeDistination: "Il percorso attraversa paesaggi rurali dove è possibile osservare la vita autentica dei villaggi del Karakalpakstan.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/12-30"
          },
          {
            timeid: "6",
            time: "13:15",
            timeName: "Arrivo a Ornek. Pranzo in famiglia locale",
            timeDistination: "Accoglienza calorosa in una casa locale con piatti tradizionali: partecipazione alla preparazione di zhugara gurtik o beshbarmak, conoscenza delle tradizioni di ospitalità e degustazione di prodotti freschi come sary may e katyk.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/13-15"
          },
          {
            timeid: "7",
            time: "14:30",
            timeName: "Panificazione tradizionale karakalpaka",
            timeDistination: "Parteciperete alla preparazione di baursak, pane e zagary. Le donne locali mostreranno le tecniche tradizionali di preparazione tramandate di generazione in generazione.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/x8AEQDAceTY3hAqn8",
            img: "img/ethnodayinchimbay/daysimg/14-30"
          },
          {
            timeid: "8",
            time: "17:00",
            timeName: "Rinascita delle tradizioni: tessuti karakalpaki",
            timeDistination: "Visita al laboratorio di Bibisary Kunnazarova, dove viene preservata l’arte tradizionale della tessitura dei tappeti karakalpaki, oggi integrata nel design moderno delle yurte.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/mE6tf9JYtcf44dWW9",
            img: "img/ethnodayinchimbay/daysimg/17-00"
          },
          {
            timeid: "9",
            time: "17:45",
            timeName: "Kurpacha tradizionali",
            timeDistination: "Visita al laboratorio dell’artigiana Damekhan, specializzata nella produzione di kurpacha tradizionali utilizzati nella vita quotidiana e nelle yurte.",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Chimbay",
            locationSrc: "https://maps.app.goo.gl/gg4pCXEFCjybdjUbA",
            img: "img/ethnodayinchimbay/daysimg/17-45"
          },
          {
            timeid: "10",
            time: "18:30",
            timeName: "Fine del tour",
            timeDistination: "",
            timeVideoSrc: "https://www.youtube.com/embed/rPoLncM2Lnc?si=IIM3IAsNxDSLnVsF",
            location: "Nukus",
            locationSrc: "https://maps.app.goo.gl/ppwpcgUTYMBz8vm7A",
            img: "img/ethnodayinchimbay/daysimg/09-00"
          },
        ],
      },
    ],
    maps: "https://www.google.com/maps/d/u/2/embed?mid=1UYlw0wT8BRzC5Dheo1nnwSgx0O13zCE&ehbc=2E312F&noprof=1",
    feedback: [

    ],
    img: [
      "img/ethnodayinchimbay/tourimg/10",
      "img/ethnodayinchimbay/tourimg/1",
      "img/ethnodayinchimbay/tourimg/2",
      "img/ethnodayinchimbay/tourimg/3",
      "img/ethnodayinchimbay/tourimg/4",
      "img/ethnodayinchimbay/tourimg/5",
      "img/ethnodayinchimbay/tourimg/6",
      "img/ethnodayinchimbay/tourimg/7",
      "img/ethnodayinchimbay/tourimg/8",
      "img/ethnodayinchimbay/tourimg/9",
      "img/ethnodayinchimbay/tourimg/11",
      "img/ethnodayinchimbay/tourimg/12",
      "img/ethnodayinchimbay/tourimg/13",
      "img/ethnodayinchimbay/tourimg/14",
      "img/ethnodayinchimbay/tourimg/15",
    ],
  }
]
export default tours;